import { 
    Mod,
    ModDatabase, 
    ContentType, 
    IdolSize 
  } from '../types/mods';

export const mods: Record<string, Mod> = {
  'prefix_minor_additional_abyss_chance': {
    id: 1,
    tradeId: 'explicit.stat_4278144676',
    description: 'Your Maps have +(15–25)% chance to contain an Abyss',
    range: [15, 25],
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'prefix_minor_increased_abyss_chance': {
    id: 2,
    tradeId: 'explicit.stat_4111037980',
    description: 'Your Maps have (80–100)% increased chance to contain an Abyss',
    range: [80, 100],
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'suffix_minor_increased_abyss_jewel_chance_from_trove': {
    id: 3,
    tradeId: 'explicit.stat_1553039081',
    description: 'Abyssal Troves and Stygian Spires in your Maps have (15–25)% increased chance to contain or drop an Abyss Jewel',
    range: [15, 25],
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_abyss_trove_rare_socket_chance': {
    id: 4,
    tradeId: 'explicit.stat_2609011894',
    description: 'Abyssal Troves and Stygian Spires in your Maps have (6–10)% chance to drop a Rare Item with an Abyssal Socket',
    range: [6, 10],
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_abyss_trove_item_rarity': {
    id: 5,
    tradeId: 'explicit.stat_2786105132',
    description: '(300–350)% increased Rarity of Items Dropped by Abyssal Troves and Stygian Spires in your Maps',
    range: [300, 350],
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_incursion_pack_size': {
    id: 6,
    tradeId: 'explicit.stat_2490898366',
    description: 'Incursions in your Maps have (4–6)% increased Pack Size',
    range: [4, 6],
    contentType: ContentType.INCURSION,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'prefix_minor_additional_incursion_chance': {
    id: 7,
    tradeId: 'explicit.stat_2709296039',
    description: 'Your Maps have +(15–25)% chance to contain Alva',
    range: [15, 25],
    contentType: ContentType.INCURSION,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'prefix_minor_increased_incursion_chance': {
    id: 8,
    tradeId: 'explicit.stat_3629418990',
    description: 'Your Maps have (80–100)% increased chance to contain Alva',
    range: [80, 100],
    contentType: ContentType.INCURSION,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'prefix_minor_anarchy_additional_exiles_chance': {
    id: 9,
    tradeId: 'explicit.stat_1123357133',
    description: 'Your Maps have a (15–25)% chance to contain an additional Rogue Exile',
    range: [15, 25],
    contentType: ContentType.ROGUE_EXILES,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'prefix_minor_anarchy_exile_chance': {
    id: 10,
    tradeId: 'explicit.stat_2974922599',
    description: 'Your Maps have +(7–10)% chance to contain a Rogue Exile',
    range: [7, 10],
    contentType: ContentType.ROGUE_EXILES,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'prefix_minor_anarchy_map_boss_exile_guards_chance': {
    id: 11,
    tradeId: 'explicit.stat_472880157',
    description: 'Map Bosses have (6–10)% chance to be accompanied by two Rogue Exile Bodyguards',
    range: [6, 10],
    contentType: ContentType.ROGUE_EXILES,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'prefix_minor_anarchy_map_boss_two_exile_chance': {
    id: 12,
    tradeId: 'explicit.stat_3408085256',
    description: 'Map Bosses have (2–3)% chance to be accompanied by two Rogue Exiles',
    range: [2, 3],
    contentType: ContentType.ROGUE_EXILES,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'suffix_minor_beastiary_duplicate_captured_beasts_chance': {
    id: 13,
    tradeId: 'explicit.stat_2836003955',
    description: '(5–10)% chance to create a copy of Beasts Captured in your Maps',
    range: [5, 10],
    contentType: ContentType.BESTIARY,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'prefix_minor_bestiary_additional_chance': {
    id: 14,
    tradeId: 'explicit.stat_1566972708',
    description: 'Your Maps have +(15–25)% chance to contain Einhar',
    range: [15, 25],
    contentType: ContentType.BESTIARY,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'prefix_minor_bestiary_increased_chance': {
    id: 15,
    tradeId: 'explicit.stat_1301096166',
    description: 'Your Maps have (80–100)% increased chance to contain Einhar',
    range: [80, 100],
    contentType: ContentType.BESTIARY,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'suffix_minor_bestiary_red_beast_deep_chance': {
    id: 16,
    tradeId: 'explicit.stat_59091266',
    description: 'Red Beasts in your Maps have (40–60)% increased chance to be from The Deep',
    range: [40, 60],
    contentType: ContentType.BESTIARY,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_bestiary_red_beast_wilds_chance': {
    id: 17,
    tradeId: 'explicit.stat_3090817208',
    description: 'Red Beasts in your Maps have (40–60)% increased chance to be from The Wilds',
    range: [40, 60],
    contentType: ContentType.BESTIARY,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_bestiary_red_beast_caverns_chance': {
    id: 18,
    tradeId: 'explicit.stat_1595637549',
    description: 'Red Beasts in your Maps have (40–60)% increased chance to be from The Caverns',
    range: [40, 60],
    contentType: ContentType.BESTIARY,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_bestiary_red_beast_sands_chance': {
    id: 19,
    tradeId: 'explicit.stat_2436491720',
    description: 'Red Beasts in your Maps have (40–60)% increased chance to be from The Sands',
    range: [40, 60],
    contentType: ContentType.BESTIARY,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'prefix_minor_beyond_additional_chance': {
    id: 20,
    tradeId: 'explicit.stat_3438840900',
    description: '(15–25)% chance for your Maps to attract Beyond Demons',
    range: [15, 25],
    contentType: ContentType.BEYOND,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'suffix_minor_beyond_increased_demon_faction_chance': {
    id: 21,
    tradeId: 'explicit.stat_3175325766',
    description: 'Beyond Demons in your Maps have (35–45)% increased chance to be followers of K\'tash',
    range: [35, 45],
    contentType: ContentType.BEYOND,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_beyond_increased_pale_faction_chance': {
    id: 22,
    tradeId: 'explicit.stat_3857813970',
    description: 'Beyond Demons in your Maps have (35–45)% increased chance to be followers of Beidat',
    range: [35, 45],
    contentType: ContentType.BEYOND,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_beyond_increased_flesh_faction_chance': {
    id: 23,
    tradeId: 'explicit.stat_2541655454',
    description: 'Beyond Demons in your Maps have (35–45)% increased chance to be followers of Ghorr',
    range: [35, 45],
    contentType: ContentType.BEYOND,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'prefix_minor_blight_additional_encounter_chance': {
    id: 24,
    tradeId: 'explicit.stat_764545335',
    description: 'Your Maps have +(15–25)% chance to contain a Blight Encounter',
    range: [15, 25],
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'prefix_minor_blight_additional_chance': {
    id: 25,
    tradeId: 'explicit.stat_1393318927',
    description: 'Your Maps have (80–100)% increased chance to contain a Blight Encounter',
    range: [80, 100],
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'suffix_minor_blight_tower_reduced_cost': {
    id: 26,
    tradeId: 'explicit.stat_2078691497',
    description: '(15–20)% reduced Cost of Building and Upgrading Towers',
    range: [15, 20],
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_blight_blight_map_reward_chance': {
    id: 27,
    tradeId: 'explicit.stat_2002028881',
    description: 'Blight Chests in your Maps have (15–25)% more chance to contain Blighted Maps',
    range: [15, 25],
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_cleansing_fire_pack_size': {
    id: 28,
    tradeId: 'explicit.stat_2127991449',
    description: 'Monster Packs Influenced by The Searing Exarch in your Maps have (4–6)% increased Pack Size',
    range: [4, 6],
    contentType: ContentType.SEARING_EXARCH,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'prefix_minor_map_boss_conqueror_map_drop_chance': {
    id: 29,
    tradeId: 'explicit.stat_1554844434',
    description: 'Map Bosses have (40–60)% increased chance to drop a Conqueror Map',
    range: [40, 60],
    contentType: ContentType.CONQUERORS,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'prefix_minor_delirium_additional_chance': {
    id: 30,
    tradeId: 'explicit.stat_1808954678',
    description: 'Your Maps have +(15–25)% chance to contain a Mirror of Delirium',
    range: [15, 25],
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'prefix_minor_delirium_increased_chance': {
    id: 31,
    tradeId: 'explicit.stat_3573600538',
    description: 'Your Maps have (80–100)% increased chance to contain a Mirror of Delirium',
    range: [80, 100],
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'suffix_minor_delirium_additional_reward_type_chance': {
    id: 32,
    tradeId: 'explicit.stat_1770833858',
    description: 'Delirium Encounters in your Maps have (6–10)% chance to generate an additional Reward type',
    range: [6, 10],
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_delirium_boss_chance': {
    id: 33,
    tradeId: 'explicit.stat_3962960008',
    description: 'Delirium Encounters in your Maps are (35–50)% more likely to spawn Unique Bosses',
    range: [35, 50],
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_delirium_boss_increased_splinter_drops': {
    id: 34,
    tradeId: 'explicit.stat_405988579',
    description: 'Delirium Bosses in your Maps drop (20–30)% increased Simulacrum Splinters',
    range: [20, 30],
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_delirium_increased_reward_progress': {
    id: 35,
    tradeId: 'explicit.stat_3428124128',
    description: 'Delirious Monsters Killed in your Maps provide (10–20)% increased Reward Progress',
    range: [10, 20],
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_delirium_pack_size': {
    id: 36,
    tradeId: 'explicit.stat_3465791711',
    description: 'Delirium Monsters in your Maps have (5–10)% increased Pack Size',
    range: [5, 10],
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'prefix_minor_delve_additional_chance': {
    id: 37,
    tradeId: 'explicit.stat_4267923742',
    description: 'Your Maps have +(15–25)% chance to contain Niko',
    range: [15, 25],
    contentType: ContentType.DELVE,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'prefix_minor_delve_increased_chance': {
    id: 38,
    tradeId: 'explicit.stat_399319107',
    description: 'Your Maps have (80–100)% increased chance to contain Niko',
    range: [80, 100],
    contentType: ContentType.DELVE,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'prefix_minor_delve_sulphite_on_map_boss_defeat_white': {
    id: 39,
    tradeId: 'explicit.stat_1235418654',
    description: 'Your White Tier Maps grant (100–150) additional Voltaxic Sulphite on Completion',
    range: [100, 150],
    contentType: ContentType.DELVE,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'prefix_minor_delve_sulphite_on_map_boss_defeat_yellow': {
    id: 40,
    tradeId: 'explicit.stat_932764321',
    description: 'Your Yellow Tier Maps grant (150–200) additional Voltaxic Sulphite on Completion',
    range: [150, 200],
    contentType: ContentType.DELVE,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'prefix_minor_delve_sulphite_on_map_boss_defeat_red': {
    id: 41,
    tradeId: 'explicit.stat_1267068028',
    description: 'Your Red Tier Maps grant (200–250) additional Voltaxic Sulphite on Completion',
    range: [200, 250],
    contentType: ContentType.DELVE,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'suffix_minor_delve_suphite_veins_grant_azurite_chance': {
    id: 42,
    tradeId: 'explicit.stat_3862876997',
    description: 'Sulphite Veins and Chests in your Maps have (3–5)% chance to also contain an equal amount of Azurite',
    range: [3, 5],
    contentType: ContentType.DELVE,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_shrine_duration': {
    id: 43,
    tradeId: 'explicit.stat_1458119808',
    description: '(30–40)% increased duration of Shrine Buffs on players granted by Shrines in your Maps',
    range: [30, 40],
    contentType: ContentType.SHRINES,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'prefix_minor_shrine_increased_chance': {
    id: 44,
    tradeId: 'explicit.stat_2571125745',
    description: 'Your Maps have +(7–10)% chance to contain a Shrine',
    range: [7, 10],
    contentType: ContentType.SHRINES,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'prefix_minor_shrine_additional_chance': {
    id: 45,
    tradeId: 'explicit.stat_1260233365',
    description: 'Your Maps have a (35–50)% chance to contain an additional Shrine',
    range: [35, 50],
    contentType: ContentType.SHRINES,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'suffix_minor_essence_rare_item_with_mod_chance': {
    id: 46,
    tradeId: 'explicit.stat_1445968994',
    description: 'Imprisoned Monsters in your Maps have (40–60)% chance to drop an additional Rare Item with an Essence Modifier',
    range: [40, 60],
    contentType: ContentType.ESSENCE,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_essence_additional_essence_chance': {
    id: 47,
    tradeId: 'explicit.stat_2874244045',
    description: 'Imprisoned Monsters in your Maps have (8–12)% chance to have an additional Essence',
    range: [8, 12],
    contentType: ContentType.ESSENCE,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'prefix_minor_essence_increased_chance': {
    id: 48,
    tradeId: 'explicit.stat_4098286334',
    description: 'Your Maps have +(7–10)% chance to contain an Imprisoned Monster',
    range: [7, 10],
    contentType: ContentType.ESSENCE,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'prefix_minor_essence_additional_monolith_chance': {
    id: 49,
    tradeId: 'explicit.stat_2039130613',
    description: 'Your Maps have (35–50)% chance to contain an additional Imprisoned Monster',
    range: [35, 50],
    contentType: ContentType.ESSENCE,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'prefix_minor_expedition_additional_chance': {
    id: 50,
    tradeId: 'explicit.stat_4154778375',
    description: 'Your Maps have +(15–25)% chance to contain an Expedition Encounter',
    range: [15, 25],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'prefix_minor_expedition_increased_chance': {
    id: 51,
    tradeId: 'explicit.stat_1561678231',
    description: 'Your Maps have (80–100)% increased chance to contain an Expedition Encounter',
    range: [80, 100],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'suffix_minor_expedition_explosive_radius': {
    id: 52,
    tradeId: 'explicit.stat_3289828378',
    description: '(15–20)% increased Explosive Radius in your Maps',
    range: [15, 20],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_expedition_logbook_monster_drop_chance': {
    id: 53,
    tradeId: 'explicit.stat_1083387327',
    description: '(15–25)% increased Quantity of Expedition Logbooks dropped by Runic Monsters in your Maps',
    range: [15, 25],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'prefix_minor_harbinger_additional_harbinger_chance': {
    id: 54,
    tradeId: 'explicit.stat_266448395',
    description: 'Your Maps have a (35–50)% chance to contain an additional Harbinger',
    range: [35, 50],
    contentType: ContentType.HARBINGER,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'suffix_minor_harbinger_cooldown_recovery': {
    id: 55,
    tradeId: 'explicit.stat_1972294007',
    description: 'Harbingers in your Maps have (20–30)% increased Cooldown Recovery Rate',
    range: [20, 30],
    contentType: ContentType.HARBINGER,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'prefix_minor_harvest_additional_chance': {
    id: 56,
    tradeId: 'explicit.stat_1145451936',
    description: 'Your Maps have +(15–25)% chance to contain The Sacred Grove',
    range: [15, 25],
    contentType: ContentType.HARVEST,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'prefix_minor_harvest_increased_chance': {
    id: 57,
    tradeId: 'explicit.stat_2936740844',
    description: 'Your Maps have (80–100)% increased chance to contain The Sacred Grove',
    range: [80, 100],
    contentType: ContentType.HARVEST,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'suffix_minor_harvest_monster_increased_experience': {
    id: 58,
    tradeId: 'explicit.stat_4251234305',
    description: 'Harvest Monsters in your Maps grant (70–90)% increased Experience',
    range: [70, 90],
    contentType: ContentType.HARVEST,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_harvest_green_plot_chance': {
    id: 59,
    tradeId: 'explicit.stat_744497885',
    description: 'Harvest Crops in your Maps have (10–15)% reduced chance to grow Yellow Plants',
    range: [10, 15],
    contentType: ContentType.HARVEST,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_harvest_blue_plot_chance': {
    id: 60,
    tradeId: 'explicit.stat_1234594761',
    description: 'Harvest Crops in your Maps have (10–15)% reduced chance to grow Blue Plants',
    range: [10, 15],
    contentType: ContentType.HARVEST,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_harvest_red_plot_chance': {
    id: 61,
    tradeId: 'explicit.stat_4191390667',
    description: 'Harvest Crops in your Maps have (10–15)% reduced chance to grow Purple Plants',
    range: [10, 15],
    contentType: ContentType.HARVEST,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'prefix_minor_heist_additional_cache_chance': {
    id: 62,
    tradeId: 'explicit.stat_1975869602',
    description: 'Your Maps have +(15–25)% chance to contain a Smuggler\'s Cache',
    range: [15, 25],
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'prefix_minor_heist_increased_cache_chance': {
    id: 63,
    tradeId: 'explicit.stat_4069523014',
    description: 'Your Maps have (80–100)% increased chance to contain a Smuggler\'s Cache',
    range: [80, 100],
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'suffix_minor_heist_cache_blueprint_drop_chance': {
    id: 64,
    tradeId: 'explicit.stat_2018889940',
    description: 'Smuggler\'s Caches in your Maps have (35–45)% increased chance to drop Blueprints',
    range: [35, 45],
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'prefix_minor_heist_increased_contract_chance': {
    id: 65,
    tradeId: 'explicit.stat_3022689249',
    description: '(10–15)% increased Heist Contracts found in your Maps',
    range: [10, 15],
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'suffix_minor_heist_lockpick_bruteforce_perception_job_chance': {
    id: 66,
    tradeId: 'explicit.stat_1870692844',
    description: 'Heist Contracts found in your Maps are (40–60)% more likely to require Lockpicking, Brute Force or Perception',
    range: [40, 60],
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_heist_demo_counter_thaumaturgy_trap_disarm_job_chance': {
    id: 67,
    tradeId: 'explicit.stat_3225564606',
    description: 'Heist Contracts found in your Maps are (40–60)% more likely to require Demolition, Counter-Thaumaturgy or Trap Disarmament',
    range: [40, 60],
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_heist_agility_deception_engineering_job_chance': {
    id: 68,
    tradeId: 'explicit.stat_496819486',
    description: 'Heist Contracts found in your Maps are (40–60)% more likely to require Agility, Deception or Engineering',
    range: [40, 60],
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'prefix_minor_betrayal_additional_chance': {
    id: 69,
    tradeId: 'explicit.stat_527292219',
    description: 'Your Maps have +(15–25)% chance to contain Jun',
    range: [15, 25],
    contentType: ContentType.BETRAYAL,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'prefix_minor_betrayal_increased_chance': {
    id: 70,
    tradeId: 'explicit.stat_4116217552',
    description: 'Your Maps have (80–100)% increased chance to contain Jun',
    range: [80, 100],
    contentType: ContentType.BETRAYAL,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'suffix_minor_betrayal_leader_intervention_chance': {
    id: 71,
    tradeId: 'explicit.stat_1820067107',
    description: 'Immortal Syndicate Members in your Maps are (40–60)% more likely to be accompanied by their Leader',
    range: [40, 60],
    contentType: ContentType.BETRAYAL,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_betrayal_execute_additional_rank': {
    id: 72,
    tradeId: 'explicit.stat_3615401038',
    description: 'Immortal Syndicate Members Executed in your Maps have (40–60)% chance to gain an additional Rank',
    range: [40, 60],
    contentType: ContentType.BETRAYAL,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'prefix_minor_legion_additional_chance': {
    id: 73,
    tradeId: 'explicit.stat_1981273563',
    description: 'Your Maps have +(15–25)% chance to contain a Legion Encounter',
    range: [15, 25],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'prefix_minor_legion_increased_chance': {
    id: 74,
    tradeId: 'explicit.stat_310950600',
    description: 'Your Maps have (80–100)% increased chance to contain a Legion Encounter',
    range: [80, 100],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'suffix_minor_legion_sergeant_additional_reward_chance': {
    id: 75,
    tradeId: 'explicit.stat_958835998',
    description: 'Legion Sergeants in your Maps have (6–10)% additional chance to have Rewards',
    range: [6, 10],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_legion_general_chance': {
    id: 76,
    tradeId: 'explicit.stat_113049735',
    description: 'Legion Encounters in your Maps are (25–35)% more likely to include a General',
    range: [25, 35],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_legion_chest_break_out_range': {
    id: 77,
    tradeId: 'explicit.stat_793510540',
    description: 'Legion Chests released from Stasis in your Maps release other Monsters and Chests with (35–50)% increased Range',
    range: [35, 50],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'prefix_minor_map_tier_bonus': {
    id: 78,
    tradeId: 'explicit.stat_51196661',
    description: 'Tier 1-15 Maps found have (5–10)% chance to become 1 tier higher',
    range: [5, 10],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'suffix_minor_ultimatum_trialmaster_chance': {
    id: 79,
    tradeId: 'explicit.stat_1603263120',
    description: 'Ultimatum Encounters in your Maps have (15–20)% increased chance for the final Round to include a Boss',
    range: [15, 20],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'prefix_minor_ultimatum_increased_chance': {
    id: 80,
    tradeId: 'explicit.stat_880963174',
    description: 'Your Maps have (80–100)% increased chance to contain an Ultimatum Encounter',
    range: [80, 100],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'prefix_minor_ultimatum_additional_chance': {
    id: 81,
    tradeId: 'explicit.stat_1365687125',
    description: 'Your Maps have +(15–25)% chance to contain an Ultimatum Encounter',
    range: [15, 25],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'suffix_minor_ultimatum_defence_encounter_chance': {
    id: 82,
    tradeId: 'explicit.stat_4236665456',
    description: 'Ultimatum Encounters in your Maps have (40–60)% increased chance to require you to protect the Altar',
    range: [40, 60],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_ultimatum_rewards_unique_item_chance': {
    id: 83,
    tradeId: 'explicit.stat_1280423224',
    description: 'Ultimatum Rewards in your Maps have (20–30)% increased chance to be Unique Items',
    range: [20, 30],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_ultimatum_reward_jewellery_chance': {
    id: 84,
    tradeId: 'explicit.stat_3814215147',
    description: 'Ultimatum Rewards in your Maps have (20–30)% increased chance to be Jewellery',
    range: [20, 30],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_ultimatum_reward_currency_chance': {
    id: 85,
    tradeId: 'explicit.stat_1656757869',
    description: 'Ultimatum Rewards in your Maps have (20–30)% increased chance to be Currency Items',
    range: [20, 30],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_ultimatum_exterminate_chance': {
    id: 86,
    tradeId: 'explicit.stat_2014727907',
    description: 'Ultimatum Encounters in your Maps have (40–60)% increased chance to require you to defeat waves of Enemies',
    range: [40, 60],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_ultimatum_conquer_chance': {
    id: 87,
    tradeId: 'explicit.stat_802960755',
    description: 'Ultimatum Encounters in your Maps have (40–60)% increased chance to require you to Stand in the Stone Circles',
    range: [40, 60],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_ultimatum_reward_divination_card_chance': {
    id: 88,
    tradeId: 'explicit.stat_297961897',
    description: 'Ultimatum Rewards in your Maps have (20–30)% increased chance to be Divination Cards',
    range: [20, 30],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_ultimatum_reward_gem_chance': {
    id: 89,
    tradeId: 'explicit.stat_2091246228',
    description: 'Ultimatum Rewards in your Maps have (20–30)% increased chance to be Gems',
    range: [20, 30],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_ultimatum_survival_encounter_chance': {
    id: 90,
    tradeId: 'explicit.stat_306537703',
    description: 'Ultimatum Encounters in your Maps have (40–60)% increased chance to only require you to Survive',
    range: [40, 60],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'prefix_minor_settlers_increased_chance': {
    id: 91,
    tradeId: 'explicit.stat_2661886285',
    description: 'Your Maps have (80–100)% increased chance to contain Ore Deposits',
    range: [80, 100],
    contentType: ContentType.SETTLERS,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'prefix_minor_settlers_additional_chance': {
    id: 92,
    tradeId: 'explicit.stat_2661886285',
    description: 'Your Maps have +(15–25)% chance to contain Ore Deposits',
    range: [15, 25],
    contentType: ContentType.SETTLERS,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'suffix_minor_settlers_ore_found': {
    id: 93,
    tradeId: 'explicit.stat_792089502',
    description: 'Ore Deposits in your Maps contain (10–15)% increased Ore',
    range: [10, 15],
    contentType: ContentType.SETTLERS,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_settlers_bismuth_chance': {
    id: 94,
    tradeId: 'explicit.stat_3096795807',
    description: '(30–50)% increased chance for Ore Deposits found in your Maps to be Bismuth',
    range: [30, 50],
    contentType: ContentType.SETTLERS,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_settlers_crimson_ore_chance': {
    id: 95,
    tradeId: 'explicit.stat_2365077639',
    description: '(30–50)% increased chance for Ore Deposits found in your Maps to be Crimson Iron',
    range: [30, 50],
    contentType: ContentType.SETTLERS,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_settlers_orichalcum_ore_chance': {
    id: 96,
    tradeId: 'explicit.stat_1972650697',
    description: '(30–50)% increased chance for Ore Deposits found in your Maps to be Orichalcum',
    range: [30, 50],
    contentType: ContentType.SETTLERS,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_settlers_amber_ore_chance': {
    id: 97,
    tradeId: 'explicit.stat_2162292810',
    description: '(30–50)% increased chance for Ore Deposits found in your Maps to be Petrified Amber',
    range: [30, 50],
    contentType: ContentType.SETTLERS,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_settlers_verisium_ore_chance': {
    id: 98,
    tradeId: 'explicit.stat_236923923',
    description: '(30–50)% increased chance for Ore Deposits found in your Maps to be Verisium',
    range: [30, 50],
    contentType: ContentType.SETTLERS,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'prefix_minor_ritual_additional_chance': {
    id: 99,
    tradeId: 'explicit.stat_1314822783',
    description: 'Your Maps have +(15–25)% chance to contain Ritual Altars',
    range: [15, 25],
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'prefix_minor_ritual_increased_chance': {
    id: 100,
    tradeId: 'explicit.stat_1777351949',
    description: 'Your Maps have (80–100)% increased chance to contain Ritual Altars',
    range: [80, 100],
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'suffix_minor_ritual_less_reroll_cost': {
    id: 101,
    tradeId: 'explicit.stat_2282052746',
    description: 'Rerolling Favours at Ritual Altars in your Maps costs (8–12)% reduced Tribute',
    range: [8, 12],
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_ritual_deferred_rewards_offered_sooner': {
    id: 102,
    tradeId: 'explicit.stat_28208665',
    description: 'Favours Deferred at Ritual Altars in your Maps reappear (20–30)% sooner',
    range: [20, 30],
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_ritual_unique_monsters_more_tribute': {
    id: 103,
    tradeId: 'explicit.stat_3957379603',
    description: 'Unique Monsters slain at Ritual Altars in your Maps grant (40–60)% more Tribute',
    range: [40, 60],
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'prefix_minor_scarab_increased_drops': {
    id: 104,
    tradeId: 'explicit.stat_1351268685',
    description: '(5–10)% increased Scarabs found in your Maps',
    range: [5, 10],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'suffix_minor_scarab_unique_monsters_drop_chance': {
    id: 105,
    tradeId: 'explicit.stat_3190161627',
    description: 'Unique Monsters in your Maps have (75–100)% increased chance to drop Scarabs',
    range: [75, 100],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'prefix_minor_strongbox_increased_chance': {
    id: 106,
    tradeId: 'explicit.stat_2388936716',
    description: 'Your Maps have +(35–50)% chance to contain a Strongbox',
    range: [35, 50],
    contentType: ContentType.STRONGBOXES,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'suffix_minor_strongbox_arcanist_chance': {
    id: 107,
    tradeId: 'explicit.stat_2115623338',
    description: 'Strongboxes in your Maps have (50–70)% increased chance to be an Arcanist\'s Strongbox',
    range: [50, 70],
    contentType: ContentType.STRONGBOXES,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_strongbox_cartographers_chance': {
    id: 108,
    tradeId: 'explicit.stat_3273190973',
    description: 'Strongboxes in your Maps have (50–70)% increased chance to be a Cartographer\'s Strongbox',
    range: [50, 70],
    contentType: ContentType.STRONGBOXES,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_strongbox_diviners_chance': {
    id: 109,
    tradeId: 'explicit.stat_2388239017',
    description: 'Strongboxes in your Maps have (50–70)% increased chance to be a Diviner\'s Strongbox',
    range: [50, 70],
    contentType: ContentType.STRONGBOXES,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_strongbox_gemcutters_chance': {
    id: 110,
    tradeId: 'explicit.stat_773912026',
    description: 'Strongboxes in your Maps have (40–60)% increased chance to be a Gemcutter\'s Strongbox',
    range: [40, 60],
    contentType: ContentType.STRONGBOXES,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_tangle_double_progress_chance': {
    id: 111,
    tradeId: 'explicit.stat_1943774953',
    description: 'Your Maps have (4–6)% chance to award double progress towards encountering The Eater of Worlds',
    range: [4, 6],
    contentType: ContentType.EATER_OF_WORLDS,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_tangle_duplicate_elritch_currency_chance': {
    id: 112,
    tradeId: 'explicit.stat_2157440077',
    description: 'Eldritch Ichor found in your Maps influenced by The Eater of Worlds have (4–6)% chance to be Duplicated',
    range: [4, 6],
    contentType: ContentType.EATER_OF_WORLDS,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'prefix_minor_torment_additional_chance': {
    id: 113,
    tradeId: 'explicit.stat_846433713',
    description: 'Your Maps have a (35–50)% chance to be haunted by an additional Tormented Spirit',
    range: [35, 50],
    contentType: ContentType.TORMENTED_SPIRITS,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'prefix_minor_torment_increased_chance': {
    id: 114,
    tradeId: 'explicit.stat_2750973094',
    description: 'Your Maps have +(7–10)% chance to be haunted by a Tormented Spirit',
    range: [7, 10],
    contentType: ContentType.TORMENTED_SPIRITS,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'suffix_minor_torment_spirit_duration': {
    id: 115,
    tradeId: 'explicit.stat_663610248',
    description: 'Tormented Spirits in your Maps have (40–60)% increased Duration',
    range: [40, 60],
    contentType: ContentType.TORMENTED_SPIRITS,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_map_items_drop_corrupted_in_corrupted_maps_chance': {
    id: 116,
    tradeId: 'explicit.stat_1407304212',
    description: 'Items found in your Corrupted Maps have (1–2)% chance to be Corrupted',
    range: [1, 2],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_map_upgrade_vaal_side_area_chance': {
    id: 117,
    tradeId: 'explicit.stat_2063734057',
    description: 'Vaal Side Areas in your Maps have (6–10)% chance to be an Alluring Vaal Side Area',
    range: [6, 10],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_map_rare_monster_items_drop_corrupted_chance': {
    id: 118,
    tradeId: 'explicit.stat_2736953654',
    description: 'Items dropped by Rare Monsters have (3–5)% chance to be Corrupted',
    range: [3, 5],
    contentType: ContentType.VAAL_SIDE_AREAS,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'prefix_minor_map_increased_atlas_scouting_report_drop_chance': {
    id: 119,
    tradeId: 'explicit.stat_602879359',
    description: '(10–15)% increased Atlas Scouting Reports found in your Maps',
    range: [10, 15],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'suffix_minor_scouting_reports_drops_as_delirium_chance': {
    id: 120,
    tradeId: 'explicit.stat_4045495237',
    description: '(2–4)% chance for Scouting Reports to drop as Delirious Scouting Reports instead in your Maps',
    range: [2, 4],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_scouting_reports_drop_as_blighted_chance': {
    id: 121,
    tradeId: 'explicit.stat_1347565511',
    description: '(2–4)% chance for Scouting Reports to drop as Blighted Scouting Reports instead in your Maps',
    range: [2, 4],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_scouting_reports_drop_as_comprehensive_chance': {
    id: 122,
    tradeId: 'explicit.stat_1385164385',
    description: '(6–10)% chance for Scouting Reports to drop as Comprehensive Scouting Reports instead in your Maps',
    range: [6, 10],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_scouting_reports_drop_as_vaal_chance': {
    id: 123,
    tradeId: 'explicit.stat_2327933970',
    description: '(4–6)% chance for Scouting Reports to drop as Vaal Scouting Reports instead in your Maps',
    range: [4, 6],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_scouting_reports_drop_as_operative_chance': {
    id: 124,
    tradeId: 'explicit.stat_2246445775',
    description: '(3–5)% chance for Scouting Reports to drop as Operative\'s Scouting Reports instead in your Maps',
    range: [3, 5],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'suffix_minor_scouting_reports_drop_as_singular_chance': {
    id: 125,
    tradeId: 'explicit.stat_2681413993',
    description: '(4–6)% chance for Scouting Reports to drop as Singular Scouting Reports instead in your Maps',
    range: [4, 6],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.MINOR],
    type: 'suffix'
  },
  'prefix_minor_increased_map_drops_chance': {
    id: 126,
    tradeId: 'explicit.stat_2777224821',
    description: '(2–3)% increased Maps found in Area',
    range: [2, 3],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'prefix_minor_map_tier_seventeen_packs': {
    id: 127,
    tradeId: 'explicit.stat_1366180761',
    description: 'Your Maps contain (3–5)% more Monster Packs consisting of difficult and rewarding Monsters',
    range: [3, 5],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.MINOR],
    type: 'prefix'
  },
  'prefix_noble_additional_abyss_chance': {
    id: 128,
    tradeId: 'explicit.stat_4278144676',
    description: 'Your Maps have +(30–45)% chance to contain an Abyss',
    range: [30, 45],
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'prefix_noble_increased_abyss_chance': {
    id: 129,
    tradeId: 'explicit.stat_4111037980',
    description: 'Your Maps have (144–180)% increased chance to contain an Abyss',
    range: [144, 180],
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'suffix_noble_increased_abyss_monsters': {
    id: 130,
    tradeId: 'explicit.stat_944630113',
    description: 'Abysses in your Maps spawn (12–18)% increased Monsters',
    range: [12, 18],
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_increased_abyss_monster_experience': {
    id: 131,
    tradeId: 'explicit.stat_2975078312',
    description: 'Abyss Monsters in your Maps grant (30–40)% increased Experience',
    range: [30, 40],
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_abyss_path_spawn100_percent_increased_monsters_chance': {
    id: 132,
    tradeId: 'explicit.stat_211873159',
    description: 'Abyss Cracks in your Maps have (8–12)% chance to spawn 100% increased Monsters',
    range: [8, 12],
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_abyss_chasm_spawn100_percent_increased_monsters_chance': {
    id: 133,
    tradeId: 'explicit.stat_1086708760',
    description: 'Abyss Pits in your Maps have (8–12)% chance to spawn 100% increased Monsters',
    range: [8, 12],
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_abyss_at_least_magic_per_chasm_chance': {
    id: 134,
    tradeId: 'explicit.stat_440232197',
    description: 'Abyss Cracks in your Maps have (3–5)% chance to spawn all Monsters as Magic for each prior Pit in that Abyss',
    range: [3, 5],
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'prefix_noble_additional_incursion_chance': {
    id: 135,
    tradeId: 'explicit.stat_2709296039',
    description: 'Your Maps have +(30–45)% chance to contain Alva',
    range: [30, 45],
    contentType: ContentType.INCURSION,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'prefix_noble_increased_incursion_chance': {
    id: 136,
    tradeId: 'explicit.stat_3629418990',
    description: 'Your Maps have (144–180)% increased chance to contain Alva',
    range: [144, 180],
    contentType: ContentType.INCURSION,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'suffix_noble_incursion_all_monsters_magic_chance': {
    id: 137,
    tradeId: 'explicit.stat_787321478',
    description: 'Incursions in your Maps have (15–25)% chance for all Monsters to be at least Magic',
    range: [15, 25],
    contentType: ContentType.INCURSION,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'prefix_noble_anarchy_additional_exiles_chance': {
    id: 138,
    tradeId: 'explicit.stat_1123357133',
    description: 'Your Maps have a (30–45)% chance to contain an additional Rogue Exile',
    range: [30, 45],
    contentType: ContentType.ROGUE_EXILES,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'prefix_noble_anarchy_exile_chance': {
    id: 139,
    tradeId: 'explicit.stat_2974922599',
    description: 'Your Maps have +(12–18)% chance to contain a Rogue Exile',
    range: [12, 18],
    contentType: ContentType.ROGUE_EXILES,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'suffix_noble_anarchy_exile_increased_rarity': {
    id: 140,
    tradeId: 'explicit.stat_4105955491',
    description: '(30–40)% increased Rarity of Items Dropped by Wild Rogue Exiles in your Maps',
    range: [30, 40],
    contentType: ContentType.ROGUE_EXILES,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_anarchy_exile_additional_currency_chance': {
    id: 141,
    tradeId: 'explicit.stat_2646493318',
    description: 'Rogue Exiles in your Maps have (15–20)% chance to drop an additional Currency Item',
    range: [15, 20],
    contentType: ContentType.ROGUE_EXILES,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'prefix_noble_bestiary_additional_chance': {
    id: 142,
    tradeId: 'explicit.stat_1566972708',
    description: 'Your Maps have +(30–45)% chance to contain Einhar',
    range: [30, 45],
    contentType: ContentType.BESTIARY,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'prefix_noble_bestiary_increased_chance': {
    id: 143,
    tradeId: 'explicit.stat_1301096166',
    description: 'Your Maps have (144–180)% increased chance to contain Einhar',
    range: [144, 180],
    contentType: ContentType.BESTIARY,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'suffix_noble_bestiary_addtional_red_beast_chance': {
    id: 144,
    tradeId: 'explicit.stat_1044770866',
    description: 'Your Maps that contain capturable Beasts have (12–18)% chance to contain an additional Red Beast',
    range: [12, 18],
    contentType: ContentType.BESTIARY,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_bestiary_einhar_more_damage_to_uniques': {
    id: 145,
    tradeId: 'explicit.stat_1709437962',
    description: 'Einhar deals (600–800)% more Damage to Unique Monsters in your Maps',
    range: [600, 800],
    contentType: ContentType.BESTIARY,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_beastiary_einhar_cooldown_recovery': {
    id: 146,
    tradeId: 'explicit.stat_1288839550',
    description: 'Einhar has (60–80)% increased Cooldown Recovery Rate in your Maps',
    range: [60, 80],
    contentType: ContentType.BESTIARY,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'prefix_noble_beyond_additional_chance': {
    id: 147,
    tradeId: 'explicit.stat_3438840900',
    description: '(30–45)% chance for your Maps to attract Beyond Demons',
    range: [30, 45],
    contentType: ContentType.BEYOND,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'suffix_noble_beyond_increased_portal_search_radius': {
    id: 148,
    tradeId: 'explicit.stat_1454090489',
    description: 'Beyond Portals in your Maps have (20–25)% increased Merging Radius',
    range: [20, 25],
    contentType: ContentType.BEYOND,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_beyond_increased_monster_tainted_currency_quantity': {
    id: 149,
    tradeId: 'explicit.stat_1289727785',
    description: '(10–15)% increased Quantity of Tainted Currency dropped by Beyond Demons in your Maps',
    range: [10, 15],
    contentType: ContentType.BEYOND,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_blight_lane_additional_chest_chance': {
    id: 150,
    tradeId: 'explicit.stat_3986662538',
    description: 'Lanes of Blight Encounters in your Maps have (6–8)% chance for an additional Reward Chest',
    range: [6, 8],
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'prefix_noble_blight_additional_encounter_chance': {
    id: 151,
    tradeId: 'explicit.stat_764545335',
    description: 'Your Maps have +(30–45)% chance to contain a Blight Encounter',
    range: [30, 45],
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'prefix_noble_blight_additional_chance': {
    id: 152,
    tradeId: 'explicit.stat_1393318927',
    description: 'Your Maps have (144–180)% increased chance to contain a Blight Encounter',
    range: [144, 180],
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'suffix_noble_blight_chest_additional_drop_chance': {
    id: 153,
    tradeId: 'explicit.stat_1260718722',
    description: '(15–25)% chance for Blight Chests to contain an additional Reward',
    range: [15, 25],
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_blight_boss_additional_reward_chance': {
    id: 154,
    tradeId: 'explicit.stat_393389663',
    description: 'Blight Bosses in your Maps have (14–18)% chance to add an additional Reward Chest to their Lane',
    range: [14, 18],
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_blight_chest_oil_chance': {
    id: 155,
    tradeId: 'explicit.stat_1254426365',
    description: 'Blighted Chests in your Maps have (25–35)% increased chance to contain an Oil',
    range: [25, 35],
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_blight_monster_spawn_rate': {
    id: 156,
    tradeId: 'explicit.stat_1837341489',
    description: 'Blight Monsters in your Maps spawn (40–60)% faster',
    range: [40, 60],
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_cleansing_fire_monster_influence_item_drop_chance': {
    id: 157,
    tradeId: 'explicit.stat_532540562',
    description: 'Monsters Influenced by The Searing Exarch in your Maps have (0.5–0.7)% chance to drop an Item with a Searing Exarch Implicit Modifier',
    range: [0.5, 0.7],
    contentType: ContentType.SEARING_EXARCH,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_conqueror_influence_pack_size': {
    id: 158,
    tradeId: 'explicit.stat_2459732614',
    description: 'Monster Packs Influenced by Conquerors in your Maps have (8–12)% increased Pack Size',
    range: [8, 12],
    contentType: ContentType.CONQUERORS,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'prefix_noble_delirium_additional_chance': {
    id: 159,
    tradeId: 'explicit.stat_1808954678',
    description: 'Your Maps have +(30–45)% chance to contain a Mirror of Delirium',
    range: [30, 45],
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'prefix_noble_delirium_increased_chance': {
    id: 160,
    tradeId: 'explicit.stat_3573600538',
    description: 'Your Maps have (144–180)% increased chance to contain a Mirror of Delirium',
    range: [144, 180],
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'suffix_noble_delirium_secondary_wave_acceleration': {
    id: 161,
    tradeId: 'explicit.stat_3350944114',
    description: 'Delirium Fog in your Maps dissipates (2–5)% slower',
    range: [2, 5],
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_delirium_boss_unique_cluster_jewel_chance': {
    id: 162,
    tradeId: 'explicit.stat_615948723',
    description: 'Delirium Bosses in your Maps have (30–40)% increased chance to drop Unique Cluster Jewels',
    range: [30, 40],
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_delirium_monster_cluster_jewel_drop_chance': {
    id: 163,
    tradeId: 'explicit.stat_3580714718',
    description: 'Delirium Monsters in your Maps have (15–25)% increased chance to drop Cluster Jewels',
    range: [15, 25],
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_delirium_cluster_jewel_rare_corrupted_chance': {
    id: 164,
    tradeId: 'explicit.stat_1975134334',
    description: 'Cluster Jewels from Delirium Rewards have a (6–8)% chance to be Rare and Corrupted',
    range: [6, 8],
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_delve_increased_sulphite': {
    id: 165,
    tradeId: 'explicit.stat_4276927142',
    description: 'Voltaxic Sulphite Veins and Chests in your Maps contain (8–10)% increased Sulphite',
    range: [8, 10],
    contentType: ContentType.DELVE,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'prefix_noble_delve_additional_chance': {
    id: 166,
    tradeId: 'explicit.stat_4267923742',
    description: 'Your Maps have +(30–45)% chance to contain Niko',
    range: [30, 45],
    contentType: ContentType.DELVE,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'prefix_noble_delve_increased_chance': {
    id: 167,
    tradeId: 'explicit.stat_399319107',
    description: 'Your Maps have (144–180)% increased chance to contain Niko',
    range: [144, 180],
    contentType: ContentType.DELVE,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'suffix_noble_delve_movement_speed_per_sulphite_mined': {
    id: 168,
    tradeId: 'explicit.stat_1774735706',
    description: 'You gain (8–12)% increased Movement Speed per stack of Sulphite Intoxication',
    range: [8, 12],
    contentType: ContentType.DELVE,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'prefix_noble_shrine_increased_chance': {
    id: 169,
    tradeId: 'explicit.stat_2571125745',
    description: 'Your Maps have +(12–18)% chance to contain a Shrine',
    range: [12, 18],
    contentType: ContentType.SHRINES,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'prefix_noble_shrine_additional_chance': {
    id: 170,
    tradeId: 'explicit.stat_1260233365',
    description: 'Your Maps have a (60–80)% chance to contain an additional Shrine',
    range: [60, 80],
    contentType: ContentType.SHRINES,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'suffix_noble_shrine_buff_effect': {
    id: 171,
    tradeId: 'explicit.stat_866902458',
    description: '(25–35)% increased effect of Shrine Buffs on players granted by Shrines in your Maps',
    range: [25, 35],
    contentType: ContentType.SHRINES,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_zana_influence_memory_tear_chance': {
    id: 172,
    tradeId: 'explicit.stat_4016588303',
    description: '(10–20)% increased chance for your Maps to contain Memory Tears (Tier 16+)',
    range: [10, 20],
    contentType: ContentType.ZANA,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_zana_influence_anger_boss_chance': {
    id: 173,
    tradeId: 'explicit.stat_1493453364',
    description: '(15–25)% increased chance for Memory Threads to lead towards the Incarnation of Fear',
    range: [15, 25],
    contentType: ContentType.ZANA,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_zana_influence_ignorance_boss_chance': {
    id: 174,
    tradeId: 'explicit.stat_3126598962',
    description: '(15–25)% increased chance for Memory Threads to lead towards the Incarnation of Neglect',
    range: [15, 25],
    contentType: ContentType.ZANA,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_zana_influence_benevolence_boss_chance': {
    id: 175,
    tradeId: 'explicit.stat_1415269999',
    description: '(15–25)% increased chance for Memory Threads to lead towards the Incarnation of Dread',
    range: [15, 25],
    contentType: ContentType.ZANA,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'prefix_noble_boss_shaper_map_drop_chance': {
    id: 176,
    tradeId: 'explicit.stat_931052937',
    description: 'Final Map Boss in each Map has +(1.8–2.4)% chance to drop a Shaper Guardian Map (Tier 14+)',
    range: [1.8, 2.4],
    contentType: ContentType.ELDER,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'prefix_noble_boss_elder_map_drop_chance': {
    id: 177,
    tradeId: 'explicit.stat_1377454569',
    description: 'Final Map Boss in each Map has +(1.8–2.4)% chance to drop an Elder Guardian Map (Tier 14+)',
    range: [1.8, 2.4],
    contentType: ContentType.ELDER,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'prefix_noble_essence_increased_chance': {
    id: 178,
    tradeId: 'explicit.stat_4098286334',
    description: 'Your Maps have +(12–18)% chance to contain an Imprisoned Monster',
    range: [12, 18],
    contentType: ContentType.ESSENCE,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'prefix_noble_essence_additional_monolith_chance': {
    id: 179,
    tradeId: 'explicit.stat_2039130613',
    description: 'Your Maps have (60–80)% chance to contain an additional Imprisoned Monster',
    range: [60, 80],
    contentType: ContentType.ESSENCE,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'suffix_noble_essence_monoliths_have_corrutption_essence_chance': {
    id: 180,
    tradeId: 'explicit.stat_1439991839',
    description: 'Monsters Imprisoned by Essences have a (20–25)% chance to contain a Remnant of Corruption',
    range: [20, 25],
    contentType: ContentType.ESSENCE,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_expedition_artifact_quantity': {
    id: 181,
    tradeId: 'explicit.stat_4219583418',
    description: '(10–15)% increased quantity of Artifacts dropped by Monsters',
    range: [10, 15],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'prefix_noble_expedition_additional_chance': {
    id: 182,
    tradeId: 'explicit.stat_4154778375',
    description: 'Your Maps have +(30–45)% chance to contain an Expedition Encounter',
    range: [30, 45],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'prefix_noble_expedition_increased_chance': {
    id: 183,
    tradeId: 'explicit.stat_1561678231',
    description: 'Your Maps have (144–180)% increased chance to contain an Expedition Encounter',
    range: [144, 180],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'suffix_noble_expedition_increased_explosives': {
    id: 184,
    tradeId: 'explicit.stat_3051490307',
    description: '(6–10)% increased number of Explosives in your Maps',
    range: [6, 10],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_expedition_reroll_currency_quantity': {
    id: 185,
    tradeId: 'explicit.stat_2934907255',
    description: '(15–20)% increased Quantity of Vendor Refresh Currencies dropped by Monsters in your Maps',
    range: [15, 20],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_expedition_fuse_burn_time': {
    id: 186,
    tradeId: 'explicit.stat_3907743910',
    description: 'Expedition Detonation Chains in your Maps travel (12–18)% slower',
    range: [12, 18],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_harbinger_additional_currency_shard_stacks': {
    id: 187,
    tradeId: 'explicit.stat_1413020589',
    description: 'Harbingers in your Maps have (40–60)% chance to drop an additional Stack of Currency Shards',
    range: [40, 60],
    contentType: ContentType.HARBINGER,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'prefix_noble_harbinger_additional_harbinger_chance': {
    id: 188,
    tradeId: 'explicit.stat_266448395',
    description: 'Your Maps have a (60–80)% chance to contain an additional Harbinger',
    range: [60, 80],
    contentType: ContentType.HARBINGER,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'prefix_noble_harvest_additional_chance': {
    id: 189,
    tradeId: 'explicit.stat_1145451936',
    description: 'Your Maps have +(30–45)% chance to contain The Sacred Grove',
    range: [30, 45],
    contentType: ContentType.HARVEST,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'prefix_noble_harvest_increased_chance': {
    id: 190,
    tradeId: 'explicit.stat_2936740844',
    description: 'Your Maps have (144–180)% increased chance to contain The Sacred Grove',
    range: [144, 180],
    contentType: ContentType.HARVEST,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'suffix_noble_harvest_boss_encounter_chance': {
    id: 191,
    tradeId: 'explicit.stat_1505882627',
    description: 'Harvest Crops in your Maps have (35–45)% increased chance to contain a Tier 4 Plant',
    range: [35, 45],
    contentType: ContentType.HARVEST,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_harvest_tier_three_chance': {
    id: 192,
    tradeId: 'explicit.stat_2992379436',
    description: 'Harvest Crops in your Maps have (25–35)% increased chance to contain Tier 3 Plants',
    range: [25, 35],
    contentType: ContentType.HARVEST,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'prefix_noble_heist_additional_cache_chance': {
    id: 193,
    tradeId: 'explicit.stat_1975869602',
    description: 'Your Maps have +(30–45)% chance to contain a Smuggler\'s Cache',
    range: [30, 45],
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'prefix_noble_heist_increased_cache_chance': {
    id: 194,
    tradeId: 'explicit.stat_4069523014',
    description: 'Your Maps have (144–180)% increased chance to contain a Smuggler\'s Cache',
    range: [144, 180],
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'suffix_noble_heist_level_three_job_chance': {
    id: 195,
    tradeId: 'explicit.stat_3688987182',
    description: 'Heist Contracts found in your Maps are (75–125)% more likely to require level 3 Jobs',
    range: [75, 125],
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_heist_level_four_job_chance': {
    id: 196,
    tradeId: 'explicit.stat_3688987182',
    description: 'Heist Contracts found in your Maps are (75–125)% more likely to require level 4 Jobs',
    range: [75, 125],
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_heist_level_five_job_chance': {
    id: 197,
    tradeId: 'explicit.stat_3688987182',
    description: 'Heist Contracts found in your Maps are (75–125)% more likely to require level 5 Jobs',
    range: [75, 125],
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_heist_second_cache_chance': {
    id: 198,
    tradeId: 'explicit.stat_549540629',
    description: 'Your Maps that contain Smuggler\'s Caches have a (25–35)% chance to contain an additional Smuggler\'s Cache',
    range: [25, 35],
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'prefix_noble_heist_increased_blueprint_chance': {
    id: 199,
    tradeId: 'explicit.stat_619910101',
    description: '(20–25)% increased Blueprints found in your Maps',
    range: [20, 25],
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'prefix_noble_betrayal_additional_chance': {
    id: 200,
    tradeId: 'explicit.stat_527292219',
    description: 'Your Maps have +(30–45)% chance to contain Jun',
    range: [30, 45],
    contentType: ContentType.BETRAYAL,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'prefix_noble_betrayal_increased_chance': {
    id: 201,
    tradeId: 'explicit.stat_4116217552',
    description: 'Your Maps have (144–180)% increased chance to contain Jun',
    range: [144, 180],
    contentType: ContentType.BETRAYAL,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'suffix_noble_betrayal_bargin_option_chance': {
    id: 202,
    tradeId: 'explicit.stat_1259656520',
    description: 'Immortal Syndicate Members in your Maps are (120–160)% more likely to offer to Bargain for Items',
    range: [120, 160],
    contentType: ContentType.BETRAYAL,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_betrayal_target_item_rarity_per_equipment': {
    id: 203,
    tradeId: 'explicit.stat_4187085307',
    description: '(16–24)% increased Rarity of items from Defeated Syndicate Members in your Maps per Equipment Item they have',
    range: [16, 24],
    contentType: ContentType.BETRAYAL,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'prefix_noble_legion_additional_chance': {
    id: 204,
    tradeId: 'explicit.stat_1981273563',
    description: 'Your Maps have +(30–45)% chance to contain a Legion Encounter',
    range: [30, 45],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'prefix_noble_legion_increased_chance': {
    id: 205,
    tradeId: 'explicit.stat_310950600',
    description: 'Your Maps have (144–180)% increased chance to contain a Legion Encounter',
    range: [144, 180],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'suffix_noble_legion_sergeant_item_rarity': {
    id: 206,
    tradeId: 'explicit.stat_3617935793',
    description: '(100–150)% increased Rarity of Items Dropped by Legion Sergeants in your Maps',
    range: [100, 150],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_legion_duration': {
    id: 207,
    tradeId: 'explicit.stat_699122342',
    description: 'Legion Encounters in your Maps have (40–60)% increased Duration',
    range: [40, 60],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_legion_frozen_monsters_damage_taken': {
    id: 208,
    tradeId: 'explicit.stat_2596927667',
    description: 'Legion Monsters in your Maps take (30–40)% increased Damage while in Stasis',
    range: [30, 40],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_legion_pack_size': {
    id: 209,
    tradeId: 'explicit.stat_4183582609',
    description: 'Legion Monsters in your Maps have (10–15)% increased Pack Size',
    range: [10, 15],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'prefix_noble_ultimatum_increased_chance': {
    id: 210,
    tradeId: 'explicit.stat_880963174',
    description: 'Your Maps have (144–180)% increased chance to contain an Ultimatum Encounter',
    range: [144, 180],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'prefix_noble_ultimatum_additional_chance': {
    id: 211,
    tradeId: 'explicit.stat_1365687125',
    description: 'Your Maps have +(30–45)% chance to contain an Ultimatum Encounter',
    range: [30, 45],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'suffix_noble_ultimatum_defence_encounter_life': {
    id: 212,
    tradeId: 'explicit.stat_4281937233',
    description: 'Ultimatum Altars in your Maps have (30–40)% increased Life',
    range: [30, 40],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_ultimatum_conquer_encounter_radius': {
    id: 213,
    tradeId: 'explicit.stat_1805474879',
    description: 'Ultimatum Stone Circles in your Maps have (15–20)% increased radius',
    range: [15, 20],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_ultimatum_rewards_inscribed_chance': {
    id: 214,
    tradeId: 'explicit.stat_294140055',
    description: 'Ultimatum Rewards in your Maps have (25–35)% increased chance to be Inscribed Ultimatums',
    range: [25, 35],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_ultimatum_increased_survival_encounter_time': {
    id: 215,
    tradeId: 'explicit.stat_3099069648',
    description: 'Ultimatum Encounters in your Maps only requiring you to Survive have (3–5)% reduced duration',
    range: [3, 5],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_ultimatum_ultimatum_exterminate_reduced_monster_kills_required': {
    id: 216,
    tradeId: 'explicit.stat_340836576',
    description: 'Ultimatum Encounters in your Maps requiring you to Defeat waves of Enemies require killing (3–5)% reduced number of Enemies',
    range: [3, 5],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'prefix_noble_settlers_increased_chance': {
    id: 217,
    tradeId: '',
    description: 'Your Maps have (144–180)% increased chance to contain Ore Deposits',
    range: [144, 180],
    contentType: ContentType.SETTLERS,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'prefix_noble_settlers_additional_chance': {
    id: 218,
    tradeId: 'explicit.stat_2661886285',
    description: 'Your Maps have +(30–45)% chance to contain Ore Deposits',
    range: [30, 45],
    contentType: ContentType.SETTLERS,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'prefix_noble_ritual_additional_chance': {
    id: 219,
    tradeId: 'explicit.stat_1314822783',
    description: 'Your Maps have +(30–45)% chance to contain Ritual Altars',
    range: [30, 45],
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'prefix_noble_ritual_increased_chance': {
    id: 220,
    tradeId: 'explicit.stat_1777351949',
    description: 'Your Maps have (144–180)% increased chance to contain Ritual Altars',
    range: [144, 180],
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'suffix_noble_ritual_increased_uber_rune_chance': {
    id: 221,
    tradeId: 'explicit.stat_2172921782',
    description: '(50–75)% increased chance of Ritual Altars with Special Rewards',
    range: [50, 75],
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_ritual_rewards_from_rerolls_no_cost_chance': {
    id: 222,
    tradeId: 'explicit.stat_937291386',
    description: 'Favours Rerolled at Ritual Altars in your Maps have (0.8–1.2)% chance to cost no Tribute',
    range: [0.8, 1.2],
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_ritual_increased_maximum_monsters_alive': {
    id: 223,
    tradeId: 'explicit.stat_2219456349',
    description: 'Ritual Altars in your Maps can have (15–25)% increased number of Spawned Monsters at once',
    range: [15, 25],
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_ritual_splinters_increased_stack_size': {
    id: 224,
    tradeId: 'explicit.stat_1724306833',
    description: 'Ritual Splinters offered at Ritual Altars in your Maps have (20–25)% increased Stack Size',
    range: [20, 25],
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_scarab_map_more_likely': {
    id: 225,
    tradeId: 'explicit.stat_1762451150',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Cartography Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_scarab_strongbox_more_likely': {
    id: 226,
    tradeId: 'explicit.stat_3017211510',
    description: 'Scarabs found in your Maps have (60–80)% increased chance to be Ambush Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_scarab_unique_more_likely': {
    id: 227,
    tradeId: 'explicit.stat_2584308379',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Titanic Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_scarab_harbinger_more_likely': {
    id: 228,
    tradeId: 'explicit.stat_1560748306',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Harbinger Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_scarab_beyond_more_likely': {
    id: 229,
    tradeId: 'explicit.stat_2507275343',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Beyond Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_scarab_essence_more_likely': {
    id: 230,
    tradeId: 'explicit.stat_751635784',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Essence Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_scarab_torment_more_likely': {
    id: 231,
    tradeId: 'explicit.stat_3070577277',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Torment Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_scarab_domination_more_likely': {
    id: 232,
    tradeId: 'explicit.stat_2477998669',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Domination Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_scarab_anarchy_more_likely': {
    id: 233,
    tradeId: 'explicit.stat_723578929',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Anarchy Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_scarab_bestiary_more_likely': {
    id: 234,
    tradeId: 'explicit.stat_9949109',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Bestiary Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_scarab_divination_more_likely': {
    id: 235,
    tradeId: 'explicit.stat_1684527465',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Divination Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_scarab_legion_more_likely': {
    id: 236,
    tradeId: 'explicit.stat_1858240316',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Legion Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_scarab_delve_more_likely': {
    id: 237,
    tradeId: 'explicit.stat_1395445308',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Sulphite Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_scarab_blight_more_likely': {
    id: 238,
    tradeId: 'explicit.stat_3866432319',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Blight Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_scarab_abyss_more_likely': {
    id: 239,
    tradeId: 'explicit.stat_1849225887',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Abyss Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_scarab_ultimatum_more_likely': {
    id: 240,
    tradeId: 'explicit.stat_2263557454',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Ultimatum Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_scarab_delirium_more_likely': {
    id: 241,
    tradeId: 'explicit.stat_1571899068',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Delirium Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_scarab_ritual_more_likely': {
    id: 242,
    tradeId: 'explicit.stat_2810822634',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Ritual Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_scarab_harvest_more_likely': {
    id: 243,
    tradeId: 'explicit.stat_316950976',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Harvest Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_scarab_betrayal_more_likely': {
    id: 244,
    tradeId: 'explicit.stat_1048062553',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Betrayal Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_scarab_incursion_more_likely': {
    id: 245,
    tradeId: 'explicit.stat_1215465898',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Incursion Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_scarab_expedition_more_likely': {
    id: 246,
    tradeId: 'explicit.stat_46751559',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Expedition Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_scarab_settlers_more_likely': {
    id: 247,
    tradeId: 'explicit.stat_3346769137',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Kalguuran Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'prefix_noble_strongbox_increased_chance': {
    id: 248,
    tradeId: 'explicit.stat_2388936716',
    description: 'Your Maps have +(60–80)% chance to contain a Strongbox',
    range: [60, 80],
    contentType: ContentType.STRONGBOXES,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'suffix_noble_strongbox_additional_pack_chance': {
    id: 249,
    tradeId: 'explicit.stat_403369937',
    description: 'Strongboxes in your Maps have (40–60)% chance to be guarded by an additional Pack of Monsters',
    range: [40, 60],
    contentType: ContentType.STRONGBOXES,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'suffix_noble_strongbox_item_quantity': {
    id: 250,
    tradeId: 'explicit.stat_1054904554',
    description: '(15–20)% increased Quantity of Items contained in Strongboxes in your Maps',
    range: [15, 20],
    contentType: ContentType.STRONGBOXES,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'prefix_noble_map_boss_synthesis_map_drop_chance': {
    id: 251,
    tradeId: 'explicit.stat_4098976931',
    description: '+(1.2–1.8)% chance for a Synthesis Map to drop from Final Map Boss in each Map (Tier 14+)',
    range: [1.2, 1.8],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'prefix_noble_torment_additional_chance': {
    id: 252,
    tradeId: 'explicit.stat_846433713',
    description: 'Your Maps have a (60–80)% chance to be haunted by an additional Tormented Spirit',
    range: [60, 80],
    contentType: ContentType.TORMENTED_SPIRITS,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'prefix_noble_torment_increased_chance': {
    id: 253,
    tradeId: 'explicit.stat_2750973094',
    description: 'Your Maps have +(12–18)% chance to be haunted by a Tormented Spirit',
    range: [12, 18],
    contentType: ContentType.TORMENTED_SPIRITS,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'suffix_noble_torment_escape_chance': {
    id: 254,
    tradeId: 'explicit.stat_4028829918',
    description: 'Tormented Spirits have a (1–2)% chance to be set free when Possessed Monsters are slain',
    range: [1, 2],
    contentType: ContentType.TORMENTED_SPIRITS,
    idolSizes: [IdolSize.NOBLE],
    type: 'suffix'
  },
  'prefix_noble_torment_map_boss_surrounded_by_spirit_chance': {
    id: 255,
    tradeId: 'explicit.stat_906368454',
    description: 'Map Bosses have (6–8)% chance to be surrounded by Tormented Spirits',
    range: [6, 8],
    contentType: ContentType.TORMENTED_SPIRITS,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'prefix_noble_map_vaal_side_area_chance': {
    id: 256,
    tradeId: 'explicit.stat_2156201537',
    description: 'Your Maps have +(5–8)% chance to contain a Vaal Side Area',
    range: [5, 8],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'prefix_noble_map_contains_adjacent_map_chance': {
    id: 257,
    tradeId: 'explicit.stat_3885184473',
    description: '(5–8)% chance for one Monster in each of your Maps to drop an additional connected Map',
    range: [5, 8],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.NOBLE],
    type: 'prefix'
  },
  'prefix_kamasan_additional_abyss_chance': {
    id: 258,
    tradeId: 'explicit.stat_4278144676',
    description: 'Your Maps have +(30–45)% chance to contain an Abyss',
    range: [30, 45],
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'prefix_kamasan_increased_abyss_chance': {
    id: 259,
    tradeId: 'explicit.stat_4111037980',
    description: 'Your Maps have (144–180)% increased chance to contain an Abyss',
    range: [144, 180],
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'suffix_kamasan_increased_abyss_monsters': {
    id: 260,
    tradeId: 'explicit.stat_944630113',
    description: 'Abysses in your Maps spawn (12–18)% increased Monsters',
    range: [12, 18],
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_increased_abyss_monster_experience': {
    id: 261,
    tradeId: 'explicit.stat_2975078312',
    description: 'Abyss Monsters in your Maps grant (30–40)% increased Experience',
    range: [30, 40],
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_abyss_path_spawn100_percent_increased_monsters_chance': {
    id: 262,
    tradeId: 'explicit.stat_211873159',
    description: 'Abyss Cracks in your Maps have (8–12)% chance to spawn 100% increased Monsters',
    range: [8, 12],
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_abyss_chasm_spawn100_percent_increased_monsters_chance': {
    id: 263,
    tradeId: 'explicit.stat_1086708760',
    description: 'Abyss Pits in your Maps have (8–12)% chance to spawn 100% increased Monsters',
    range: [8, 12],
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_abyss_at_least_magic_per_chasm_chance': {
    id: 264,
    tradeId: 'explicit.stat_440232197',
    description: 'Abyss Cracks in your Maps have (3–5)% chance to spawn all Monsters as Magic for each prior Pit in that Abyss',
    range: [3, 5],
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'prefix_kamasan_additional_incursion_chance': {
    id: 265,
    tradeId: 'explicit.stat_2709296039',
    description: 'Your Maps have +(30–45)% chance to contain Alva',
    range: [30, 45],
    contentType: ContentType.INCURSION,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'prefix_kamasan_increased_incursion_chance': {
    id: 266,
    tradeId: 'explicit.stat_3629418990',
    description: 'Your Maps have (144–180)% increased chance to contain Alva',
    range: [144, 180],
    contentType: ContentType.INCURSION,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'suffix_kamasan_incursion_all_monsters_magic_chance': {
    id: 267,
    tradeId: 'explicit.stat_787321478',
    description: 'Incursions in your Maps have (15–25)% chance for all Monsters to be at least Magic',
    range: [15, 25],
    contentType: ContentType.INCURSION,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'prefix_kamasan_anarchy_additional_exiles_chance': {
    id: 268,
    tradeId: 'explicit.stat_1123357133',
    description: 'Your Maps have a (30–45)% chance to contain an additional Rogue Exile',
    range: [30, 45],
    contentType: ContentType.ROGUE_EXILES,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'prefix_kamasan_anarchy_exile_chance': {
    id: 269,
    tradeId: 'explicit.stat_2974922599',
    description: 'Your Maps have +(12–18)% chance to contain a Rogue Exile',
    range: [12, 18],
    contentType: ContentType.ROGUE_EXILES,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'suffix_kamasan_anarchy_exile_increased_rarity': {
    id: 270,
    tradeId: 'explicit.stat_4105955491',
    description: '(30–40)% increased Rarity of Items Dropped by Wild Rogue Exiles in your Maps',
    range: [30, 40],
    contentType: ContentType.ROGUE_EXILES,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_anarchy_exile_additional_currency_chance': {
    id: 271,
    tradeId: 'explicit.stat_2646493318',
    description: 'Rogue Exiles in your Maps have (15–20)% chance to drop an additional Currency Item',
    range: [15, 20],
    contentType: ContentType.ROGUE_EXILES,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'prefix_kamasan_bestiary_additional_chance': {
    id: 272,
    tradeId: 'explicit.stat_1566972708',
    description: 'Your Maps have +(30–45)% chance to contain Einhar',
    range: [30, 45],
    contentType: ContentType.BESTIARY,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'prefix_kamasan_bestiary_increased_chance': {
    id: 273,
    tradeId: 'explicit.stat_1301096166',
    description: 'Your Maps have (144–180)% increased chance to contain Einhar',
    range: [144, 180],
    contentType: ContentType.BESTIARY,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'suffix_kamasan_bestiary_addtional_red_beast_chance': {
    id: 274,
    tradeId: 'explicit.stat_1044770866',
    description: 'Your Maps that contain capturable Beasts have (12–18)% chance to contain an additional Red Beast',
    range: [12, 18],
    contentType: ContentType.BESTIARY,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_bestiary_einhar_more_damage_to_uniques': {
    id: 275,
    tradeId: 'explicit.stat_1709437962',
    description: 'Einhar deals (600–800)% more Damage to Unique Monsters in your Maps',
    range: [600, 800],
    contentType: ContentType.BESTIARY,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_beastiary_einhar_cooldown_recovery': {
    id: 276,
    tradeId: 'explicit.stat_1288839550',
    description: 'Einhar has (60–80)% increased Cooldown Recovery Rate in your Maps',
    range: [60, 80],
    contentType: ContentType.BESTIARY,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'prefix_kamasan_beyond_additional_chance': {
    id: 277,
    tradeId: 'explicit.stat_3438840900',
    description: '(30–45)% chance for your Maps to attract Beyond Demons',
    range: [30, 45],
    contentType: ContentType.BEYOND,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'suffix_kamasan_beyond_increased_portal_search_radius': {
    id: 278,
    tradeId: 'explicit.stat_1454090489',
    description: 'Beyond Portals in your Maps have (20–25)% increased Merging Radius',
    range: [20, 25],
    contentType: ContentType.BEYOND,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_beyond_increased_monster_tainted_currency_quantity': {
    id: 279,
    tradeId: 'explicit.stat_1289727785',
    description: '(10–15)% increased Quantity of Tainted Currency dropped by Beyond Demons in your Maps',
    range: [10, 15],
    contentType: ContentType.BEYOND,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_blight_lane_additional_chest_chance': {
    id: 280,
    tradeId: 'explicit.stat_3986662538',
    description: 'Lanes of Blight Encounters in your Maps have (6–8)% chance for an additional Reward Chest',
    range: [6, 8],
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'prefix_kamasan_blight_additional_encounter_chance': {
    id: 281,
    tradeId: 'explicit.stat_764545335',
    description: 'Your Maps have +(30–45)% chance to contain a Blight Encounter',
    range: [30, 45],
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'prefix_kamasan_blight_additional_chance': {
    id: 282,
    tradeId: 'explicit.stat_1393318927',
    description: 'Your Maps have (144–180)% increased chance to contain a Blight Encounter',
    range: [144, 180],
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'suffix_kamasan_blight_chest_additional_drop_chance': {
    id: 283,
    tradeId: 'explicit.stat_1260718722',
    description: '(15–25)% chance for Blight Chests to contain an additional Reward',
    range: [15, 25],
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_blight_boss_additional_reward_chance': {
    id: 284,
    tradeId: 'explicit.stat_393389663',
    description: 'Blight Bosses in your Maps have (14–18)% chance to add an additional Reward Chest to their Lane',
    range: [14, 18],
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_blight_chest_oil_chance': {
    id: 285,
    tradeId: 'explicit.stat_1254426365',
    description: 'Blighted Chests in your Maps have (25–35)% increased chance to contain an Oil',
    range: [25, 35],
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_blight_monster_spawn_rate': {
    id: 286,
    tradeId: 'explicit.stat_1837341489',
    description: 'Blight Monsters in your Maps spawn (40–60)% faster',
    range: [40, 60],
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_cleansing_fire_monster_influence_item_drop_chance': {
    id: 287,
    tradeId: 'explicit.stat_532540562',
    description: 'Monsters Influenced by The Searing Exarch in your Maps have (0.5–0.7)% chance to drop an Item with a Searing Exarch Implicit Modifier',
    range: [0.5, 0.7],
    contentType: ContentType.SEARING_EXARCH,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_conqueror_influence_pack_size': {
    id: 288,
    tradeId: 'explicit.stat_2459732614',
    description: 'Monster Packs Influenced by Conquerors in your Maps have (8–12)% increased Pack Size',
    range: [8, 12],
    contentType: ContentType.CONQUERORS,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'prefix_kamasan_delirium_additional_chance': {
    id: 289,
    tradeId: 'explicit.stat_1808954678',
    description: 'Your Maps have +(30–45)% chance to contain a Mirror of Delirium',
    range: [30, 45],
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'prefix_kamasan_delirium_increased_chance': {
    id: 290,
    tradeId: 'explicit.stat_3573600538',
    description: 'Your Maps have (144–180)% increased chance to contain a Mirror of Delirium',
    range: [144, 180],
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'suffix_kamasan_delirium_secondary_wave_acceleration': {
    id: 291,
    tradeId: 'explicit.stat_3350944114',
    description: 'Delirium Fog in your Maps dissipates (2–5)% slower',
    range: [2, 5],
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_delirium_boss_unique_cluster_jewel_chance': {
    id: 292,
    tradeId: 'explicit.stat_615948723',
    description: 'Delirium Bosses in your Maps have (30–40)% increased chance to drop Unique Cluster Jewels',
    range: [30, 40],
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_delirium_monster_cluster_jewel_drop_chance': {
    id: 293,
    tradeId: 'explicit.stat_3580714718',
    description: 'Delirium Monsters in your Maps have (15–25)% increased chance to drop Cluster Jewels',
    range: [15, 25],
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_delirium_cluster_jewel_rare_corrupted_chance': {
    id: 294,
    tradeId: 'explicit.stat_1975134334',
    description: 'Cluster Jewels from Delirium Rewards have a (6–8)% chance to be Rare and Corrupted',
    range: [6, 8],
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_delve_increased_sulphite': {
    id: 295,
    tradeId: 'explicit.stat_4276927142',
    description: 'Voltaxic Sulphite Veins and Chests in your Maps contain (8–10)% increased Sulphite',
    range: [8, 10],
    contentType: ContentType.DELVE,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'prefix_kamasan_delve_additional_chance': {
    id: 296,
    tradeId: 'explicit.stat_4267923742',
    description: 'Your Maps have +(30–45)% chance to contain Niko',
    range: [30, 45],
    contentType: ContentType.DELVE,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'prefix_kamasan_delve_increased_chance': {
    id: 297,
    tradeId: 'explicit.stat_399319107',
    description: 'Your Maps have (144–180)% increased chance to contain Niko',
    range: [144, 180],
    contentType: ContentType.DELVE,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'suffix_kamasan_delve_movement_speed_per_sulphite_mined': {
    id: 298,
    tradeId: 'explicit.stat_1774735706',
    description: 'You gain (8–12)% increased Movement Speed per stack of Sulphite Intoxication',
    range: [8, 12],
    contentType: ContentType.DELVE,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'prefix_kamasan_shrine_increased_chance': {
    id: 299,
    tradeId: 'explicit.stat_2571125745',
    description: 'Your Maps have +(12–18)% chance to contain a Shrine',
    range: [12, 18],
    contentType: ContentType.SHRINES,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'prefix_kamasan_shrine_additional_chance': {
    id: 300,
    tradeId: 'explicit.stat_1260233365',
    description: 'Your Maps have a (60–80)% chance to contain an additional Shrine',
    range: [60, 80],
    contentType: ContentType.SHRINES,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'suffix_kamasan_shrine_buff_effect': {
    id: 301,
    tradeId: 'explicit.stat_1773503150',
    description: '(25–35)% increased effect of Shrine Buffs on players granted by Shrines in your Maps',
    range: [25, 35],
    contentType: ContentType.SHRINES,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_zana_influence_memory_tear_chance': {
    id: 302,
    tradeId: 'explicit.stat_4016588303',
    description: '(10–20)% increased chance for your Maps to contain Memory Tears (Tier 16+)',
    range: [10, 20],
    contentType: ContentType.ZANA,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_zana_influence_anger_boss_chance': {
    id: 303,
    tradeId: 'explicit.stat_1493453364',
    description: '(15–25)% increased chance for Memory Threads to lead towards the Incarnation of Fear',
    range: [15, 25],
    contentType: ContentType.ZANA,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_zana_influence_ignorance_boss_chance': {
    id: 304,
    tradeId: 'explicit.stat_3126598962',
    description: '(15–25)% increased chance for Memory Threads to lead towards the Incarnation of Neglect',
    range: [15, 25],
    contentType: ContentType.ZANA,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_zana_influence_benevolence_boss_chance': {
    id: 305,
    tradeId: 'explicit.stat_1415269999',
    description: '(15–25)% increased chance for Memory Threads to lead towards the Incarnation of Dread',
    range: [15, 25],
    contentType: ContentType.ZANA,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'prefix_kamasan_boss_shaper_map_drop_chance': {
    id: 306,
    tradeId: 'explicit.stat_931052937',
    description: 'Final Map Boss in each Map has +(1.8–2.4)% chance to drop a Shaper Guardian Map (Tier 14+)',
    range: [1.8, 2.4],
    contentType: ContentType.ELDER,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'prefix_kamasan_boss_elder_map_drop_chance': {
    id: 307,
    tradeId: 'explicit.stat_1377454569',
    description: 'Final Map Boss in each Map has +(1.8–2.4)% chance to drop an Elder Guardian Map (Tier 14+)',
    range: [1.8, 2.4],
    contentType: ContentType.ELDER,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'prefix_kamasan_essence_increased_chance': {
    id: 308,
    tradeId: 'explicit.stat_4098286334',
    description: 'Your Maps have +(12–18)% chance to contain an Imprisoned Monster',
    range: [12, 18],
    contentType: ContentType.ESSENCE,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'prefix_kamasan_essence_additional_monolith_chance': {
    id: 309,
    tradeId: 'explicit.stat_2039130613',
    description: 'Your Maps have (60–80)% chance to contain an additional Imprisoned Monster',
    range: [60, 80],
    contentType: ContentType.ESSENCE,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'suffix_kamasan_essence_monoliths_have_corrutption_essence_chance': {
    id: 310,
    tradeId: 'explicit.stat_1439991839',
    description: 'Monsters Imprisoned by Essences have a (20–25)% chance to contain a Remnant of Corruption',
    range: [20, 25],
    contentType: ContentType.ESSENCE,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_expedition_artifact_quantity': {
    id: 311,
    tradeId: 'explicit.stat_4219583418',
    description: '(10–15)% increased quantity of Artifacts dropped by Monsters',
    range: [10, 15],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'prefix_kamasan_expedition_additional_chance': {
    id: 312,
    tradeId: 'explicit.stat_4154778375',
    description: 'Your Maps have +(30–45)% chance to contain an Expedition Encounter',
    range: [30, 45],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'prefix_kamasan_expedition_increased_chance': {
    id: 313,
    tradeId: 'explicit.stat_1561678231',
    description: 'Your Maps have (144–180)% increased chance to contain an Expedition Encounter',
    range: [144, 180],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'suffix_kamasan_expedition_increased_explosives': {
    id: 314,
    tradeId: 'explicit.stat_3051490307',
    description: '(6–10)% increased number of Explosives in your Maps',
    range: [6, 10],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_expedition_reroll_currency_quantity': {
    id: 315,
    tradeId: 'explicit.stat_2934907255',
    description: '(15–20)% increased Quantity of Vendor Refresh Currencies dropped by Monsters in your Maps',
    range: [15, 20],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_expedition_fuse_burn_time': {
    id: 316,
    tradeId: 'explicit.stat_3907743910',
    description: 'Expedition Detonation Chains in your Maps travel (12–18)% slower',
    range: [12, 18],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_harbinger_additional_currency_shard_stacks': {
    id: 317,
    tradeId: 'explicit.stat_1413020589',
    description: 'Harbingers in your Maps have (40–60)% chance to drop an additional Stack of Currency Shards',
    range: [40, 60],
    contentType: ContentType.HARBINGER,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'prefix_kamasan_harbinger_additional_harbinger_chance': {
    id: 318,
    tradeId: 'explicit.stat_266448395',
    description: 'Your Maps have a (60–80)% chance to contain an additional Harbinger',
    range: [60, 80],
    contentType: ContentType.HARBINGER,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'prefix_kamasan_harvest_additional_chance': {
    id: 319,
    tradeId: 'explicit.stat_1145451936',
    description: 'Your Maps have +(30–45)% chance to contain The Sacred Grove',
    range: [30, 45],
    contentType: ContentType.HARVEST,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'prefix_kamasan_harvest_increased_chance': {
    id: 320,
    tradeId: 'explicit.stat_2936740844',
    description: 'Your Maps have (144–180)% increased chance to contain The Sacred Grove',
    range: [144, 180],
    contentType: ContentType.HARVEST,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'suffix_kamasan_harvest_boss_encounter_chance': {
    id: 321,
    tradeId: 'explicit.stat_1505882627',
    description: 'Harvest Crops in your Maps have (35–45)% increased chance to contain a Tier 4 Plant',
    range: [35, 45],
    contentType: ContentType.HARVEST,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_harvest_tier_three_chance': {
    id: 322,
    tradeId: 'explicit.stat_2992379436',
    description: 'Harvest Crops in your Maps have (25–35)% increased chance to contain Tier 3 Plants',
    range: [25, 35],
    contentType: ContentType.HARVEST,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'prefix_kamasan_heist_additional_cache_chance': {
    id: 323,
    tradeId: 'explicit.stat_1975869602',
    description: 'Your Maps have +(30–45)% chance to contain a Smuggler\'s Cache',
    range: [30, 45],
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'prefix_kamasan_heist_increased_cache_chance': {
    id: 324,
    tradeId: 'explicit.stat_4069523014',
    description: 'Your Maps have (144–180)% increased chance to contain a Smuggler\'s Cache',
    range: [144, 180],
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'suffix_kamasan_heist_level_three_job_chance': {
    id: 325,
    tradeId: 'explicit.stat_3688987182',
    description: 'Heist Contracts found in your Maps are (75–125)% more likely to require level 3 Jobs',
    range: [75, 125],
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_heist_level_four_job_chance': {
    id: 326,
    tradeId: 'explicit.stat_3688987182',
    description: 'Heist Contracts found in your Maps are (75–125)% more likely to require level 4 Jobs',
    range: [75, 125],
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_heist_level_five_job_chance': {
    id: 327,
    tradeId: 'explicit.stat_3688987182',
    description: 'Heist Contracts found in your Maps are (75–125)% more likely to require level 5 Jobs',
    range: [75, 125],
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_heist_second_cache_chance': {
    id: 328,
    tradeId: 'explicit.stat_549540629',
    description: 'Your Maps that contain Smuggler\'s Caches have a (25–35)% chance to contain an additional Smuggler\'s Cache',
    range: [25, 35],
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'prefix_kamasan_heist_increased_blueprint_chance': {
    id: 329,
    tradeId: 'explicit.stat_619910101',
    description: '(20–25)% increased Blueprints found in your Maps',
    range: [20, 25],
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'prefix_kamasan_betrayal_additional_chance': {
    id: 330,
    tradeId: 'explicit.stat_527292219',
    description: 'Your Maps have +(30–45)% chance to contain Jun',
    range: [30, 45],
    contentType: ContentType.BETRAYAL,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'prefix_kamasan_betrayal_increased_chance': {
    id: 331,
    tradeId: 'explicit.stat_4116217552',
    description: 'Your Maps have (144–180)% increased chance to contain Jun',
    range: [144, 180],
    contentType: ContentType.BETRAYAL,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'suffix_kamasan_betrayal_bargin_option_chance': {
    id: 332,
    tradeId: 'explicit.stat_1259656520',
    description: 'Immortal Syndicate Members in your Maps are (120–160)% more likely to offer to Bargain for Items',
    range: [120, 160],
    contentType: ContentType.BETRAYAL,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_betrayal_target_item_rarity_per_equipment': {
    id: 333,
    tradeId: 'explicit.stat_4187085307',
    description: '(16–24)% increased Rarity of items from Defeated Syndicate Members in your Maps per Equipment Item they have',
    range: [16, 24],
    contentType: ContentType.BETRAYAL,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'prefix_kamasan_legion_additional_chance': {
    id: 334,
    tradeId: 'explicit.stat_1981273563',
    description: 'Your Maps have +(30–45)% chance to contain a Legion Encounter',
    range: [30, 45],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'prefix_kamasan_legion_increased_chance': {
    id: 335,
    tradeId: 'explicit.stat_310950600',
    description: 'Your Maps have (144–180)% increased chance to contain a Legion Encounter',
    range: [144, 180],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'suffix_kamasan_legion_sergeant_item_rarity': {
    id: 336,
    tradeId: 'explicit.stat_3617935793',
    description: '(100–150)% increased Rarity of Items Dropped by Legion Sergeants in your Maps',
    range: [100, 150],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_legion_duration': {
    id: 337,
    tradeId: 'explicit.stat_699122342',
    description: 'Legion Encounters in your Maps have (40–60)% increased Duration',
    range: [40, 60],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_legion_frozen_monsters_damage_taken': {
    id: 338,
    tradeId: 'explicit.stat_2596927667',
    description: 'Legion Monsters in your Maps take (30–40)% increased Damage while in Stasis',
    range: [30, 40],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_legion_pack_size': {
    id: 339,
    tradeId: 'explicit.stat_4183582609',
    description: 'Legion Monsters in your Maps have (10–15)% increased Pack Size',
    range: [10, 15],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'prefix_kamasan_ultimatum_increased_chance': {
    id: 340,
    tradeId: 'explicit.stat_880963174',
    description: 'Your Maps have (144–180)% increased chance to contain an Ultimatum Encounter',
    range: [144, 180],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'prefix_kamasan_ultimatum_additional_chance': {
    id: 341,
    tradeId: 'explicit.stat_1365687125',
    description: 'Your Maps have +(30–45)% chance to contain an Ultimatum Encounter',
    range: [30, 45],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'suffix_kamasan_ultimatum_defence_encounter_life': {
    id: 342,
    tradeId: 'explicit.stat_4281937233',
    description: 'Ultimatum Altars in your Maps have (30–40)% increased Life',
    range: [30, 40],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_ultimatum_conquer_encounter_radius': {
    id: 343,
    tradeId: 'explicit.stat_1805474879',
    description: 'Ultimatum Stone Circles in your Maps have (15–20)% increased radius',
    range: [15, 20],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_ultimatum_rewards_inscribed_chance': {
    id: 344,
    tradeId: 'explicit.stat_294140055',
    description: 'Ultimatum Rewards in your Maps have (25–35)% increased chance to be Inscribed Ultimatums',
    range: [25, 35],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_ultimatum_increased_survival_encounter_time': {
    id: 345,
    tradeId: 'explicit.stat_3099069648',
    description: 'Ultimatum Encounters in your Maps only requiring you to Survive have (3–5)% reduced duration',
    range: [3, 5],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_ultimatum_ultimatum_exterminate_reduced_monster_kills_required': {
    id: 346,
    tradeId: 'explicit.stat_340836576',
    description: 'Ultimatum Encounters in your Maps requiring you to Defeat waves of Enemies require killing (3–5)% reduced number of Enemies',
    range: [3, 5],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'prefix_kamasan_settlers_increased_chance': {
    id: 347,
    tradeId: '',
    description: 'Your Maps have (144–180)% increased chance to contain Ore Deposits',
    range: [144, 180],
    contentType: ContentType.SETTLERS,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'prefix_kamasan_settlers_additional_chance': {
    id: 348,
    tradeId: 'explicit.stat_2661886285',
    description: 'Your Maps have +(30–45)% chance to contain Ore Deposits',
    range: [30, 45],
    contentType: ContentType.SETTLERS,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'prefix_kamasan_ritual_additional_chance': {
    id: 349,
    tradeId: 'explicit.stat_1314822783',
    description: 'Your Maps have +(30–45)% chance to contain Ritual Altars',
    range: [30, 45],
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'prefix_kamasan_ritual_increased_chance': {
    id: 350,
    tradeId: 'explicit.stat_1777351949',
    description: 'Your Maps have (144–180)% increased chance to contain Ritual Altars',
    range: [144, 180],
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'suffix_kamasan_ritual_increased_uber_rune_chance': {
    id: 351,
    tradeId: 'explicit.stat_2172921782',
    description: '(50–75)% increased chance of Ritual Altars with Special Rewards',
    range: [50, 75],
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_ritual_rewards_from_rerolls_no_cost_chance': {
    id: 352,
    tradeId: 'explicit.stat_937291386',
    description: 'Favours Rerolled at Ritual Altars in your Maps have (0.8–1.2)% chance to cost no Tribute',
    range: [0.8, 1.2],
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_ritual_increased_maximum_monsters_alive': {
    id: 353,
    tradeId: 'explicit.stat_2219456349',
    description: 'Ritual Altars in your Maps can have (15–25)% increased number of Spawned Monsters at once',
    range: [15, 25],
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_ritual_splinters_increased_stack_size': {
    id: 354,
    tradeId: 'explicit.stat_1724306833',
    description: 'Ritual Splinters offered at Ritual Altars in your Maps have (20–25)% increased Stack Size',
    range: [20, 25],
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_scarab_map_more_likely': {
    id: 355,
    tradeId: 'explicit.stat_1762451150',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Cartography Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_scarab_strongbox_more_likely': {
    id: 356,
    tradeId: 'explicit.stat_3017211510',
    description: 'Scarabs found in your Maps have (60–80)% increased chance to be Ambush Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_scarab_unique_more_likely': {
    id: 357,
    tradeId: 'explicit.stat_2584308379',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Titanic Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_scarab_harbinger_more_likely': {
    id: 358,
    tradeId: 'explicit.stat_1560748306',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Harbinger Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_scarab_beyond_more_likely': {
    id: 359,
    tradeId: 'explicit.stat_2507275343',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Beyond Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_scarab_essence_more_likely': {
    id: 360,
    tradeId: 'explicit.stat_751635784',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Essence Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_scarab_torment_more_likely': {
    id: 361,
    tradeId: 'explicit.stat_3070577277',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Torment Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_scarab_domination_more_likely': {
    id: 362,
    tradeId: 'explicit.stat_2477998669',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Domination Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_scarab_anarchy_more_likely': {
    id: 363,
    tradeId: 'explicit.stat_723578929',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Anarchy Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_scarab_bestiary_more_likely': {
    id: 364,
    tradeId: 'explicit.stat_9949109',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Bestiary Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_scarab_divination_more_likely': {
    id: 365,
    tradeId: 'explicit.stat_1684527465',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Divination Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_scarab_legion_more_likely': {
    id: 366,
    tradeId: 'explicit.stat_1858240316',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Legion Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_scarab_delve_more_likely': {
    id: 367,
    tradeId: 'explicit.stat_1395445308',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Sulphite Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_scarab_blight_more_likely': {
    id: 368,
    tradeId: 'explicit.stat_3866432319',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Blight Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_scarab_abyss_more_likely': {
    id: 369,
    tradeId: 'explicit.stat_1849225887',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Abyss Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_scarab_ultimatum_more_likely': {
    id: 370,
    tradeId: 'explicit.stat_2263557454',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Ultimatum Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_scarab_delirium_more_likely': {
    id: 371,
    tradeId: 'explicit.stat_1571899068',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Delirium Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_scarab_ritual_more_likely': {
    id: 372,
    tradeId: '',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Ritual Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_scarab_harvest_more_likely': {
    id: 373,
    tradeId: '',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Harvest Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_scarab_betrayal_more_likely': {
    id: 374,
    tradeId: '',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Betrayal Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_scarab_incursion_more_likely': {
    id: 375,
    tradeId: '',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Incursion Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_scarab_expedition_more_likely': {
    id: 376,
    tradeId: '',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Expedition Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_scarab_settlers_more_likely': {
    id: 377,
    tradeId: '',
    description: 'Scarabs dropped in your Maps have (60–80)% increased chance to be Kalguuran Scarabs',
    range: [60, 80],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'prefix_kamasan_strongbox_increased_chance': {
    id: 378,
    tradeId: 'explicit.stat_2388936716',
    description: 'Your Maps have +(60–80)% chance to contain a Strongbox',
    range: [60, 80],
    contentType: ContentType.STRONGBOXES,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'suffix_kamasan_strongbox_additional_pack_chance': {
    id: 379,
    tradeId: 'explicit.stat_403369937',
    description: 'Strongboxes in your Maps have (40–60)% chance to be guarded by an additional Pack of Monsters',
    range: [40, 60],
    contentType: ContentType.STRONGBOXES,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'suffix_kamasan_strongbox_item_quantity': {
    id: 380,
    tradeId: 'explicit.stat_1054904554',
    description: '(15–20)% increased Quantity of Items contained in Strongboxes in your Maps',
    range: [15, 20],
    contentType: ContentType.STRONGBOXES,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'prefix_kamasan_map_boss_synthesis_map_drop_chance': {
    id: 381,
    tradeId: 'explicit.stat_4098976931',
    description: '+(1.2–1.8)% chance for a Synthesis Map to drop from Final Map Boss in each Map (Tier 14+)',
    range: [1.2, 1.8],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'prefix_kamasan_torment_additional_chance': {
    id: 382,
    tradeId: 'explicit.stat_846433713',
    description: 'Your Maps have a (60–80)% chance to be haunted by an additional Tormented Spirit',
    range: [60, 80],
    contentType: ContentType.TORMENTED_SPIRITS,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'prefix_kamasan_torment_increased_chance': {
    id: 383,
    tradeId: 'explicit.stat_2750973094',
    description: 'Your Maps have +(12–18)% chance to be haunted by a Tormented Spirit',
    range: [12, 18],
    contentType: ContentType.TORMENTED_SPIRITS,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'suffix_kamasan_torment_escape_chance': {
    id: 384,
    tradeId: 'explicit.stat_4028829918',
    description: 'Tormented Spirits have a (1–2)% chance to be set free when Possessed Monsters are slain',
    range: [1, 2],
    contentType: ContentType.TORMENTED_SPIRITS,
    idolSizes: [IdolSize.KAMASAN],
    type: 'suffix'
  },
  'prefix_kamasan_torment_map_boss_surrounded_by_spirit_chance': {
    id: 385,
    tradeId: 'explicit.stat_906368454',
    description: 'Map Bosses have (6–8)% chance to be surrounded by Tormented Spirits',
    range: [6, 8],
    contentType: ContentType.TORMENTED_SPIRITS,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'prefix_kamasan_map_vaal_side_area_chance': {
    id: 386,
    tradeId: 'explicit.stat_2156201537',
    description: 'Your Maps have +(5–8)% chance to contain a Vaal Side Area',
    range: [5, 8],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'prefix_kamasan_map_contains_adjacent_map_chance': {
    id: 387,
    tradeId: 'explicit.stat_3885184473',
    description: '(5–8)% chance for one Monster in each of your Maps to drop an additional connected Map',
    range: [5, 8],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.KAMASAN],
    type: 'prefix'
  },
  'prefix_burial_additional_abyss_chance': {
    id: 388,
    tradeId: 'explicit.stat_4278144676',
    description: 'Your Maps have +(40–60)% chance to contain an Abyss',
    range: [40, 60],
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'prefix_burial_increased_abyss_chance': {
    id: 389,
    tradeId: 'explicit.stat_4111037980',
    description: 'Your Maps have (192–240)% increased chance to contain an Abyss',
    range: [192, 240],
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'suffix_burial_increased_abyss_spire_chance': {
    id: 390,
    tradeId: 'explicit.stat_836430463',
    description: 'Abysses in your Maps that do not lead to an Abyssal Depths have (40–60)% increased chance to lead to a Stygian Spire',
    range: [40, 60],
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_increased_abyss_depths_chance': {
    id: 391,
    tradeId: 'explicit.stat_2722831300',
    description: 'Abysses in your Maps have (40–60)% increased chance to lead to an Abyssal Depths',
    range: [40, 60],
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_abyss_path_spawn_at_least_magic_chance': {
    id: 392,
    tradeId: 'explicit.stat_1388221282',
    description: 'Abyss Cracks in your Maps have (10–20)% chance to spawn all Monsters as at least Magic',
    range: [10, 20],
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_abyss_chasm_spawn_at_least_magic_chance': {
    id: 393,
    tradeId: 'explicit.stat_4157613372',
    description: 'Abyss Pits in your Maps have (10–20)% chance to spawn all Monsters as at least Magic',
    range: [10, 20],
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_incursion_additional_upgrade_non_resident': {
    id: 394,
    tradeId: 'explicit.stat_1346625818',
    description: 'Killing non-resident Architects in your Maps has (30–50)% chance to add an additional Upgrade Tier to the surviving Architect\'s Room',
    range: [30, 50],
    contentType: ContentType.INCURSION,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'prefix_burial_additional_incursion_chance': {
    id: 395,
    tradeId: 'explicit.stat_2709296039',
    description: 'Your Maps have +(40–60)% chance to contain Alva',
    range: [40, 60],
    contentType: ContentType.INCURSION,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'prefix_burial_increased_incursion_chance': {
    id: 396,
    tradeId: 'explicit.stat_3629418990',
    description: 'Your Maps have (192–240)% increased chance to contain Alva',
    range: [192, 240],
    contentType: ContentType.INCURSION,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'suffix_burial_anarchy_possessed': {
    id: 397,
    tradeId: 'explicit.stat_3034509000',
    description: 'Wild Rogue Exiles in your Maps have (75–100)% chance to be Possessed by a Tormented Spirit',
    range: [75, 100],
    contentType: ContentType.ROGUE_EXILES,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'prefix_burial_anarchy_additional_exiles_chance': {
    id: 398,
    tradeId: 'explicit.stat_1123357133',
    description: 'Your Maps have a (40–60)% chance to contain an additional Rogue Exile',
    range: [40, 60],
    contentType: ContentType.ROGUE_EXILES,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'prefix_burial_anarchy_exile_chance': {
    id: 399,
    tradeId: 'explicit.stat_2974922599',
    description: 'Your Maps have +(15–25)% chance to contain a Rogue Exile',
    range: [15, 25],
    contentType: ContentType.ROGUE_EXILES,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'suffix_burial_bestiary_additional_yellow_beasts': {
    id: 400,
    tradeId: 'explicit.stat_1320130840',
    description: 'Your Maps that contain capturable Beasts contain (3–4) additional Yellow Beasts',
    range: [3, 4],
    contentType: ContentType.BESTIARY,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'prefix_burial_bestiary_additional_chance': {
    id: 401,
    tradeId: 'explicit.stat_1566972708',
    description: 'Your Maps have +(40–60)% chance to contain Einhar',
    range: [40, 60],
    contentType: ContentType.BESTIARY,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'prefix_burial_bestiary_increased_chance': {
    id: 402,
    tradeId: 'explicit.stat_1301096166',
    description: 'Your Maps have (192–240)% increased chance to contain Einhar',
    range: [192, 240],
    contentType: ContentType.BESTIARY,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'suffix_burial_bestiary_chance_to_not_consume_beast': {
    id: 403,
    tradeId: 'explicit.stat_3773225751',
    description: 'Red Beasts captured in your Maps have a (40–60)% chance to gain a Modifier that provides a chance to not to be consumed when sacrificed at the Blood Altar',
    range: [40, 60],
    contentType: ContentType.BESTIARY,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_bestiary_red_beast_pairs_chance': {
    id: 404,
    tradeId: 'explicit.stat_543949956',
    description: 'Red Beasts in your Maps have (16–24)% chance to appear in Pairs',
    range: [16, 24],
    contentType: ContentType.BESTIARY,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'prefix_burial_beyond_additional_chance': {
    id: 405,
    tradeId: 'explicit.stat_3438840900',
    description: '(40–60)% chance for your Maps to attract Beyond Demons',
    range: [40, 60],
    contentType: ContentType.BEYOND,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'suffix_burial_beyond_increased_monster_experience': {
    id: 406,
    tradeId: 'explicit.stat_3791540252',
    description: 'Beyond Demons in your Maps grant (20–30)% increased Experience',
    range: [20, 30],
    contentType: ContentType.BEYOND,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_beyond_increased_boss_spawn_chance': {
    id: 407,
    tradeId: 'explicit.stat_4180165115',
    description: 'Beyond Portals in your Maps have (25–35)% increased chance to spawn a Unique Boss',
    range: [25, 35],
    contentType: ContentType.BEYOND,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_beyond_more_demon_faction_divination_card_quantity': {
    id: 408,
    tradeId: 'explicit.stat_1340524145',
    description: '(20–25)% more Divination Cards found from Beyond Demons in your Maps that are followers of K\'Tash',
    range: [20, 25],
    contentType: ContentType.BEYOND,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_beyond_more_pale_faction_currency_quantity': {
    id: 409,
    tradeId: 'explicit.stat_3062743459',
    description: '(20–25)% more Basic Currency Items found from Beyond Demons in your Maps that are followers of Beidat',
    range: [20, 25],
    contentType: ContentType.BEYOND,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_beyond_more_flesh_faction_unique_quantity': {
    id: 410,
    tradeId: 'explicit.stat_303527630',
    description: '(20–25)% more Unique Items found from Beyond Demons in your Maps that are followers of Ghorr',
    range: [20, 25],
    contentType: ContentType.BEYOND,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'prefix_burial_blight_additional_encounter_chance': {
    id: 411,
    tradeId: 'explicit.stat_764545335',
    description: 'Your Maps have +(40–60)% chance to contain a Blight Encounter',
    range: [40, 60],
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'prefix_burial_blight_additional_chance': {
    id: 412,
    tradeId: 'explicit.stat_1393318927',
    description: 'Your Maps have (192–240)% increased chance to contain a Blight Encounter',
    range: [192, 240],
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'suffix_burial_blight_more_pack_size': {
    id: 413,
    tradeId: 'explicit.stat_4091793171',
    description: 'Blight Encounters in your Maps spawn (25–35)% more Non-Unique Monsters',
    range: [25, 35],
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_blight_oil_higher_tier_chance': {
    id: 414,
    tradeId: 'explicit.stat_3259960466',
    description: 'Oils found in your Maps have (20–25)% chance to be 1 tier higher',
    range: [20, 25],
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_blight_monsters_take_increased_damage': {
    id: 415,
    tradeId: 'explicit.stat_3594607722',
    description: 'Blight Monsters in your Maps take (30–40)% increased Damage',
    range: [30, 40],
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_cleansing_fire_altar_spawn_chance_on_influence_appearance': {
    id: 416,
    tradeId: 'explicit.stat_3179686508',
    description: '(40–60)% chance to spawn a Searing Exarch Altar when the Influence of The Searing Exarch first appears in your Maps',
    range: [40, 60],
    contentType: ContentType.SEARING_EXARCH,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'prefix_burial_delirium_additional_chance': {
    id: 417,
    tradeId: 'explicit.stat_1808954678',
    description: 'Your Maps have +(40–60)% chance to contain a Mirror of Delirium',
    range: [40, 60],
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'prefix_burial_delirium_increased_chance': {
    id: 418,
    tradeId: 'explicit.stat_3573600538',
    description: 'Your Maps have (192–240)% increased chance to contain a Mirror of Delirium',
    range: [192, 240],
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'suffix_burial_delirium_faster_depth_increase': {
    id: 419,
    tradeId: 'explicit.stat_1769611692',
    description: 'Delirium in your Maps increases (35–50)% faster with distance from the mirror',
    range: [35, 50],
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_delirium_secondary_wave_delay': {
    id: 420,
    tradeId: 'explicit.stat_1174954559',
    description: 'Delirium Fog in your Maps lasts (10–15) additional seconds before dissipating',
    range: [10, 15],
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_delirium_additional_delirium_orb_chance': {
    id: 421,
    tradeId: 'explicit.stat_2901714012',
    description: 'Delirium Rewards in your Maps have (8–12)% increased chance to give Delirium Orbs',
    range: [8, 12],
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'prefix_burial_delve_additional_chance': {
    id: 422,
    tradeId: 'explicit.stat_4267923742',
    description: 'Your Maps have +(40–60)% chance to contain Niko',
    range: [40, 60],
    contentType: ContentType.DELVE,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'prefix_burial_delve_increased_chance': {
    id: 423,
    tradeId: 'explicit.stat_399319107',
    description: 'Your Maps have (192–240)% increased chance to contain Niko',
    range: [192, 240],
    contentType: ContentType.DELVE,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'suffix_burial_delve_double_sulphite_chance': {
    id: 424,
    tradeId: 'explicit.stat_1174549622',
    description: 'Voltaxic Sulphite Veins and Chests in your Maps have (4–6)% chance to contain double Sulphite',
    range: [4, 6],
    contentType: ContentType.DELVE,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_delve_damager_per_sulphite_mined': {
    id: 425,
    tradeId: 'explicit.stat_1280291906',
    description: 'You gain (30–40)% increased Damage per stack of Sulphite Intoxication',
    range: [30, 40],
    contentType: ContentType.DELVE,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'prefix_burial_shrine_num': {
    id: 426,
    tradeId: 'explicit.stat_1468737867',
    description: 'Your Maps contain an additional Shrine',
    range: [1, 1],
    contentType: ContentType.SHRINES,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'prefix_burial_shrine_increased_chance': {
    id: 427,
    tradeId: 'explicit.stat_2571125745',
    description: 'Your Maps have +(15–25)% chance to contain a Shrine',
    range: [15, 25],
    contentType: ContentType.SHRINES,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'suffix_burial_shrine_additional_pack_chance': {
    id: 428,
    tradeId: 'explicit.stat_1751949663',
    description: 'Shrines in your Maps have (40–60)% chance to be guarded by an additional Pack of Monsters',
    range: [40, 60],
    contentType: ContentType.SHRINES,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_shaper_influence_pack_size': {
    id: 429,
    tradeId: 'explicit.stat_3017475694',
    description: 'Monster Packs Influenced by The Shaper in your Maps have (15–25)% increased Pack Size',
    range: [15, 25],
    contentType: ContentType.SHAPER,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_elder_influence_pack_size': {
    id: 430,
    tradeId: 'explicit.stat_3275918621',
    description: 'Monster Packs Influenced by The Elder in your Maps have (15–25)% increased Pack Size',
    range: [15, 25],
    contentType: ContentType.ELDER,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_zana_influence_equipment_item_chance': {
    id: 431,
    tradeId: 'explicit.stat_4012065952',
    description: '(15–25)% increased chance for Equipment Items dropped in your Maps to have Memory Strands',
    range: [15, 25],
    contentType: ContentType.ZANA,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_zana_influence_map_item_chance': {
    id: 432,
    tradeId: 'explicit.stat_874254965',
    description: '(15–25)% increased chance for Maps found in your Maps to have Memory Influence',
    range: [15, 25],
    contentType: ContentType.ZANA,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'prefix_burial_essence_additional_monoliths': {
    id: 433,
    tradeId: 'explicit.stat_395808938',
    description: 'Your Maps contain (1–1) additional Imprisoned Monsters',
    range: [1, 1],
    contentType: ContentType.ESSENCE,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'prefix_burial_essence_increased_chance': {
    id: 434,
    tradeId: 'explicit.stat_4098286334',
    description: 'Your Maps have +(15–25)% chance to contain an Imprisoned Monster',
    range: [15, 25],
    contentType: ContentType.ESSENCE,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'suffix_burial_essence_three_additional_essence_chance': {
    id: 435,
    tradeId: 'explicit.stat_3011076420',
    description: 'Imprisoned Monsters in your Maps have (12–17)% chance to have 3 additional Essences',
    range: [12, 17],
    contentType: ContentType.ESSENCE,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'prefix_burial_expedition_additional_chance': {
    id: 436,
    tradeId: 'explicit.stat_4154778375',
    description: 'Your Maps have +(40–60)% chance to contain an Expedition Encounter',
    range: [40, 60],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'prefix_burial_expedition_increased_chance': {
    id: 437,
    tradeId: 'explicit.stat_1561678231',
    description: 'Your Maps have (192–240)% increased chance to contain an Expedition Encounter',
    range: [192, 240],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'suffix_burial_expedition_extra_relic_suffix_chance': {
    id: 438,
    tradeId: 'explicit.stat_1871805225',
    description: 'Remnants in your Maps have (25–35)% chance to have an additional Suffix Modifier',
    range: [25, 35],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_expedition_tujen_chance': {
    id: 439,
    tradeId: 'explicit.stat_2110260866',
    description: 'Expeditions in your Maps have (80–100)% increased chance to be led by Tujen',
    range: [80, 100],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_expedition_dannig_chance': {
    id: 440,
    tradeId: 'explicit.stat_3171270268',
    description: 'Expeditions in your Maps have (50–60)% increased chance to be led by Dannig',
    range: [50, 60],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_expedition_monsters_spawn_missing_percent_life': {
    id: 441,
    tradeId: 'explicit.stat_2684644644',
    description: 'Expedition Monsters in your Maps spawn with an additional (6–10)% of Life missing',
    range: [6, 10],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_expedition_rog_chance': {
    id: 442,
    tradeId: 'explicit.stat_140032086',
    description: 'Expeditions in your Maps have (80–100)% increased chance to be led by Rog',
    range: [80, 100],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_expedition_gwennen_chance': {
    id: 443,
    tradeId: 'explicit.stat_159709680',
    description: 'Expeditions in your Maps have (80–100)% increased chance to be led by Gwennen',
    range: [80, 100],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'prefix_burial_harbinger_extra_harbingers': {
    id: 444,
    tradeId: 'explicit.stat_504850499',
    description: 'Your Maps contain (1–1) additional Harbingers',
    range: [1, 1],
    contentType: ContentType.HARBINGER,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'prefix_burial_harbinger_additional_harbinger_chance': {
    id: 445,
    tradeId: 'explicit.stat_266448395',
    description: 'Your Maps have a (15–25)% chance to contain an additional Harbinger',
    range: [15, 25],
    contentType: ContentType.HARBINGER,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'suffix_burial_harbinger_powerful_chance': {
    id: 446,
    tradeId: 'explicit.stat_3511358099',
    description: 'Harbingers in your Maps have (20–25)% chance to be replaced by a powerful Harbinger boss',
    range: [20, 25],
    contentType: ContentType.HARBINGER,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'prefix_burial_harvest_additional_chance': {
    id: 447,
    tradeId: 'explicit.stat_1145451936',
    description: 'Your Maps have +(40–60)% chance to contain The Sacred Grove',
    range: [40, 60],
    contentType: ContentType.HARVEST,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'prefix_burial_harvest_increased_chance': {
    id: 448,
    tradeId: 'explicit.stat_2936740844',
    description: 'Your Maps have (192–240)% increased chance to contain The Sacred Grove',
    range: [192, 240],
    contentType: ContentType.HARVEST,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'suffix_burial_harvest_increased_lifeforce_dropped': {
    id: 449,
    tradeId: 'explicit.stat_3483648190',
    description: 'Harvest Monsters in your Maps drop (12–18)% increased Quantity of Lifeforce',
    range: [12, 18],
    contentType: ContentType.HARVEST,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_harvest_other_plot_not_whither_chance': {
    id: 450,
    tradeId: 'explicit.stat_1565587169',
    description: 'Harvests in your Maps have (8–12)% chance for the unchosen Crop to not wilt',
    range: [8, 12],
    contentType: ContentType.HARVEST,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_harvest_additional_plot_chance': {
    id: 451,
    tradeId: 'explicit.stat_1880405255',
    description: 'The Sacred Grove in your Maps has (40–60)% chance to contain an additional Harvest',
    range: [40, 60],
    contentType: ContentType.HARVEST,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'prefix_burial_heist_additional_cache_chance': {
    id: 452,
    tradeId: 'explicit.stat_1975869602',
    description: 'Your Maps have +(40–60)% chance to contain a Smuggler\'s Cache',
    range: [40, 60],
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'prefix_burial_heist_increased_cache_chance': {
    id: 453,
    tradeId: 'explicit.stat_4069523014',
    description: 'Your Maps have (192–240)% increased chance to contain a Smuggler\'s Cache',
    range: [192, 240],
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'suffix_burial_heist_cache_increased_contract_drop_chance': {
    id: 454,
    tradeId: 'explicit.stat_470630932',
    description: 'Smuggler\'s Caches in your Maps have (40–60)% increased chance to drop Contracts',
    range: [40, 60],
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_heist_cache_more_rogue_markers_per_opened_cache': {
    id: 455,
    tradeId: 'explicit.stat_2863957119',
    description: 'Smuggler\'s Caches drop (8–12)% more Rogue Markers for each Smuggler\'s Cache opened in the Area',
    range: [8, 12],
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_heist_high_value_contract_chance': {
    id: 456,
    tradeId: 'explicit.stat_2429444272',
    description: 'Heist Contracts found in your Maps are (70–90)% more likely to target High Value Targets',
    range: [70, 90],
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_heist_precious_value_contract_chance': {
    id: 457,
    tradeId: 'explicit.stat_1288317603',
    description: 'Heist Contracts found in your Maps are (45–65)% more likely to target Precious Targets',
    range: [45, 65],
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_betrayal_reinforcement_chance': {
    id: 458,
    tradeId: 'explicit.stat_2181411965',
    description: 'Immortal Syndicate Members in your Maps have (20–25)% increased chance to be accompanied by reinforcements',
    range: [20, 25],
    contentType: ContentType.BETRAYAL,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'prefix_burial_betrayal_additional_chance': {
    id: 459,
    tradeId: 'explicit.stat_527292219',
    description: 'Your Maps have +(40–60)% chance to contain Jun',
    range: [40, 60],
    contentType: ContentType.BETRAYAL,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'prefix_burial_betrayal_increased_chance': {
    id: 460,
    tradeId: 'explicit.stat_4116217552',
    description: 'Your Maps have (192–240)% increased chance to contain Jun',
    range: [192, 240],
    contentType: ContentType.BETRAYAL,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'suffix_burial_betrayal_targets_drop_additional_veiled_item_chance': {
    id: 461,
    tradeId: 'explicit.stat_4122946258',
    description: 'Immortal Syndicate Members in your Maps have (40–60)% chance to drop an additional Veiled Item',
    range: [40, 60],
    contentType: ContentType.BETRAYAL,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_betrayal_target_item_rarity': {
    id: 462,
    tradeId: 'explicit.stat_2695818040',
    description: '(40–60)% increased Rarity of Items Dropped by Immortal Syndicate Members in your Maps',
    range: [40, 60],
    contentType: ContentType.BETRAYAL,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'prefix_burial_ascendancy_additional_trial_chance': {
    id: 463,
    tradeId: 'explicit.stat_495465216',
    description: 'Your Maps have +(8–12)% chance to contain a Trial of Ascendancy',
    range: [8, 12],
    contentType: ContentType.LAB,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'prefix_burial_legion_additional_chance': {
    id: 464,
    tradeId: 'explicit.stat_1981273563',
    description: 'Your Maps have +(40–60)% chance to contain a Legion Encounter',
    range: [40, 60],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'prefix_burial_legion_increased_chance': {
    id: 465,
    tradeId: 'explicit.stat_310950600',
    description: 'Your Maps have (192–240)% increased chance to contain a Legion Encounter',
    range: [192, 240],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'suffix_burial_legion_karui_chance': {
    id: 466,
    tradeId: 'explicit.stat_4094461744',
    description: 'Legion Encounters in your Maps have (100–150)% increased chance to include a Karui army',
    range: [100, 150],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_legion_eternal_empire_chance': {
    id: 467,
    tradeId: 'explicit.stat_3825355878',
    description: 'Legion Encounters in your Maps have (100–150)% increased chance to include an Eternal Empire army',
    range: [100, 150],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_legion_vaal_chance': {
    id: 468,
    tradeId: 'explicit.stat_3218477736',
    description: 'Legion Encounters in your Maps have (80–120)% increased chance to include a Vaal army',
    range: [80, 120],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_legion_templar_chance': {
    id: 469,
    tradeId: 'explicit.stat_573511501',
    description: 'Legion Encounters in your Maps have (75–100)% increased chance to include a Templar army',
    range: [75, 100],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_legion_maraketh_chance': {
    id: 470,
    tradeId: 'explicit.stat_1611826374',
    description: 'Legion Encounters in your Maps have (60–80)% increased chance to include a Maraketh army',
    range: [60, 80],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_legion_splinter_dupe_chance': {
    id: 471,
    tradeId: 'explicit.stat_3374667389',
    description: 'Splinters dropped by Legion Monsters or contained in Legion Chests in your Maps have (15–20)% chance to be Duplicated',
    range: [15, 20],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_legion_chest_splinter_dupe_chance': {
    id: 472,
    tradeId: 'explicit.stat_1794950665',
    description: 'Splinters contained in Legion Chests in your Maps have (20–25)% chance to be Duplicated',
    range: [20, 25],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_legion_monster_splinter_dupe_chance': {
    id: 473,
    tradeId: 'explicit.stat_3473008748',
    description: 'Splinters dropped by Legion Monsters in your Maps have (20–25)% chance to be Duplicated',
    range: [20, 25],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_legion_monster_with_reward_additional_reward_chance': {
    id: 474,
    tradeId: 'explicit.stat_611792282',
    description: 'Legion Monsters in your Maps which have Rewards have (8–12)% chance to gain two additional Rewards, and if not have (15–20)% chance to gain one additional Reward',
    range: [8, 12],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'prefix_burial_map_boss_additional_adjacent_map_chance': {
    id: 475,
    tradeId: 'explicit.stat_729281484',
    description: 'Final Map Boss in each Map has (4–6)% chance to drop an additional connected Map',
    range: [4, 6],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'suffix_burial_fortune_favours_the_brave_pack_size': {
    id: 476,
    tradeId: 'explicit.stat_631736299',
    description: '(5–10)% increased Pack Size of your Maps affected by Fortune Favours the Brave',
    range: [5, 10],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_fortune_favours_the_brave_item_quantity': {
    id: 477,
    tradeId: 'explicit.stat_2619073196',
    description: '(5–10)% increased Quantity of Items found in your Maps affected by Fortune Favours the Brave',
    range: [5, 10],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_fortune_favours_the_brave_item_rarity': {
    id: 478,
    tradeId: 'explicit.stat_3433267351',
    description: '(10–20)% increased Rarity of Items found in your Maps affected by Fortune Favours the Brave',
    range: [10, 20],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'prefix_burial_ultimatum_increased_chance': {
    id: 479,
    tradeId: 'explicit.stat_880963174',
    description: 'Your Maps have (192–240)% increased chance to contain an Ultimatum Encounter',
    range: [192, 240],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'prefix_burial_ultimatum_additional_chance': {
    id: 480,
    tradeId: 'explicit.stat_1365687125',
    description: 'Your Maps have +(40–60)% chance to contain an Ultimatum Encounter',
    range: [40, 60],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'suffix_burial_ultimatum_increased_number_of_monsters': {
    id: 481,
    tradeId: 'explicit.stat_3025100555',
    description: 'Ultimatum Encounters in your Maps spawn (15–20)% increased number of Monsters',
    range: [15, 20],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_ultimatum_experience': {
    id: 482,
    tradeId: 'explicit.stat_3027114376',
    description: 'Ultimatum Monsters in your Maps grant (40–60)% increased Experience',
    range: [40, 60],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_ultimatum_inscribed_reward_unique_item_chance': {
    id: 483,
    tradeId: 'explicit.stat_2112979059',
    description: 'Inscribed Ultimatums found in your Maps have (40–60)% increased chance to reward Unique Items',
    range: [40, 60],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_ultimatum_inscribed_reward_currency_chance': {
    id: 484,
    tradeId: 'explicit.stat_2412871991',
    description: 'Inscribed Ultimatums found in your Maps have (40–60)% increased chance to reward Currency Items',
    range: [40, 60],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_ultimatum_inscribed_reward_divination_card_chance': {
    id: 485,
    tradeId: 'explicit.stat_2367226239',
    description: 'Inscribed Ultimatums found in your Maps have (40–60)% increased chance to reward Divination Cards',
    range: [40, 60],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'prefix_burial_settlers_increased_chance': {
    id: 486,
    tradeId: 'explicit.stat_2661886285',
    description: 'Your Maps have (192–240)% increased chance to contain Ore Deposits',
    range: [192, 240],
    contentType: ContentType.SETTLERS,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'prefix_burial_settlers_additional_chance': {
    id: 487,
    tradeId: 'explicit.stat_2661886285',
    description: 'Your Maps have +(40–60)% chance to contain Ore Deposits',
    range: [40, 60],
    contentType: ContentType.SETTLERS,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'suffix_burial_settlers_second_ore_chance': {
    id: 488,
    tradeId: 'explicit.stat_2843145261',
    description: 'Your Maps with Ore Deposits have (30–50)% increased chance to contain at least two Ore Deposits',
    range: [30, 50],
    contentType: ContentType.SETTLERS,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_settlers_bismuth_additional_modifier_chance': {
    id: 489,
    tradeId: 'explicit.stat_3604585015',
    description: 'Bismuth Ore Deposits in your Maps have (20–30)% chance to add an additional Modifier to Monsters they affect',
    range: [20, 30],
    contentType: ContentType.SETTLERS,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_settlers_crimson_ore_additional_pods': {
    id: 490,
    tradeId: 'explicit.stat_3208431815',
    description: 'Crimson Iron Ore Deposits in your Maps are guarded by an additional Corrupted Growth',
    range: [0, 0],
    contentType: ContentType.SETTLERS,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_settlers_orichalcum_ore_buff_duration': {
    id: 491,
    tradeId: 'explicit.stat_3847531781',
    description: 'Buffs granted by Orichalcum Ore Deposits in your Maps have (60–100)% increased Duration',
    range: [60, 100],
    contentType: ContentType.SETTLERS,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_settlers_amber_ore_tree_damage_taken': {
    id: 492,
    tradeId: 'explicit.stat_1235842798',
    description: 'Petrified Amber Ore Deposits in your Maps take (15–25)% reduced Damage',
    range: [15, 25],
    contentType: ContentType.SETTLERS,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_settlers_verisium_ore_maximum_channel': {
    id: 493,
    tradeId: 'explicit.stat_1949656826',
    description: 'Verisium Ore Deposits in your Maps can be channelled on for (20–30)% longer',
    range: [20, 30],
    contentType: ContentType.SETTLERS,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'prefix_burial_ritual_additional_chance': {
    id: 494,
    tradeId: 'explicit.stat_1314822783',
    description: 'Your Maps have +(40–60)% chance to contain Ritual Altars',
    range: [40, 60],
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'prefix_burial_ritual_increased_chance': {
    id: 495,
    tradeId: 'explicit.stat_1777351949',
    description: 'Your Maps have (192–240)% increased chance to contain Ritual Altars',
    range: [192, 240],
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'suffix_burial_ritual_increased_tribute': {
    id: 496,
    tradeId: 'explicit.stat_159726667',
    description: 'Monsters Sacrificed at Ritual Altars in your Maps grant (20–25)% increased Tribute',
    range: [20, 25],
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_ritual_monster_spawning_speed': {
    id: 497,
    tradeId: 'explicit.stat_2428948876',
    description: 'Ritual Altars in your Maps spawn Monsters (15–20)% faster',
    range: [15, 20],
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_ritual_vessel_from_final_encounter_chance': {
    id: 498,
    tradeId: 'explicit.stat_3008766302',
    description: 'Completing the final Ritual Altar in your Maps has (10–15)% chance to drop a Blood-filled Vessel',
    range: [10, 15],
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_scarab_boss_additional_drop_chance': {
    id: 499,
    tradeId: 'explicit.stat_4086926366',
    description: 'Final Map Boss in each Map has (20–25)% chance to drop an additional Scarab',
    range: [20, 25],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_scarab_rare_monster_drop_chance_per_modifier': {
    id: 500,
    tradeId: 'explicit.stat_829341851',
    description: 'Rare Monsters in your Maps have (40–60)% increased chance to drop Scarabs per Monster Modifier affecting them',
    range: [40, 60],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'prefix_burial_map_non_unique_mod_effect': {
    id: 501,
    tradeId: 'explicit.stat_3191123893',
    description: '(6–9)% increased effect of Explicit Modifiers on your Maps',
    range: [6, 9],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'prefix_burial_strongbox_additional': {
    id: 502,
    tradeId: 'explicit.stat_3240183538',
    description: 'Your Maps contain (1–1) additional Strongboxes',
    range: [1, 1],
    contentType: ContentType.STRONGBOXES,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'prefix_burial_strongbox_increased_chance': {
    id: 503,
    tradeId: 'explicit.stat_2388936716',
    description: 'Your Maps have +(15–25)% chance to contain a Strongbox',
    range: [15, 25],
    contentType: ContentType.STRONGBOXES,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'suffix_burial_strongbox_currency_duped': {
    id: 504,
    tradeId: 'explicit.stat_92114609',
    description: 'Currency Items from Strongboxes in your Maps are Duplicated',
    range: [0, 0],
    contentType: ContentType.STRONGBOXES,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_strongbox_maps_duped': {
    id: 505,
    tradeId: 'explicit.stat_4089738202',
    description: 'Maps from Strongboxes in your Maps are Duplicated',
    range: [0, 0],
    contentType: ContentType.STRONGBOXES,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_strongbox_divination_cards_duped': {
    id: 506,
    tradeId: 'explicit.stat_3469094021',
    description: 'Divination Cards from Strongboxes in your Maps are Duplicated',
    range: [0, 0],
    contentType: ContentType.STRONGBOXES,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_strongbox_gems_duped': {
    id: 507,
    tradeId: 'explicit.stat_1992708227',
    description: 'Gems contained in Strongboxes in your Maps are Duplicated',
    range: [0, 0],
    contentType: ContentType.STRONGBOXES,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_tangle_monsters_drop_additional_eater_of_worlds_item': {
    id: 508,
    tradeId: 'explicit.stat_2121601076',
    description: 'Monsters Influenced by The Eater of Worlds in your Maps have (0.8–1.2)% chance to drop an item with an Eater of Worlds Implicit Modifier',
    range: [0.8, 1.2],
    contentType: ContentType.EATER_OF_WORLDS,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_tangle_altar_spawn_chance': {
    id: 509,
    tradeId: 'explicit.stat_2988344505',
    description: '(15–20)% increased chance to find Eater of Worlds Altars in your Maps',
    range: [15, 20],
    contentType: ContentType.EATER_OF_WORLDS,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'prefix_burial_torment_increased_chance': {
    id: 510,
    tradeId: 'explicit.stat_2750973094',
    description: 'Your Maps have +(15–25)% chance to be haunted by a Tormented Spirit',
    range: [15, 25],
    contentType: ContentType.TORMENTED_SPIRITS,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'prefix_burial_torment_rare_monsters_possessed_chance': {
    id: 511,
    tradeId: 'explicit.stat_3788412017',
    description: 'Up to 5 Rare Monsters in each of your Maps are Possessed and their Minions are Touched',
    range: [0, 0],
    contentType: ContentType.TORMENTED_SPIRITS,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'prefix_burial_torment_extra_spirits': {
    id: 512,
    tradeId: 'explicit.stat_358129101',
    description: 'Your Maps are haunted by an additional Tormented Spirit',
    range: [0, 0],
    contentType: ContentType.TORMENTED_SPIRITS,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'suffix_burial_map_unique_monster_items_drop_corrupted_chance': {
    id: 513,
    tradeId: 'explicit.stat_1852765051',
    description: 'Items dropped by Unique Monsters have (10–15)% chance to be Corrupted',
    range: [10, 15],
    contentType: ContentType.VAAL_SIDE_AREAS,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_burial_vaal_side_area_vaal_vessel_duplicate_rewards': {
    id: 514,
    tradeId: 'explicit.stat_4131593417',
    description: 'Vaal Side Areas in your Maps have (15–20)% chance for Rewards from Vaal Vessels to be Duplicated',
    range: [15, 20],
    contentType: ContentType.VAAL_SIDE_AREAS,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'prefix_burial_map_additional_kirac_mission_on_completion_chance': {
    id: 515,
    tradeId: 'explicit.stat_2771143254',
    description: 'Your Maps have (5–8)% chance to grant an additional Kirac Mission on Completion',
    range: [5, 8],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'prefix_burial_map_additionak_kirac_mission_on_completion_chance_per_myriad': {
    id: 516,
    tradeId: 'explicit.stat_2771143254',
    description: 'Your Maps have (2–2.5)% chance to grant an additional Kirac Mission on Completion',
    range: [2, 2.5],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'suffix_burial_increased_map_drop_rarity': {
    id: 517,
    tradeId: 'explicit.stat_655058427',
    description: '(25–35)% increased Rarity of Maps found in your Maps',
    range: [25, 35],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.BURIAL],
    type: 'suffix'
  },
  'prefix_burial_increased_item_rarity': {
    id: 518,
    tradeId: 'explicit.stat_2306002879',
    description: '(12–16)% increased Rarity of Items found in your Maps',
    range: [12, 16],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.BURIAL],
    type: 'prefix'
  },
  'prefix_totemic_additional_abyss_chance': {
    id: 519,
    tradeId: 'explicit.stat_4278144676',
    description: 'Your Maps have +(40–60)% chance to contain an Abyss',
    range: [40, 60],
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'prefix_totemic_increased_abyss_chance': {
    id: 520,
    tradeId: 'explicit.stat_4111037980',
    description: 'Your Maps have (192–240)% increased chance to contain an Abyss',
    range: [192, 240],
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'suffix_totemic_increased_abyss_spire_chance': {
    id: 521,
    tradeId: 'explicit.stat_836430463',
    description: 'Abysses in your Maps that do not lead to an Abyssal Depths have (40–60)% increased chance to lead to a Stygian Spire',
    range: [40, 60],
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_increased_abyss_depths_chance': {
    id: 522,
    tradeId: 'explicit.stat_2722831300',
    description: 'Abysses in your Maps have (40–60)% increased chance to lead to an Abyssal Depths',
    range: [40, 60],
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_abyss_path_spawn_at_least_magic_chance': {
    id: 523,
    tradeId: 'explicit.stat_1388221282',
    description: 'Abyss Cracks in your Maps have (10–20)% chance to spawn all Monsters as at least Magic',
    range: [10, 20],
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_abyss_chasm_spawn_at_least_magic_chance': {
    id: 524,
    tradeId: 'explicit.stat_4157613372',
    description: 'Abyss Pits in your Maps have (10–20)% chance to spawn all Monsters as at least Magic',
    range: [10, 20],
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_incursion_additional_upgrade_non_resident': {
    id: 525,
    tradeId: 'explicit.stat_1346625818',
    description: 'Killing non-resident Architects in your Maps has (30–50)% chance to add an additional Upgrade Tier to the surviving Architect\'s Room',
    range: [30, 50],
    contentType: ContentType.INCURSION,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'prefix_totemic_additional_incursion_chance': {
    id: 526,
    tradeId: 'explicit.stat_2709296039',
    description: 'Your Maps have +(40–60)% chance to contain Alva',
    range: [40, 60],
    contentType: ContentType.INCURSION,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'prefix_totemic_increased_incursion_chance': {
    id: 527,
    tradeId: 'explicit.stat_3629418990',
    description: 'Your Maps have (192–240)% increased chance to contain Alva',
    range: [192, 240],
    contentType: ContentType.INCURSION,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'suffix_totemic_anarchy_possessed': {
    id: 528,
    tradeId: 'explicit.stat_3034509000',
    description: 'Wild Rogue Exiles in your Maps have (75–100)% chance to be Possessed by a Tormented Spirit',
    range: [75, 100],
    contentType: ContentType.ROGUE_EXILES,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'prefix_totemic_anarchy_additional_exiles_chance': {
    id: 529,
    tradeId: 'explicit.stat_1123357133',
    description: 'Your Maps have a (40–60)% chance to contain an additional Rogue Exile',
    range: [40, 60],
    contentType: ContentType.ROGUE_EXILES,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'prefix_totemic_anarchy_exile_chance': {
    id: 530,
    tradeId: 'explicit.stat_2974922599',
    description: 'Your Maps have +(15–25)% chance to contain a Rogue Exile',
    range: [15, 25],
    contentType: ContentType.ROGUE_EXILES,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'suffix_totemic_bestiary_additional_yellow_beasts': {
    id: 531,
    tradeId: 'explicit.stat_1320130840',
    description: 'Your Maps that contain capturable Beasts contain (3–4) additional Yellow Beasts',
    range: [3, 4],
    contentType: ContentType.BESTIARY,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'prefix_totemic_bestiary_additional_chance': {
    id: 532,
    tradeId: 'explicit.stat_1566972708',
    description: 'Your Maps have +(40–60)% chance to contain Einhar',
    range: [40, 60],
    contentType: ContentType.BESTIARY,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'prefix_totemic_bestiary_increased_chance': {
    id: 533,
    tradeId: 'explicit.stat_1301096166',
    description: 'Your Maps have (192–240)% increased chance to contain Einhar',
    range: [192, 240],
    contentType: ContentType.BESTIARY,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'suffix_totemic_bestiary_chance_to_not_consume_beast': {
    id: 534,
    tradeId: 'explicit.stat_3773225751',
    description: 'Red Beasts captured in your Maps have a (40–60)% chance to gain a Modifier that provides a chance to not to be consumed when sacrificed at the Blood Altar',
    range: [40, 60],
    contentType: ContentType.BESTIARY,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_bestiary_red_beast_pairs_chance': {
    id: 535,
    tradeId: 'explicit.stat_543949956',
    description: 'Red Beasts in your Maps have (16–24)% chance to appear in Pairs',
    range: [16, 24],
    contentType: ContentType.BESTIARY,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'prefix_totemic_beyond_additional_chance': {
    id: 536,
    tradeId: 'explicit.stat_3438840900',
    description: '(40–60)% chance for your Maps to attract Beyond Demons',
    range: [40, 60],
    contentType: ContentType.BEYOND,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'suffix_totemic_beyond_increased_monster_experience': {
    id: 537,
    tradeId: 'explicit.stat_3791540252',
    description: 'Beyond Demons in your Maps grant (20–30)% increased Experience',
    range: [20, 30],
    contentType: ContentType.BEYOND,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_beyond_increased_boss_spawn_chance': {
    id: 538,
    tradeId: 'explicit.stat_4180165115',
    description: 'Beyond Portals in your Maps have (25–35)% increased chance to spawn a Unique Boss',
    range: [25, 35],
    contentType: ContentType.BEYOND,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_beyond_more_demon_faction_divination_card_quantity': {
    id: 539,
    tradeId: 'explicit.stat_1340524145',
    description: '(20–25)% more Divination Cards found from Beyond Demons in your Maps that are followers of K\'Tash',
    range: [20, 25],
    contentType: ContentType.BEYOND,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_beyond_more_pale_faction_currency_quantity': {
    id: 540,
    tradeId: 'explicit.stat_3062743459',
    description: '(20–25)% more Basic Currency Items found from Beyond Demons in your Maps that are followers of Beidat',
    range: [20, 25],
    contentType: ContentType.BEYOND,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_beyond_more_flesh_faction_unique_quantity': {
    id: 541,
    tradeId: 'explicit.stat_303527630',
    description: '(20–25)% more Unique Items found from Beyond Demons in your Maps that are followers of Ghorr',
    range: [20, 25],
    contentType: ContentType.BEYOND,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'prefix_totemic_blight_additional_encounter_chance': {
    id: 542,
    tradeId: 'explicit.stat_764545335',
    description: 'Your Maps have +(40–60)% chance to contain a Blight Encounter',
    range: [40, 60],
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'prefix_totemic_blight_additional_chance': {
    id: 543,
    tradeId: 'explicit.stat_1393318927',
    description: 'Your Maps have (192–240)% increased chance to contain a Blight Encounter',
    range: [192, 240],
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'suffix_totemic_blight_more_pack_size': {
    id: 544,
    tradeId: 'explicit.stat_4091793171',
    description: 'Blight Encounters in your Maps spawn (25–35)% more Non-Unique Monsters',
    range: [25, 35],
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_blight_oil_higher_tier_chance': {
    id: 545,
    tradeId: 'explicit.stat_3259960466',
    description: 'Oils found in your Maps have (20–25)% chance to be 1 tier higher',
    range: [20, 25],
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_blight_monsters_take_increased_damage': {
    id: 546,
    tradeId: 'explicit.stat_3594607722',
    description: 'Blight Monsters in your Maps take (30–40)% increased Damage',
    range: [30, 40],
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_cleansing_fire_altar_spawn_chance_on_influence_appearance': {
    id: 547,
    tradeId: 'explicit.stat_3179686508',
    description: '(40–60)% chance to spawn a Searing Exarch Altar when the Influence of The Searing Exarch first appears in your Maps',
    range: [40, 60],
    contentType: ContentType.SEARING_EXARCH,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'prefix_totemic_delirium_additional_chance': {
    id: 548,
    tradeId: 'explicit.stat_1808954678',
    description: 'Your Maps have +(40–60)% chance to contain a Mirror of Delirium',
    range: [40, 60],
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'prefix_totemic_delirium_increased_chance': {
    id: 549,
    tradeId: 'explicit.stat_3573600538',
    description: 'Your Maps have (192–240)% increased chance to contain a Mirror of Delirium',
    range: [192, 240],
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'suffix_totemic_delirium_faster_depth_increase': {
    id: 550,
    tradeId: 'explicit.stat_1769611692',
    description: 'Delirium in your Maps increases (35–50)% faster with distance from the mirror',
    range: [35, 50],
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_delirium_secondary_wave_delay': {
    id: 551,
    tradeId: 'explicit.stat_1174954559',
    description: 'Delirium Fog in your Maps lasts (10–15) additional seconds before dissipating',
    range: [10, 15],
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_delirium_additional_delirium_orb_chance': {
    id: 552,
    tradeId: 'explicit.stat_2901714012',
    description: 'Delirium Rewards in your Maps have (8–12)% increased chance to give Delirium Orbs',
    range: [8, 12],
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'prefix_totemic_delve_additional_chance': {
    id: 553,
    tradeId: 'explicit.stat_4267923742',
    description: 'Your Maps have +(40–60)% chance to contain Niko',
    range: [40, 60],
    contentType: ContentType.DELVE,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'prefix_totemic_delve_increased_chance': {
    id: 554,
    tradeId: 'explicit.stat_399319107',
    description: 'Your Maps have (192–240)% increased chance to contain Niko',
    range: [192, 240],
    contentType: ContentType.DELVE,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'suffix_totemic_delve_double_sulphite_chance': {
    id: 555,
    tradeId: 'explicit.stat_1174549622',
    description: 'Voltaxic Sulphite Veins and Chests in your Maps have (4–6)% chance to contain double Sulphite',
    range: [4, 6],
    contentType: ContentType.DELVE,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_delve_damager_per_sulphite_mined': {
    id: 556,
    tradeId: 'explicit.stat_1280291906',
    description: 'You gain (30–40)% increased Damage per stack of Sulphite Intoxication',
    range: [30, 40],
    contentType: ContentType.DELVE,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'prefix_totemic_shrine_num': {
    id: 557,
    tradeId: 'explicit.stat_1468737867',
    description: 'Your Maps contain an additional Shrine',
    range: [1, 1],
    contentType: ContentType.SHRINES,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'prefix_totemic_shrine_increased_chance': {
    id: 558,
    tradeId: 'explicit.stat_2571125745',
    description: 'Your Maps have +(15–25)% chance to contain a Shrine',
    range: [15, 25],
    contentType: ContentType.SHRINES,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'suffix_totemic_shrine_additional_pack_chance': {
    id: 559,
    tradeId: 'explicit.stat_1751949663',
    description: 'Shrines in your Maps have (40–60)% chance to be guarded by an additional Pack of Monsters',
    range: [40, 60],
    contentType: ContentType.SHRINES,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_shaper_influence_pack_size': {
    id: 560,
    tradeId: 'explicit.stat_3017475694',
    description: 'Monster Packs Influenced by The Shaper in your Maps have (15–25)% increased Pack Size',
    range: [15, 25],
    contentType: ContentType.SHAPER,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_elder_influence_pack_size': {
    id: 561,
    tradeId: 'explicit.stat_3275918621',
    description: 'Monster Packs Influenced by The Elder in your Maps have (15–25)% increased Pack Size',
    range: [15, 25],
    contentType: ContentType.ELDER,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_zana_influence_equipment_item_chance': {
    id: 562,
    tradeId: 'explicit.stat_4012065952',
    description: '(15–25)% increased chance for Equipment Items dropped in your Maps to have Memory Strands',
    range: [15, 25],
    contentType: ContentType.ZANA,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_zana_influence_map_item_chance': {
    id: 563,
    tradeId: 'explicit.stat_874254965',
    description: '(15–25)% increased chance for Maps found in your Maps to have Memory Influence',
    range: [15, 25],
    contentType: ContentType.ZANA,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'prefix_totemic_essence_additional_monoliths': {
    id: 564,
    tradeId: 'explicit.stat_395808938',
    description: 'Your Maps contain (1) additional Imprisoned Monsters',
    range: [1, 1],
    contentType: ContentType.ESSENCE,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'prefix_totemic_essence_increased_chance': {
    id: 565,
    tradeId: 'explicit.stat_4098286334',
    description: 'Your Maps have +(15–25)% chance to contain an Imprisoned Monster',
    range: [15, 25],
    contentType: ContentType.ESSENCE,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'suffix_totemic_essence_three_additional_essence_chance': {
    id: 566,
    tradeId: 'explicit.stat_3011076420',
    description: 'Imprisoned Monsters in your Maps have (12–17)% chance to have 3 additional Essences',
    range: [12, 17],
    contentType: ContentType.ESSENCE,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'prefix_totemic_expedition_additional_chance': {
    id: 567,
    tradeId: 'explicit.stat_4154778375',
    description: 'Your Maps have +(40–60)% chance to contain an Expedition Encounter',
    range: [40, 60],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'prefix_totemic_expedition_increased_chance': {
    id: 568,
    tradeId: 'explicit.stat_1561678231',
    description: 'Your Maps have (192–240)% increased chance to contain an Expedition Encounter',
    range: [192, 240],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'suffix_totemic_expedition_extra_relic_suffix_chance': {
    id: 569,
    tradeId: 'explicit.stat_1871805225',
    description: 'Remnants in your Maps have (25–35)% chance to have an additional Suffix Modifier',
    range: [25, 35],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_expedition_tujen_chance': {
    id: 570,
    tradeId: 'explicit.stat_2110260866',
    description: 'Expeditions in your Maps have (80–100)% increased chance to be led by Tujen',
    range: [80, 100],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_expedition_dannig_chance': {
    id: 571,
    tradeId: 'explicit.stat_3171270268',
    description: 'Expeditions in your Maps have (50–60)% increased chance to be led by Dannig',
    range: [50, 60],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_expedition_monsters_spawn_missing_percent_life': {
    id: 572,
    tradeId: 'explicit.stat_2684644644',
    description: 'Expedition Monsters in your Maps spawn with an additional (6–10)% of Life missing',
    range: [6, 10],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_expedition_rog_chance': {
    id: 573,
    tradeId: 'explicit.stat_140032086',
    description: 'Expeditions in your Maps have (80–100)% increased chance to be led by Rog',
    range: [80, 100],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_expedition_gwennen_chance': {
    id: 574,
    tradeId: 'explicit.stat_159709680',
    description: 'Expeditions in your Maps have (80–100)% increased chance to be led by Gwennen',
    range: [80, 100],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'prefix_totemic_harbinger_extra_harbingers': {
    id: 575,
    tradeId: 'explicit.stat_504850499',
    description: 'Your Maps contain (1–1) additional Harbingers',
    range: [1, 1],
    contentType: ContentType.HARBINGER,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'prefix_totemic_harbinger_additional_harbinger_chance': {
    id: 576,
    tradeId: 'explicit.stat_266448395',
    description: 'Your Maps have a (15–25)% chance to contain an additional Harbinger',
    range: [15, 25],
    contentType: ContentType.HARBINGER,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'suffix_totemic_harbinger_powerful_chance': {
    id: 577,
    tradeId: 'explicit.stat_3511358099',
    description: 'Harbingers in your Maps have (20–25)% chance to be replaced by a powerful Harbinger boss',
    range: [20, 25],
    contentType: ContentType.HARBINGER,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'prefix_totemic_harvest_additional_chance': {
    id: 578,
    tradeId: 'explicit.stat_1145451936',
    description: 'Your Maps have +(40–60)% chance to contain The Sacred Grove',
    range: [40, 60],
    contentType: ContentType.HARVEST,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'prefix_totemic_harvest_increased_chance': {
    id: 579,
    tradeId: 'explicit.stat_2936740844',
    description: 'Your Maps have (192–240)% increased chance to contain The Sacred Grove',
    range: [192, 240],
    contentType: ContentType.HARVEST,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'suffix_totemic_harvest_increased_lifeforce_dropped': {
    id: 580,
    tradeId: 'explicit.stat_3483648190',
    description: 'Harvest Monsters in your Maps drop (12–18)% increased Quantity of Lifeforce',
    range: [12, 18],
    contentType: ContentType.HARVEST,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_harvest_other_plot_not_whither_chance': {
    id: 581,
    tradeId: 'explicit.stat_1565587169',
    description: 'Harvests in your Maps have (8–12)% chance for the unchosen Crop to not wilt',
    range: [8, 12],
    contentType: ContentType.HARVEST,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_harvest_additional_plot_chance': {
    id: 582,
    tradeId: 'explicit.stat_1880405255',
    description: 'The Sacred Grove in your Maps has (40–60)% chance to contain an additional Harvest',
    range: [40, 60],
    contentType: ContentType.HARVEST,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'prefix_totemic_heist_additional_cache_chance': {
    id: 583,
    tradeId: 'explicit.stat_1975869602',
    description: 'Your Maps have +(40–60)% chance to contain a Smuggler\'s Cache',
    range: [40, 60],
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'prefix_totemic_heist_increased_cache_chance': {
    id: 584,
    tradeId: 'explicit.stat_4069523014',
    description: 'Your Maps have (192–240)% increased chance to contain a Smuggler\'s Cache',
    range: [192, 240],
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'suffix_totemic_heist_cache_increased_contract_drop_chance': {
    id: 585,
    tradeId: 'explicit.stat_470630932',
    description: 'Smuggler\'s Caches in your Maps have (40–60)% increased chance to drop Contracts',
    range: [40, 60],
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_heist_cache_more_rogue_markers_per_opened_cache': {
    id: 586,
    tradeId: 'explicit.stat_2863957119',
    description: 'Smuggler\'s Caches drop (8–12)% more Rogue Markers for each Smuggler\'s Cache opened in the Area',
    range: [8, 12],
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_heist_high_value_contract_chance': {
    id: 587,
    tradeId: 'explicit.stat_2429444272',
    description: 'Heist Contracts found in your Maps are (70–90)% more likely to target High Value Targets',
    range: [70, 90],
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_heist_precious_value_contract_chance': {
    id: 588,
    tradeId: 'explicit.stat_1288317603',
    description: 'Heist Contracts found in your Maps are (45–65)% more likely to target Precious Targets',
    range: [45, 65],
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_betrayal_reinforcement_chance': {
    id: 589,
    tradeId: 'explicit.stat_2181411965',
    description: 'Immortal Syndicate Members in your Maps have (20–25)% increased chance to be accompanied by reinforcements',
    range: [20, 25],
    contentType: ContentType.BETRAYAL,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'prefix_totemic_betrayal_additional_chance': {
    id: 590,
    tradeId: 'explicit.stat_527292219',
    description: 'Your Maps have +(40–60)% chance to contain Jun',
    range: [40, 60],
    contentType: ContentType.BETRAYAL,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'prefix_totemic_betrayal_increased_chance': {
    id: 591,
    tradeId: 'explicit.stat_4116217552',
    description: 'Your Maps have (192–240)% increased chance to contain Jun',
    range: [192, 240],
    contentType: ContentType.BETRAYAL,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'suffix_totemic_betrayal_targets_drop_additional_veiled_item_chance': {
    id: 592,
    tradeId: 'explicit.stat_4122946258',
    description: 'Immortal Syndicate Members in your Maps have (40–60)% chance to drop an additional Veiled Item',
    range: [40, 60],
    contentType: ContentType.BETRAYAL,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_betrayal_target_item_rarity': {
    id: 593,
    tradeId: 'explicit.stat_2695818040',
    description: '(40–60)% increased Rarity of Items Dropped by Immortal Syndicate Members in your Maps',
    range: [40, 60],
    contentType: ContentType.BETRAYAL,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'prefix_totemic_ascendancy_additional_trial_chance': {
    id: 594,
    tradeId: 'explicit.stat_495465216',
    description: 'Your Maps have +(8–12)% chance to contain a Trial of Ascendancy',
    range: [8, 12],
    contentType: ContentType.LAB,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'prefix_totemic_legion_additional_chance': {
    id: 595,
    tradeId: 'explicit.stat_1981273563',
    description: 'Your Maps have +(40–60)% chance to contain a Legion Encounter',
    range: [40, 60],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'prefix_totemic_legion_increased_chance': {
    id: 596,
    tradeId: 'explicit.stat_310950600',
    description: 'Your Maps have (192–240)% increased chance to contain a Legion Encounter',
    range: [192, 240],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'suffix_totemic_legion_karui_chance': {
    id: 597,
    tradeId: 'explicit.stat_4094461744',
    description: 'Legion Encounters in your Maps have (100–150)% increased chance to include a Karui army',
    range: [100, 150],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_legion_eternal_empire_chance': {
    id: 598,
    tradeId: 'explicit.stat_3825355878',
    description: 'Legion Encounters in your Maps have (100–150)% increased chance to include an Eternal Empire army',
    range: [100, 150],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_legion_vaal_chance': {
    id: 599,
    tradeId: 'explicit.stat_3218477736',
    description: 'Legion Encounters in your Maps have (80–120)% increased chance to include a Vaal army',
    range: [80, 120],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_legion_templar_chance': {
    id: 600,
    tradeId: 'explicit.stat_573511501',
    description: 'Legion Encounters in your Maps have (75–100)% increased chance to include a Templar army',
    range: [75, 100],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_legion_maraketh_chance': {
    id: 601,
    tradeId: 'explicit.stat_1611826374',
    description: 'Legion Encounters in your Maps have (60–80)% increased chance to include a Maraketh army',
    range: [60, 80],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_legion_splinter_dupe_chance': {
    id: 602,
    tradeId: 'explicit.stat_3374667389',
    description: 'Splinters dropped by Legion Monsters or contained in Legion Chests in your Maps have (15–20)% chance to be Duplicated',
    range: [15, 20],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_legion_chest_splinter_dupe_chance': {
    id: 603,
    tradeId: 'explicit.stat_1794950665',
    description: 'Splinters contained in Legion Chests in your Maps have (20–25)% chance to be Duplicated',
    range: [20, 25],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_legion_monster_splinter_dupe_chance': {
    id: 604,
    tradeId: 'explicit.stat_3473008748',
    description: 'Splinters dropped by Legion Monsters in your Maps have (20–25)% chance to be Duplicated',
    range: [20, 25],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_legion_monster_with_reward_additional_reward_chance': {
    id: 605,
    tradeId: 'explicit.stat_611792282',
    description: 'Legion Monsters in your Maps which have Rewards have (8–12)% chance to gain two additional Rewards, and if not have (15–20)% chance to gain one additional Reward',
    range: [8, 12],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'prefix_totemic_map_boss_additional_adjacent_map_chance': {
    id: 606,
    tradeId: 'explicit.stat_729281484',
    description: 'Final Map Boss in each Map has (4–6)% chance to drop an additional connected Map',
    range: [4, 6],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'suffix_totemic_fortune_favours_the_brave_pack_size': {
    id: 607,
    tradeId: 'explicit.stat_631736299',
    description: '(5–10)% increased Pack Size of your Maps affected by Fortune Favours the Brave',
    range: [5, 10],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_fortune_favours_the_brave_item_quantity': {
    id: 608,
    tradeId: 'explicit.stat_2619073196',
    description: '(5–10)% increased Quantity of Items found in your Maps affected by Fortune Favours the Brave',
    range: [5, 10],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.TOTEMIC, IdolSize.BURIAL],
    type: 'suffix'
  },
  'suffix_totemic_fortune_favours_the_brave_item_rarity': {
    id: 609,
    tradeId: 'explicit.stat_3433267351',
    description: '(10–20)% increased Rarity of Items found in your Maps affected by Fortune Favours the Brave',
    range: [10, 20],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'prefix_totemic_ultimatum_increased_chance': {
    id: 610,
    tradeId: 'explicit.stat_880963174',
    description: 'Your Maps have (192–240)% increased chance to contain an Ultimatum Encounter',
    range: [192, 240],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'prefix_totemic_ultimatum_additional_chance': {
    id: 611,
    tradeId: 'explicit.stat_1365687125',
    description: 'Your Maps have +(40–60)% chance to contain an Ultimatum Encounter',
    range: [40, 60],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'suffix_totemic_ultimatum_increased_number_of_monsters': {
    id: 612,
    tradeId: 'explicit.stat_3025100555',
    description: 'Ultimatum Encounters in your Maps spawn (15–20)% increased number of Monsters',
    range: [15, 20],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_ultimatum_experience': {
    id: 613,
    tradeId: 'explicit.stat_3027114376',
    description: 'Ultimatum Monsters in your Maps grant (40–60)% increased Experience',
    range: [40, 60],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_ultimatum_inscribed_reward_unique_item_chance': {
    id: 614,
    tradeId: 'explicit.stat_2112979059',
    description: 'Inscribed Ultimatums found in your Maps have (40–60)% increased chance to reward Unique Items',
    range: [40, 60],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_ultimatum_inscribed_reward_currency_chance': {
    id: 615,
    tradeId: 'explicit.stat_2412871991',
    description: 'Inscribed Ultimatums found in your Maps have (40–60)% increased chance to reward Currency Items',
    range: [40, 60],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_ultimatum_inscribed_reward_divination_card_chance': {
    id: 616,
    tradeId: 'explicit.stat_2367226239',
    description: 'Inscribed Ultimatums found in your Maps have (40–60)% increased chance to reward Divination Cards',
    range: [40, 60],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'prefix_totemic_settlers_increased_chance': {
    id: 617,
    tradeId: 'explicit.stat_2661886285',
    description: 'Your Maps have (192–240)% increased chance to contain Ore Deposits',
    range: [192, 240],
    contentType: ContentType.SETTLERS,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'prefix_totemic_settlers_additional_chance': {
    id: 618,
    tradeId: 'explicit.stat_2661886285',
    description: 'Your Maps have +(40–60)% chance to contain Ore Deposits',
    range: [40, 60],
    contentType: ContentType.SETTLERS,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'suffix_totemic_settlers_second_ore_chance': {
    id: 619,
    tradeId: 'explicit.stat_2843145261',
    description: 'Your Maps with Ore Deposits have (30–50)% increased chance to contain at least two Ore Deposits',
    range: [30, 50],
    contentType: ContentType.SETTLERS,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_settlers_bismuth_additional_modifier_chance': {
    id: 620,
    tradeId: 'explicit.stat_3604585015',
    description: 'Bismuth Ore Deposits in your Maps have (20–30)% chance to add an additional Modifier to Monsters they affect',
    range: [20, 30],
    contentType: ContentType.SETTLERS,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_settlers_crimson_ore_additional_pods': {
    id: 621,
    tradeId: 'explicit.stat_3208431815',
    description: 'Crimson Iron Ore Deposits in your Maps are guarded by an additional Corrupted Growth',
    range: [0, 0],
    contentType: ContentType.SETTLERS,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_settlers_orichalcum_ore_buff_duration': {
    id: 622,
    tradeId: 'explicit.stat_3847531781',
    description: 'Buffs granted by Orichalcum Ore Deposits in your Maps have (60–100)% increased Duration',
    range: [60, 100],
    contentType: ContentType.SETTLERS,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_settlers_amber_ore_tree_damage_taken': {
    id: 623,
    tradeId: 'explicit.stat_1235842798',
    description: 'Petrified Amber Ore Deposits in your Maps take (15–25)% reduced Damage',
    range: [15, 25],
    contentType: ContentType.SETTLERS,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_settlers_verisium_ore_maximum_channel': {
    id: 624,
    tradeId: 'explicit.stat_1949656826',
    description: 'Verisium Ore Deposits in your Maps can be channelled on for (20–30)% longer',
    range: [20, 30],
    contentType: ContentType.SETTLERS,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'prefix_totemic_ritual_additional_chance': {
    id: 625,
    tradeId: 'explicit.stat_1314822783',
    description: 'Your Maps have +(40–60)% chance to contain Ritual Altars',
    range: [40, 60],
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'prefix_totemic_ritual_increased_chance': {
    id: 626,
    tradeId: 'explicit.stat_1777351949',
    description: 'Your Maps have (192–240)% increased chance to contain Ritual Altars',
    range: [192, 240],
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'suffix_totemic_ritual_increased_tribute': {
    id: 627,
    tradeId: 'explicit.stat_159726667',
    description: 'Monsters Sacrificed at Ritual Altars in your Maps grant (20–25)% increased Tribute',
    range: [20, 25],
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_ritual_monster_spawning_speed': {
    id: 628,
    tradeId: 'explicit.stat_2428948876',
    description: 'Ritual Altars in your Maps spawn Monsters (15–20)% faster',
    range: [15, 20],
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_ritual_vessel_from_final_encounter_chance': {
    id: 629,
    tradeId: 'explicit.stat_3008766302',
    description: 'Completing the final Ritual Altar in your Maps has (10–15)% chance to drop a Blood-filled Vessel',
    range: [10, 15],
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_scarab_boss_additional_drop_chance': {
    id: 630,
    tradeId: 'explicit.stat_4086926366',
    description: 'Final Map Boss in each Map has (20–25)% chance to drop an additional Scarab',
    range: [20, 25],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_scarab_rare_monster_drop_chance_per_modifier': {
    id: 631,
    tradeId: 'explicit.stat_829341851',
    description: 'Rare Monsters in your Maps have (40–60)% increased chance to drop Scarabs per Monster Modifier affecting them',
    range: [40, 60],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'prefix_totemic_map_non_unique_mod_effect': {
    id: 632,
    tradeId: 'explicit.stat_3191123893',
    description: '(6–9)% increased effect of Explicit Modifiers on your Maps',
    range: [6, 9],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'prefix_totemic_strongbox_additional': {
    id: 633,
    tradeId: 'explicit.stat_3240183538',
    description: 'Your Maps contain (1–1) additional Strongboxes',
    range: [1, 1],
    contentType: ContentType.STRONGBOXES,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'prefix_totemic_strongbox_increased_chance': {
    id: 634,
    tradeId: 'explicit.stat_2388936716',
    description: 'Your Maps have +(15–25)% chance to contain a Strongbox',
    range: [15, 25],
    contentType: ContentType.STRONGBOXES,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'suffix_totemic_strongbox_currency_duped': {
    id: 635,
    tradeId: 'explicit.stat_92114609',
    description: 'Currency Items from Strongboxes in your Maps are Duplicated',
    range: [0, 0],
    contentType: ContentType.STRONGBOXES,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_strongbox_maps_duped': {
    id: 636,
    tradeId: 'explicit.stat_4089738202',
    description: 'Maps from Strongboxes in your Maps are Duplicated',
    range: [0, 0],
    contentType: ContentType.STRONGBOXES,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_strongbox_divination_cards_duped': {
    id: 637,
    tradeId: 'explicit.stat_3469094021',
    description: 'Divination Cards from Strongboxes in your Maps are Duplicated',
    range: [0, 0],
    contentType: ContentType.STRONGBOXES,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_strongbox_gems_duped': {
    id: 638,
    tradeId: 'explicit.stat_1992708227',
    description: 'Gems contained in Strongboxes in your Maps are Duplicated',
    range: [0, 0],
    contentType: ContentType.STRONGBOXES,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_tangle_monsters_drop_additional_eater_of_worlds_item': {
    id: 639,
    tradeId: 'explicit.stat_2121601076',
    description: 'Monsters Influenced by The Eater of Worlds in your Maps have (0.8–1.2)% chance to drop an item with an Eater of Worlds Implicit Modifier',
    range: [0.8, 1.2],
    contentType: ContentType.EATER_OF_WORLDS,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_tangle_altar_spawn_chance': {
    id: 640,
    tradeId: 'explicit.stat_2988344505',
    description: '(15–20)% increased chance to find Eater of Worlds Altars in your Maps',
    range: [15, 20],
    contentType: ContentType.EATER_OF_WORLDS,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'prefix_totemic_torment_increased_chance': {
    id: 641,
    tradeId: 'explicit.stat_2750973094',
    description: 'Your Maps have +(15–25)% chance to be haunted by a Tormented Spirit',
    range: [15, 25],
    contentType: ContentType.TORMENTED_SPIRITS,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'prefix_totemic_torment_rare_monsters_possessed_chance': {
    id: 642,
    tradeId: 'explicit.stat_3788412017',
    description: 'Up to 5 Rare Monsters in each of your Maps are Possessed and their Minions are Touched',
    range: [0, 0],
    contentType: ContentType.TORMENTED_SPIRITS,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'prefix_totemic_torment_extra_spirits': {
    id: 643,
    tradeId: 'explicit.stat_358129101',
    description: 'Your Maps are haunted by an additional Tormented Spirit',
    range: [0, 0],
    contentType: ContentType.TORMENTED_SPIRITS,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'suffix_totemic_map_unique_monster_items_drop_corrupted_chance': {
    id: 644,
    tradeId: 'explicit.stat_1852765051',
    description: 'Items dropped by Unique Monsters have (10–15)% chance to be Corrupted',
    range: [10, 15],
    contentType: ContentType.VAAL_SIDE_AREAS,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'suffix_totemic_vaal_side_area_vaal_vessel_duplicate_rewards': {
    id: 645,
    tradeId: 'explicit.stat_4131593417',
    description: 'Vaal Side Areas in your Maps have (15–20)% chance for Rewards from Vaal Vessels to be Duplicated',
    range: [15, 20],
    contentType: ContentType.VAAL_SIDE_AREAS,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'prefix_totemic_map_additional_kirac_mission_on_completion_chance': {
    id: 646,
    tradeId: 'explicit.stat_2771143254',
    description: 'Your Maps have (5–8)% chance to grant an additional Kirac Mission on Completion',
    range: [5, 8],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'prefix_totemic_map_additionak_kirac_mission_on_completion_chance_per_myriad': {
    id: 647,
    tradeId: 'explicit.stat_2771143254',
    description: 'Your Maps have (2–2.5)% chance to grant an additional Kirac Mission on Completion',
    range: [2, 2.5],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'suffix_totemic_increased_map_drop_rarity': {
    id: 648,
    tradeId: 'explicit.stat_655058427',
    description: '(25–35)% increased Rarity of Maps found in your Maps',
    range: [25, 35],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'suffix'
  },
  'prefix_totemic_increased_item_rarity': {
    id: 649,
    tradeId: 'explicit.stat_2306002879',
    description: '(12–16)% increased Rarity of Items found in your Maps',
    range: [12, 16],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.TOTEMIC],
    type: 'prefix'
  },
  'prefix_conqueror_additional_abyss_chance': {
    id: 650,
    tradeId: 'explicit.stat_4278144676',
    description: 'Your Maps have +(45–70)% chance to contain an Abyss',
    range: [45, 70],
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'prefix_conqueror_increased_abyss_chance': {
    id: 651,
    tradeId: 'explicit.stat_4111037980',
    description: 'Your Maps have (224–280)% increased chance to contain an Abyss',
    range: [224, 280],
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'prefix_conqueror_increased_abyss_chance_per_pack_size': {
    id: 652,
    tradeId: 'explicit.stat_827686764',
    description: 'Your Maps have +(3–5)% chance to contain an Abyss per 2% increased Pack Size',
    range: [3, 5],
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'suffix_conqueror_abyss_jewels_corrupted_extra_mods': {
    id: 653,
    tradeId: 'explicit.stat_4842372',
    description: 'Abyss Jewels found in Abyssal Troves or dropped by Stygian Spires in your Maps have (15–25)% chance to be Corrupted and have 5 or 6 random Modifiers',
    range: [15, 25],
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_abyss_trove_jewel_corrupt_chance': {
    id: 654,
    tradeId: 'explicit.stat_286869897',
    description: 'Abyss Jewels dropped by Abyssal Troves or Stygian Spires in your Maps have a 1% Chance to be Rare and Corrupted',
    range: [0, 0],
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_abyss_chasm_spawn_five_additional_rare_chance': {
    id: 655,
    tradeId: 'explicit.stat_4049011082',
    description: 'Abyss Pits in your Maps have (14–20)% chance to spawn 5 additional Rare Monsters',
    range: [14, 20],
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_abyss_trove_drop_scarab_chance': {
    id: 656,
    tradeId: 'explicit.stat_1028265433',
    description: 'Abyssal Troves and Stygian Spires in your Maps have (3–5)% chance to drop an Abyss Scarab',
    range: [3, 5],
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_abyss_garuntee_four_chasms': {
    id: 657,
    tradeId: 'explicit.stat_1977826050',
    description: 'Abysses in your Maps that do not lead to an Abyssal Depths lead to 4 Pits if able',
    range: [0, 0],
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_abyss_garuntee_three_chasms': {
    id: 658,
    tradeId: 'explicit.stat_911724954',
    description: 'Abysses in your Maps that do not lead to an Abyssal Depths lead to at least 3 Pits if able',
    range: [0, 0],
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_abyss_increased_monsters_per_chasm': {
    id: 659,
    tradeId: 'explicit.stat_1927544133',
    description: 'Abysses in your Maps spawn (8–12)% increased Monsters for each prior Pit in that Abyss',
    range: [8, 12],
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_incursion_add_room_tier_architect_kill': {
    id: 660,
    tradeId: 'explicit.stat_3052174721',
    description: 'Killing resident Architects in your Maps adds their Upgrade Tier to the surviving Architect\'s Room',
    range: [0, 0],
    contentType: ContentType.INCURSION,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'prefix_conqueror_additional_incursion_chance': {
    id: 661,
    tradeId: 'explicit.stat_2709296039',
    description: 'Your Maps have +(45–70)% chance to contain Alva',
    range: [45, 70],
    contentType: ContentType.INCURSION,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'prefix_conqueror_increased_incursion_chance': {
    id: 662,
    tradeId: 'explicit.stat_3629418990',
    description: 'Your Maps have (224–280)% increased chance to contain Alva',
    range: [224, 280],
    contentType: ContentType.INCURSION,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'suffix_conqueror_incursion_special_monster': {
    id: 663,
    tradeId: 'explicit.stat_1822007489',
    description: 'Incursions in your Maps contain a Vaal Flesh Merchant',
    range: [0, 0],
    contentType: ContentType.INCURSION,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_incursion_additional_incursion': {
    id: 664,
    tradeId: 'explicit.stat_4224761993',
    description: 'Your Maps with Incursions always have four Incursions',
    range: [0, 0],
    contentType: ContentType.INCURSION,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_incursion_double_time_from_kill': {
    id: 665,
    tradeId: 'explicit.stat_1927424401',
    description: 'Time gained from Kills is Doubled for Incursions in your Maps',
    range: [0, 0],
    contentType: ContentType.INCURSION,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_incursion_cursed_treasure': {
    id: 666,
    tradeId: 'explicit.stat_1419687153',
    description: 'Incursions in your Maps contain Cursed Treasures',
    range: [0, 0],
    contentType: ContentType.INCURSION,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'prefix_conqueror_anarchy_many_exiles': {
    id: 667,
    tradeId: 'explicit.stat_776258428',
    description: 'Your Maps have a (5–8)% chance to contain 20 additional Rogue Exiles',
    range: [5, 8],
    contentType: ContentType.ROGUE_EXILES,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'prefix_conqueror_anarchy_additional_exiles_chance': {
    id: 668,
    tradeId: 'explicit.stat_1123357133',
    description: 'Your Maps have a (45–70)% chance to contain an additional Rogue Exile',
    range: [45, 70],
    contentType: ContentType.ROGUE_EXILES,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'prefix_conqueror_anarchy_exile_chance': {
    id: 669,
    tradeId: 'explicit.stat_2974922599',
    description: 'Your Maps have +(20–30)% chance to contain a Rogue Exile',
    range: [20, 30],
    contentType: ContentType.ROGUE_EXILES,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'suffix_conqueror_anarchy_exile_special_reward_chance': {
    id: 670,
    tradeId: 'explicit.stat_113499389',
    description: 'Wild Rogue Exiles in your Maps have (40–60)% chance to have additional Rewards',
    range: [40, 60],
    contentType: ContentType.ROGUE_EXILES,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'prefix_conqueror_bestiary_additional_chance': {
    id: 671,
    tradeId: 'explicit.stat_1566972708',
    description: 'Your Maps have +(45–70)% chance to contain Einhar',
    range: [45, 70],
    contentType: ContentType.BESTIARY,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'prefix_conqueror_bestiary_increased_chance': {
    id: 672,
    tradeId: 'explicit.stat_1301096166',
    description: 'Your Maps have (224–280)% increased chance to contain Einhar',
    range: [224, 280],
    contentType: ContentType.BESTIARY,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'suffix_conqueror_bestiary_less_common_varieties': {
    id: 673,
    tradeId: 'explicit.stat_4062346714',
    description: 'Beasts in your Maps are more likely to be less common varieties',
    range: [0, 0],
    contentType: ContentType.BESTIARY,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_besitary_einhar_ignores_completion': {
    id: 674,
    tradeId: 'explicit.stat_1766031838',
    description: 'Einhar remains in your Maps after his Mission is Complete',
    range: [0, 0],
    contentType: ContentType.BESTIARY,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_bestiary_red_replace_yellow_chance': {
    id: 675,
    tradeId: 'explicit.stat_4103953516',
    description: 'Yellow Beasts in your Maps have (12–18)% chance to be replaced with Red Beasts',
    range: [12, 18],
    contentType: ContentType.BESTIARY,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_bestiary_beast_break_free_chance': {
    id: 676,
    tradeId: 'explicit.stat_3241030924',
    description: 'Beasts in your Maps have a (15–20)% chance to break free Beasts which break free in your Maps gain Bestial Rage Defeating Beasts grants Hunters\' Cunning per Bestial Rage on the defeated Beast',
    range: [15, 20],
    contentType: ContentType.BESTIARY,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'prefix_conqueror_beyond_additional_chance': {
    id: 677,
    tradeId: 'explicit.stat_3438840900',
    description: '(45–70)% chance for your Maps to attract Beyond Demons',
    range: [45, 70],
    contentType: ContentType.BEYOND,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'suffix_conqueror_beyond_increased_portal_chance': {
    id: 678,
    tradeId: 'explicit.stat_3036422124',
    description: 'Slaying Enemies in your Maps has a (12–18)% increased chance to spawn a Beyond Portal',
    range: [12, 18],
    contentType: ContentType.BEYOND,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_beyond_boss_special_buff': {
    id: 679,
    tradeId: 'explicit.stat_3366450400',
    description: 'Gain Demonic Power on defeating a Beyond Boss in your Maps',
    range: [0, 0],
    contentType: ContentType.BEYOND,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_blight_chest_num_lucky_rewards': {
    id: 680,
    tradeId: 'explicit.stat_1730598557',
    description: 'Varieties of Items contained in (3–5) Blight Chests in your Maps are Lucky',
    range: [3, 5],
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'prefix_conqueror_blight_additional_encounter_chance': {
    id: 681,
    tradeId: 'explicit.stat_764545335',
    description: 'Your Maps have +(45–70)% chance to contain a Blight Encounter',
    range: [45, 70],
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'prefix_conqueror_blight_additional_chance': {
    id: 682,
    tradeId: 'explicit.stat_1393318927',
    description: 'Your Maps have (224–280)% increased chance to contain a Blight Encounter',
    range: [224, 280],
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'suffix_conqueror_blight_chest_reopenable_chance': {
    id: 683,
    tradeId: 'explicit.stat_278772496',
    description: 'Blight chests in your Maps have a (5–10)% chance to be openable again',
    range: [5, 10],
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_blight_touched_buff': {
    id: 684,
    tradeId: 'explicit.stat_3127831894',
    description: 'Completing a Blight Encounter in your Maps grants all Players Blightreach',
    range: [0, 0],
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_blight_towers_are_chests': {
    id: 685,
    tradeId: 'explicit.stat_1421406768',
    description: 'Blight Towers in your Maps can be Salvaged after the Blight Encounter Higher Tier Towers grant better Salvaged Rewards Salvaged Rewards are improved for each different Tower Type built during Encounter',
    range: [0, 0],
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_cleansing_fire_double_progress_chance': {
    id: 686,
    tradeId: 'explicit.stat_2523194133',
    description: 'Your Maps have (10–15)% chance to award double progress towards encountering The Searing Exarch',
    range: [10, 15],
    contentType: ContentType.SEARING_EXARCH,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_cleansing_fire_dupe_currency_chance': {
    id: 687,
    tradeId: 'explicit.stat_2514681311',
    description: 'Eldritch Embers found in your Maps influenced by The Searing Exarch have (10–15)% chance to be Duplicated',
    range: [10, 15],
    contentType: ContentType.SEARING_EXARCH,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'prefix_conqueror_delirium_additional_chance': {
    id: 688,
    tradeId: 'explicit.stat_1808954678',
    description: 'Your Maps have +(45–70)% chance to contain a Mirror of Delirium',
    range: [45, 70],
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'prefix_conqueror_delirium_increased_chance': {
    id: 689,
    tradeId: 'explicit.stat_3573600538',
    description: 'Your Maps have (224–280)% increased chance to contain a Mirror of Delirium',
    range: [224, 280],
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'prefix_conqueror_delirium_delirious_map_chance': {
    id: 690,
    tradeId: 'explicit.stat_1482478377',
    description: 'Maps found in your Maps have (3–5)% chance to have layers of Delirium',
    range: [3, 5],
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'suffix_conqueror_delirium_three_additional_reward_types_chance': {
    id: 691,
    tradeId: 'explicit.stat_2312030426',
    description: 'Delirium Encounters in your Maps have (8–12)% chance to generate three additional Reward types',
    range: [8, 12],
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_delirium_splinter_stack_size': {
    id: 692,
    tradeId: 'explicit.stat_2301218725',
    description: '(20–30)% increased Stack size of Simulacrum Splinters found in your Maps',
    range: [20, 30],
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_delirium_unique_monster_additional_delirium_orb_chance': {
    id: 693,
    tradeId: 'explicit.stat_4142971786',
    description: 'Delirious Unique Monsters in your Maps have a (1–2)% chance to drop an additional Delirium Orb',
    range: [1, 2],
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_delirium_unique_monster_additional_cluster_jewel_chance': {
    id: 694,
    tradeId: 'explicit.stat_3312982927',
    description: 'Delirious Unique Monsters in your Maps have a (2–3)% chance to drop an additional Cluster Jewel',
    range: [2, 3],
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'prefix_conqueror_delve_additional_chance': {
    id: 695,
    tradeId: 'explicit.stat_4267923742',
    description: 'Your Maps have +(45–70)% chance to contain Niko',
    range: [45, 70],
    contentType: ContentType.DELVE,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'prefix_conqueror_delve_increased_chance': {
    id: 696,
    tradeId: 'explicit.stat_399319107',
    description: 'Your Maps have (224–280)% increased chance to contain Niko',
    range: [224, 280],
    contentType: ContentType.DELVE,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'suffix_conqueror_delve_guarded_sulphite': {
    id: 697,
    tradeId: 'explicit.stat_2503157846',
    description: 'Voltaxic Sulphite Veins and Chests in your Maps are guarded by Sulphite-hoarding Monsters',
    range: [0, 0],
    contentType: ContentType.DELVE,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_delve_max_resistance_per_sulphite_mined': {
    id: 698,
    tradeId: 'explicit.stat_3363725306',
    description: 'You gain +(2–3)% to all maximum Elemental Resistances per stack of Sulphite Intoxication',
    range: [2, 3],
    contentType: ContentType.DELVE,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_delve_surprise': {
    id: 699,
    tradeId: 'explicit.stat_3236481633',
    description: 'Voltaxic Sulphite Veins and Chests found in your Maps contains Doomed Spirits',
    range: [0, 0],
    contentType: ContentType.DELVE,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'prefix_conqueror_shrine_num': {
    id: 700,
    tradeId: 'explicit.stat_1468737867',
    description: 'Your Maps contain an additional Shrine',
    range: [1, 2],
    contentType: ContentType.SHRINES,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'prefix_conqueror_shrine_increased_chance': {
    id: 701,
    tradeId: 'explicit.stat_2571125745',
    description: 'Your Maps have +(20–30)% chance to contain a Shrine',
    range: [20, 30],
    contentType: ContentType.SHRINES,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'suffix_conqueror_shrine_garunteed_magic_pack': {
    id: 702,
    tradeId: 'explicit.stat_2167121354',
    description: 'Shrines in your Maps are guarded by at least one Magic Pack',
    range: [0, 0],
    contentType: ContentType.SHRINES,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_shrine_additional_effect': {
    id: 703,
    tradeId: 'explicit.stat_1594755360',
    description: 'Shrines in your Maps grant a random additional Shrine Effect',
    range: [0, 0],
    contentType: ContentType.SHRINES,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_shrine_greed_shrine_chance': {
    id: 704,
    tradeId: 'explicit.stat_2831543675',
    description: 'Shrines in your Maps have (8–12)% chance to be a Covetous Shrine',
    range: [8, 12],
    contentType: ContentType.SHRINES,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_zana_influence_lucky_strand_chance': {
    id: 705,
    tradeId: 'explicit.stat_4108379292',
    description: 'The number of Memory Strands on Equipment Items found in your Maps has (30–50)% chance to be Lucky',
    range: [30, 50],
    contentType: ContentType.ZANA,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'prefix_conqueror_essence_additional_monoliths': {
    id: 706,
    tradeId: 'explicit.stat_395808938',
    description: 'Your Maps contain (1–2) additional Imprisoned Monsters',
    range: [1, 2],
    contentType: ContentType.ESSENCE,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'prefix_conqueror_essence_increased_chance': {
    id: 707,
    tradeId: 'explicit.stat_4098286334',
    description: 'Your Maps have +(20–30)% chance to contain an Imprisoned Monster',
    range: [20, 30],
    contentType: ContentType.ESSENCE,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'suffix_conqueror_essence_num_at_max_tier': {
    id: 708,
    tradeId: 'explicit.stat_2175157402',
    description: 'Imprisoned Monsters in your Maps have at least 1 Essence at the highest possible tier',
    range: [0, 0],
    contentType: ContentType.ESSENCE,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_essence_one_tier_higher_chance': {
    id: 709,
    tradeId: 'explicit.stat_1506277901',
    description: 'Essences found in your Maps have (25–35)% chance to be a tier higher',
    range: [25, 35],
    contentType: ContentType.ESSENCE,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_essence_corrupt_convert': {
    id: 710,
    tradeId: 'explicit.stat_1019460035',
    description: 'Using a Vaal Orb on Imprisoned Monsters in your Maps replaces all Essences with one of the Essences on the Imprisoned Monster',
    range: [0, 0],
    contentType: ContentType.ESSENCE,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'prefix_conqueror_expedition_additional_chance': {
    id: 711,
    tradeId: 'explicit.stat_4154778375',
    description: 'Your Maps have +(45–70)% chance to contain an Expedition Encounter',
    range: [45, 70],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'prefix_conqueror_expedition_increased_chance': {
    id: 712,
    tradeId: 'explicit.stat_1561678231',
    description: 'Your Maps have (224–280)% increased chance to contain an Expedition Encounter',
    range: [224, 280],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'suffix_conqueror_expedition_explosive_placement_distance': {
    id: 713,
    tradeId: 'explicit.stat_1539368271',
    description: '(80–120)% increased Explosive Placement Range in your Maps',
    range: [80, 120],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_expedition_additional_relics': {
    id: 714,
    tradeId: 'explicit.stat_3753446846',
    description: 'Expeditions in your Maps have +(1–2) Remnants',
    range: [1, 2],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_expedition_increased_elite_marker_count': {
    id: 715,
    tradeId: 'explicit.stat_1640965354',
    description: 'Your Maps contain (20–25)% increased number of Runic Monster Markers',
    range: [20, 25],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'prefix_conqueror_harbinger_extra_harbingers': {
    id: 716,
    tradeId: 'explicit.stat_504850499',
    description: 'Your Maps contain (1–2) additional Harbingers',
    range: [1, 2],
    contentType: ContentType.HARBINGER,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'prefix_conqueror_harbinger_additional_harbinger_chance': {
    id: 717,
    tradeId: 'explicit.stat_266448395',
    description: 'Your Maps have a (20–30)% chance to contain an additional Harbinger',
    range: [20, 30],
    contentType: ContentType.HARBINGER,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'suffix_conqueror_harbinger_num_shards_to_drop_as_full_currency': {
    id: 718,
    tradeId: 'explicit.stat_866347860',
    description: 'Currency Shards dropped by Harbingers in your Maps can drop as Currency Items instead',
    range: [0, 0],
    contentType: ContentType.HARBINGER,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'prefix_conqueror_harvest_additional_chance': {
    id: 719,
    tradeId: 'explicit.stat_1145451936',
    description: 'Your Maps have +(45–70)% chance to contain The Sacred Grove',
    range: [45, 70],
    contentType: ContentType.HARVEST,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'prefix_conqueror_harvest_increased_chance': {
    id: 720,
    tradeId: 'explicit.stat_2936740844',
    description: 'Your Maps have (224–280)% increased chance to contain The Sacred Grove',
    range: [224, 280],
    contentType: ContentType.HARVEST,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'suffix_conqueror_harvest_duplicated_monster_chance': {
    id: 721,
    tradeId: 'explicit.stat_2634325281',
    description: 'Plants Harvested in your Maps have (4–8)% chance to spawn duplicated Monsters',
    range: [4, 8],
    contentType: ContentType.HARVEST,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_harvest_seeds_additional_monster_chance': {
    id: 722,
    tradeId: 'explicit.stat_4128958145',
    description: 'Harvested Plants in your Maps have (10–15)% chance to spawn an additional Monster',
    range: [10, 15],
    contentType: ContentType.HARVEST,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_harvest_duplicate_lifeforce_chance': {
    id: 723,
    tradeId: 'explicit.stat_2591612078',
    description: 'Lifeforce dropped by Harvest Monsters in your Maps has (10–15)% chance to be Duplicated',
    range: [10, 15],
    contentType: ContentType.HARVEST,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'prefix_conqueror_heist_additional_cache_chance': {
    id: 724,
    tradeId: 'explicit.stat_1975869602',
    description: 'Your Maps have +(45–70)% chance to contain a Smuggler\'s Cache',
    range: [45, 70],
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'prefix_conqueror_heist_increased_cache_chance': {
    id: 725,
    tradeId: 'explicit.stat_4069523014',
    description: 'Your Maps have (224–280)% increased chance to contain a Smuggler\'s Cache',
    range: [224, 280],
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'suffix_conqueror_heist_blueprint_drop_revealed_chance': {
    id: 726,
    tradeId: 'explicit.stat_3113439544',
    description: 'Blueprints that drop in your Maps have (10–15)% chance to be fully Revealed',
    range: [10, 15],
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_heist_six_caches_chance': {
    id: 727,
    tradeId: 'explicit.stat_1488908340',
    description: 'Your Maps that contain Smuggler\'s Caches have a (4–6)% chance to contain 6 additional Smuggler\'s Caches',
    range: [4, 6],
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_heist_cache_blueprint_chance_per_opened_cache': {
    id: 728,
    tradeId: 'explicit.stat_3556555275',
    description: 'Smuggler\'s Caches in your Maps have (10–15)% increased chance to contain Blueprints for each Smuggler\'s Cache opened in the Map',
    range: [10, 15],
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_heist_huck_spawns_from_cache': {
    id: 729,
    tradeId: 'explicit.stat_4286661423',
    description: 'Huck accompanies you on opening the first Smuggler\'s Cache in each of your Maps',
    range: [0, 0],
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'prefix_conqueror_betrayal_additional_chance': {
    id: 730,
    tradeId: 'explicit.stat_527292219',
    description: 'Your Maps have +(45–70)% chance to contain Jun',
    range: [45, 70],
    contentType: ContentType.BETRAYAL,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'prefix_conqueror_betrayal_increased_chance': {
    id: 731,
    tradeId: 'explicit.stat_4116217552',
    description: 'Your Maps have (224–280)% increased chance to contain Jun',
    range: [224, 280],
    contentType: ContentType.BETRAYAL,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'suffix_conqueror_betrayal_bargin_drops_more_items': {
    id: 732,
    tradeId: 'explicit.stat_574706723',
    description: 'Immortal Syndicate Members in your Maps drop (100–200)% more Items when Bargained with for Items',
    range: [100, 200],
    contentType: ContentType.BETRAYAL,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_betrayal_map_completion_random_safehouse_intelligence': {
    id: 733,
    tradeId: 'explicit.stat_424189350',
    description: 'Completing your Maps grants (10–15) Intelligence for a random Immortal Syndicate Safehouse',
    range: [10, 15],
    contentType: ContentType.BETRAYAL,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_ascendancy_improved_offering_chance': {
    id: 734,
    tradeId: 'explicit.stat_340272125',
    description: 'Labyrinth Trials in your Maps have (20–25)% chance to award an Improved Offering to the Goddess',
    range: [20, 25],
    contentType: ContentType.LAB,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'prefix_conqueror_legion_additional_chance': {
    id: 735,
    tradeId: 'explicit.stat_1981273563',
    description: 'Your Maps have +(45–70)% chance to contain a Legion Encounter',
    range: [45, 70],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'prefix_conqueror_legion_increased_chance': {
    id: 736,
    tradeId: 'explicit.stat_310950600',
    description: 'Your Maps have (224–280)% increased chance to contain a Legion Encounter',
    range: [224, 280],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'suffix_conqueror_legion_additional_num_sergeants': {
    id: 737,
    tradeId: 'explicit.stat_480028751',
    description: 'Legion Encounters in your Maps contain (2-2) additional Sergeants',
    range: [2, 2],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_legion_spawn_both_generals': {
    id: 738,
    tradeId: 'explicit.stat_2347014488',
    description: 'Legion Encounters with a General in your Maps have both Generals',
    range: [0, 0],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_legion_splinter_drop_as_fragment_chance': {
    id: 739,
    tradeId: 'explicit.stat_407036985',
    description: '(0.5–0.75)% chance for Timeless Splinters to drop as Timeless Emblems instead in your Maps',
    range: [0.5, 0.75],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'prefix_conqueror_map_random_craft_on_completion_chance': {
    id: 740,
    tradeId: 'explicit.stat_2721059969',
    description: '(8–12)% chance on Completing your Maps to gain a free use of a random Map Crafting option',
    range: [8, 12],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'prefix_conqueror_map_special_craft_on_completion_chance': {
    id: 741,
    tradeId: 'explicit.stat_3858757876',
    description: '(3–4)% chance on Completing your Maps to gain a free use of a special Map Crafting option',
    range: [3, 4],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'prefix_conqueror_ultimatum_increased_chance': {
    id: 742,
    tradeId: 'explicit.stat_880963174',
    description: 'Your Maps have (224–280)% increased chance to contain an Ultimatum Encounter',
    range: [224, 280],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'prefix_conqueror_ultimatum_additional_chance': {
    id: 743,
    tradeId: 'explicit.stat_1365687125',
    description: 'Your Maps have +(45–70)% chance to contain an Ultimatum Encounter',
    range: [45, 70],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'suffix_conqueror_ultimatum_additional_reward_tiers': {
    id: 744,
    tradeId: 'explicit.stat_1937345315',
    description: 'Ultimatum Encounters in your Maps grant rewards as though you completed an additional Round',
    range: [0, 0],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_ultimatum_trialmaster_drops_stack_of_catalysts': {
    id: 745,
    tradeId: 'explicit.stat_236047788',
    description: 'Ultimatum Boss drops a full stack of a random Catalyst',
    range: [0, 0],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_ultimatum_reward_dupe_chance': {
    id: 746,
    tradeId: 'explicit.stat_1683239984',
    description: 'Ultimatum Rewards in your Maps have (20–25)% chance to be duplicated',
    range: [20, 25],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'prefix_conqueror_settlers_increased_chance': {
    id: 747,
    tradeId: 'explicit.stat_2661886285',
    description: 'Your Maps have (224–280)% increased chance to contain Ore Deposits',
    range: [224, 280],
    contentType: ContentType.SETTLERS,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'prefix_conqueror_settlers_additional_chance': {
    id: 748,
    tradeId: 'explicit.stat_2661886285',
    description: 'Your Maps have +(45–70)% chance to contain Ore Deposits',
    range: [45, 70],
    contentType: ContentType.SETTLERS,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'suffix_conqueror_settlers_rarer_ores': {
    id: 749,
    tradeId: 'explicit.stat_3201470460',
    description: 'Ore Deposits in your Maps are more likely to be rarer varieties',
    range: [0, 0],
    contentType: ContentType.SETTLERS,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_settlers_lost_shipment_chance': {
    id: 750,
    tradeId: 'explicit.stat_643727077',
    description: '(5–7)% chance for Ore Deposits in your Maps to be replaced by Lost Shipments',
    range: [5, 7],
    contentType: ContentType.SETTLERS,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'prefix_conqueror_ritual_additional_chance': {
    id: 751,
    tradeId: 'explicit.stat_1314822783',
    description: 'Your Maps have +(45–70)% chance to contain Ritual Altars',
    range: [45, 70],
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'prefix_conqueror_ritual_increased_chance': {
    id: 752,
    tradeId: 'explicit.stat_1777351949',
    description: 'Your Maps have (224–280)% increased chance to contain Ritual Altars',
    range: [224, 280],
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'suffix_conqueror_ritual_four_encounters': {
    id: 753,
    tradeId: 'explicit.stat_2302977956',
    description: 'Your Maps with Ritual Altars always have four Ritual Altars',
    range: [0, 0],
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_ritual_additional_rerolls': {
    id: 754,
    tradeId: 'explicit.stat_120737942',
    description: 'Ritual Altars in your Maps allow rerolling Favours an additional time',
    range: [0, 0],
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_ritual_deferred_rewards_tribute_cost': {
    id: 755,
    tradeId: 'explicit.stat_1345835998',
    description: 'Deferring Favours at Ritual Altars in your Maps costs (15–20)% reduced Tribute',
    range: [15, 20],
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_scarab_chance_to_not_consume': {
    id: 756,
    tradeId: 'explicit.stat_4140427516',
    description: 'Map Device has (3–5)% chance not to consume Scarabs',
    range: [3, 5],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_scarab_less_common_types': {
    id: 757,
    tradeId: 'explicit.stat_2789471089',
    description: 'Scarabs found in your Maps are more likely to be less common varieties',
    range: [0, 0],
    contentType: ContentType.SCARABS,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'prefix_conqueror_strongbox_additional': {
    id: 758,
    tradeId: 'explicit.stat_3240183538',
    description: 'Your Maps contain (1–2) additional Strongboxes',
    range: [1, 2],
    contentType: ContentType.STRONGBOXES,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'prefix_conqueror_strongbox_increased_chance': {
    id: 759,
    tradeId: 'explicit.stat_2388936716',
    description: 'Your Maps have +(20–30)% chance to contain a Strongbox',
    range: [20, 30],
    contentType: ContentType.STRONGBOXES,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'suffix_conqueror_strongbox_at_least_rare': {
    id: 760,
    tradeId: 'explicit.stat_1564500422',
    description: 'Strongboxes in your Maps are at least Rare',
    range: [0, 0],
    contentType: ContentType.STRONGBOXES,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_strongbox_corrupted': {
    id: 761,
    tradeId: 'explicit.stat_2681419531',
    description: 'Strongboxes in your Maps are Corrupted',
    range: [0, 0],
    contentType: ContentType.STRONGBOXES,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_strongbox_reopen_chance': {
    id: 762,
    tradeId: 'explicit.stat_3353484695',
    description: 'Strongboxes opened in your Maps have (5–9)% chance to be openable again',
    range: [5, 9],
    contentType: ContentType.STRONGBOXES,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_synthesis_monster_pack_size': {
    id: 763,
    tradeId: 'explicit.stat_2049349490',
    description: 'Synthesised Monsters in Synthesis Maps have (20–30)% increased Pack Size',
    range: [20, 30],
    contentType: ContentType.SYNTHESIS,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'suffix_conqueror_tangle_influence_pack_size': {
    id: 764,
    tradeId: 'explicit.stat_4185631652',
    description: 'Monster Packs Influenced by The Eater of Worlds in your Maps have (25–35)% increased Pack Size',
    range: [25, 35],
    contentType: ContentType.EATER_OF_WORLDS,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'prefix_conqueror_torment_increased_chance': {
    id: 765,
    tradeId: 'explicit.stat_2750973094',
    description: 'Your Maps have +(20–30)% chance to be haunted by a Tormented Spirit',
    range: [20, 30],
    contentType: ContentType.TORMENTED_SPIRITS,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'suffix_conqueror_torment_rare_spirits_more_common': {
    id: 766,
    tradeId: 'explicit.stat_564845047',
    description: 'Tormented Spirits in your Maps are more likely to be less common varieties',
    range: [0, 0],
    contentType: ContentType.TORMENTED_SPIRITS,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'prefix_conqueror_torment_extra_spirits': {
    id: 767,
    tradeId: 'explicit.stat_358129101',
    description: 'Your Maps are haunted by an additional Tormented Spirit',
    range: [0, 0],
    contentType: ContentType.TORMENTED_SPIRITS,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'suffix_conqueror_maven_witnesses_additional_map_chance': {
    id: 768,
    tradeId: 'explicit.stat_3089299676',
    description: 'Defeating a Map Boss while Witnessed by The Maven has (10–15)% chance to count as also Witnessing an additional random Map Boss',
    range: [10, 15],
    contentType: ContentType.MAVEN,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'suffix'
  },
  'prefix_conqueror_increased_item_quantity': {
    id: 769,
    tradeId: 'explicit.stat_2390685262',
    description: '(4–6)% increased Quantity of Items found in your Maps',
    range: [4, 6],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'prefix_conqueror_increased_pack_size': {
    id: 770,
    tradeId: 'explicit.stat_2017682521',
    description: '(4–6)% increased Pack Size in your Maps',
    range: [4, 6],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'prefix_conqueror_map_mod_effect_per_five_quality': {
    id: 771,
    tradeId: 'explicit.stat_2490189905',
    description: '(2–4)% increased effect of Explicit Modifiers on your Maps per 5% Map Quality',
    range: [2, 4],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
  'prefix_conqueror_map_mod_effect_per_map_mod': {
    id: 772,
    tradeId: 'explicit.stat_2792863714',
    description: '2% increased effect of Explicit Modifiers on your Maps per Explicit Modifier',
    range: [0, 0],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.CONQUEROR],
    type: 'prefix'
  },
    // Arbitrary Tenets
  'prefix_arbitrary_tenets_1': {
    id: 1001,
      tradeId: 'explicit.stat_1276541261',
    description: 'Favours at Ritual Altars in your Maps randomly cost between 90% less and 80% more',
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Black Thumb
  'prefix_black_thumb_1': {
    id: 1002,
      tradeId: 'explicit.stat_328145899',
    description: 'Your Maps have no chance to contain the Sacred Grove',
    contentType: ContentType.HARVEST,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_black_thumb_2': {
    id: 1003,
      tradeId: 'explicit.stat_388787643',
    description: 'Scarabs found in your Maps cannot be Harvest Scarabs',
    contentType: ContentType.HARVEST,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_black_thumb_3': {
    id: 1004,
      tradeId: 'explicit.stat_344979199',
    description: 'Your Maps have +5% chance to contain other Extra Content that can be turned off through Atlas Passives',
    contentType: ContentType.HARVEST,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Bold Undertakings
  'prefix_bold_undertakings_1': {
    id: 1005,
      tradeId: 'explicit.stat_1944897696',
    description: 'Fortune Favours the Brave applies an additional random Option',
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_bold_undertakings_2': {
    id: 1006,
      tradeId: 'explicit.stat_1944897696',
    description: '100% more cost of the Fortune Favours the Brave Map Crafting Option',
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Cassia's Pride
  'prefix_cassias_pride_1': {
    id: 1007,
      tradeId: 'explicit.stat_2460639269',
    description: 'Blight Monsters in your Maps take (75–65)% less Damage from Players and their Minions',
    range: [65, 75],
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_cassias_pride_2': {
    id: 1008,
      tradeId: 'explicit.stat_3738423246',
    description: 'Blight Towers and their Minions in your Maps deal (300–400)% more Damage',
    range: [300, 400],
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Crop Rotation
  'prefix_crop_rotation_1': {
    id: 1009,
      tradeId: 'explicit.stat_2765997141',
    description: 'Harvest Crops in your Maps contain only Tier 1 Plants',
    contentType: ContentType.HARVEST,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_crop_rotation_2': {
    id: 1010,
      tradeId: 'explicit.stat_2765997141',
    description: 'Harvesting Crops in your Maps has a chance to upgrade the Tier of Plants of different colours',
    contentType: ContentType.HARVEST,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Crystallised Power
  'prefix_crystallised_power_1': {
    id: 1011,
      tradeId: 'explicit.stat_2623157736',
    description: 'A Map Boss is granted a random Essence Modifier from any Imprisoned Monsters slain in your Maps',
    contentType: ContentType.ESSENCE,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Dance of Destruction
  'prefix_dance_of_destruction_1': {
    id: 1012,
      tradeId: 'explicit.stat_3516276449',
    description: 'Monsters in your Maps deal (20–25)% more Damage',
    range: [20, 25],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_dance_of_destruction_2': {
    id: 1013,
    tradeId: 'explicit.stat_4190580879',
    description: 'Monsters in your Maps have (30–25)% less Life',
    range: [25, 30],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Destructive Play
  'prefix_destructive_play_1': {
    id: 1014,
    tradeId: 'explicit.stat_2960155368',
    description: 'The Maven casts Up the Stakes, summoning 1 to 3 additional Atlas Bosses when Witnessing Map Bosses',
    contentType: ContentType.MAVEN,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_destructive_play_2': {
    id: 1015,
      tradeId: '',
    description: 'The number of additional Bosses summoned is higher if there are fewer monsters remaining in the Map',
    contentType: ContentType.MAVEN,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_destructive_play_3': {
    id: 1016,
      tradeId: '',
    description: 'Modifiers to the Final Map Boss in each Map also apply to these summoned Bosses',
    contentType: ContentType.MAVEN,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Dimensional Barrier
  'prefix_dimensional_barrier_1': {
    id: 1017,
      tradeId: 'explicit.stat_1562449600',
    description: 'Your Maps have no chance to contain Breaches',
    contentType: ContentType.BREACH,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_dimensional_barrier_2': {
    id: 1018,
      tradeId: 'explicit.stat_1089629910',
    description: 'Scarabs found in your Maps cannot be Breach Scarabs',
    contentType: ContentType.BREACH,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_dimensional_barrier_3': {
    id: 1019,
      tradeId: 'explicit.stat_344979199',
    description: 'Your Maps have +5% chance to contain other Extra Content that can be turned off through Atlas Passives',
    contentType: ContentType.BREACH,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Eldritch Gaze
  'prefix_eldritch_gaze_1': {
    id: 1020,
      tradeId: 'explicit.stat_1488839433',
    description: 'Eldritch Altars Influenced by The Eater of Worlds have an additional Downside',
    contentType: ContentType.EATER_OF_WORLDS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_eldritch_gaze_2': {
    id: 1021,
      tradeId: 'explicit.stat_3619368685',
    description: 'Eldritch Altars Influenced by The Eater of Worlds have (50–60)% increased Effect of Upsides',
    range: [50, 60],
    contentType: ContentType.EATER_OF_WORLDS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Endless Tide
  'prefix_endless_tide_1': {
    id: 1022,
      tradeId: 'explicit.stat_1280481887',
    description: 'Beyond Portals in your Maps cannot spawn Unique Bosses',
    contentType: ContentType.BEYOND,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_endless_tide_2': {
    id: 1023,
      tradeId: 'explicit.stat_3009539307',
    description: 'Beyond Portals in your Maps have (50–40)% less Merging Radius',
    range: [40, 50],
    contentType: ContentType.BEYOND,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Extreme Archaeology
  'prefix_extreme_archaeology_1': {
    id: 1024,
      tradeId: 'explicit.stat_353291915',
    description: 'Number of Explosives is one',
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_extreme_archaeology_2': {
    id: 1025,
      tradeId: 'explicit.stat_3289828378',
    description: '(200–250)% increased Explosive Radius in your Maps',
    range: [200, 250],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_extreme_archaeology_3': {
    id: 1026,
      tradeId: 'explicit.stat_2684644644',
    description: 'Expedition Monsters in your Maps spawn with an additional (10–15)% of Life missing',
    range: [10, 15],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_extreme_archaeology_4': {
    id: 1027,
      tradeId: 'explicit.stat_1539368271',
    description: '(100–150)% increased Explosive Placement Range in your Maps',
    range: [100, 150],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Fungal Remission
  'prefix_fungal_remission_1': {
    id: 1028,
      tradeId: 'explicit.stat_1981776737',
    description: 'Your Maps have no chance to contain Blight Encounters',
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_fungal_remission_2': {
    id: 1029,
      tradeId: 'explicit.stat_785938790',
    description: 'Scarabs found in your Maps cannot be Blight Scarabs',
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_fungal_remission_3': {
    id: 1030,
      tradeId: 'explicit.stat_344979199',
    description: 'Your Maps have +5% chance to contain other Extra Content that can be turned off through Atlas Passives',
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Gruelling Gauntlet
  'prefix_gruelling_gauntlet_1': {
    id: 1031,
      tradeId: 'explicit.stat_3283585444',
    description: 'Ultimatum Encounters in your Maps last up to 13 Rounds',
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_gruelling_gauntlet_2': {
    id: 1032,
      tradeId: 'explicit.stat_3845167239',
    description: 'Players cannot choose which Ultimatum Modifier is applied each Round',
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_gruelling_gauntlet_3': {
    id: 1033,
      tradeId: 'explicit.stat_2694161522',
    description: 'Cannot have a Boss in the final Round',
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Immutable Dogma
  'prefix_immutable_dogma_1': {
    id: 1034,
      tradeId: 'explicit.stat_164133604',
    description: 'Cannot Reroll Favours at Ritual Altars in your Maps',
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_immutable_dogma_2': {
    id: 1035,
      tradeId: 'explicit.stat_2590915311',
    description: 'Monsters Sacrificed at Ritual Altars in your Maps grant (100–150)% more Tribute',
    range: [100, 150],
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Loved by the Sun
  'prefix_loved_by_the_sun_1': {
    id: 1036,
      tradeId: 'explicit.stat_2399560930',
    description: 'Your Maps have no chance to contain Abysses',
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_loved_by_the_sun_2': {
    id: 1037,
      tradeId: 'explicit.stat_1978710645',
    description: 'Scarabs found in your Maps cannot be Abyss Scarabs',
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_loved_by_the_sun_3': {
    id: 1038,
      tradeId: 'explicit.stat_344979199',
    description: 'Your Maps have +5% chance to contain other Extra Content that can be turned off through Atlas Passives',
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Lucid Dreams
  'prefix_lucid_dreams_1': {
    id: 1039,
      tradeId: 'explicit.stat_1516986886',
    description: 'Vaal Side Areas in your Maps are no longer Corrupted',
    contentType: ContentType.VAAL_SIDE_AREAS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Meticulous Appraiser
  'prefix_meticulous_appraiser_1': {
    id: 1040,
      tradeId: 'explicit.stat_3399892496',
    description: 'Modifiers to Quantity of Items found in your Maps instead apply to Rarity of Items found in your Maps at 300% of their value',
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Ominous Silence
  'prefix_ominous_silence_1': {
    id: 1041,
      tradeId: 'explicit.stat_2400312255',
    description: 'Your Maps have no chance to contain Mirrors of Delirium',
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_ominous_silence_2': {
    id: 1042,
      tradeId: 'explicit.stat_278421201',
    description: 'Scarabs found in your Maps cannot be Delirium Scarabs',
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_ominous_silence_3': {
    id: 1043,
      tradeId: 'explicit.stat_344979199',
    description: 'Your Maps have +5% chance to contain other Extra Content that can be turned off through Atlas Passives',
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Perceived Greatness
  'prefix_perceived_greatness_1': {
    id: 1044,
      tradeId: 'explicit.stat_3428124128',
    description: 'Delirious Monsters Killed in your Maps provide (30–20)% increased Reward Progress',
    range: [-30, -20],
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_perceived_greatness_2': {
    id: 1045,
      tradeId: 'explicit.stat_3387171641',
    description: 'Delirium Reward Types in your Maps gain +1 to count on Map Completion',
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Ruinous Wager
  'prefix_ruinous_wager_1': {
    id: 1046,
      tradeId: 'explicit.stat_3645622851',
    description: 'Ultimatum Monsters in your Maps apply Ruin with their special abilities',
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_ruinous_wager_2': {
    id: 1047,
      tradeId: '',
    description: 'Fail on reaching 7 Ruin',
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_ruinous_wager_3': {
    id: 1048,
      tradeId: 'explicit.stat_3683980805',
    description: 'Ultimatum Monsters and Modifiers in your Maps deal (60–50)% less Damage',
    range: [50, 60],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Sealed Domain
  'prefix_sealed_domain_1': {
    id: 1049,
      tradeId: 'explicit.stat_1132162798',
    description: 'Your Maps have no chance to contain Legion Encounters',
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_sealed_domain_2': {
    id: 1050,
      tradeId: 'explicit.stat_3777973541',
    description: 'Scarabs found in your Maps cannot be Legion Scarabs',
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_sealed_domain_3': {
    id: 1051,
      tradeId: 'explicit.stat_344979199',
    description: 'Your Maps have +5% chance to contain other Extra Content that can be turned off through Atlas Passives',
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Secular Focus
  'prefix_secular_focus_1': {
    id: 1052,
      tradeId: 'explicit.stat_847340197',
    description: 'Your Maps have no chance to contain Ritual Altars',
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_secular_focus_2': {
    id: 1053,
      tradeId: 'explicit.stat_1693489030',
    description: 'Scarabs found in your Maps cannot be Ritual Scarabs',
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_secular_focus_3': {
    id: 1054,
      tradeId: 'explicit.stat_344979199',
    description: 'Your Maps have +5% chance to contain other Extra Content that can be turned off through Atlas Passives',
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Servant of Order
  'prefix_servant_of_order_1': {
    id: 1055,
      tradeId: 'explicit.stat_3819443367',
    description: 'Your Maps have no chance to contain Ultimatum Encounters',
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_servant_of_order_2': {
    id: 1056,
      tradeId: 'explicit.stat_264552782',
    description: 'Scarabs found in your Maps cannot be Ultimatum Scarabs',
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_servant_of_order_3': {
    id: 1057,
      tradeId: 'explicit.stat_344979199',
    description: 'Your Maps have +5% chance to contain other Extra Content that can be turned off through Atlas Passives',
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Shadow Shaping
  'prefix_shadow_shaping_1': {
    id: 1058,
      tradeId: 'explicit.stat_441900529',
    description: 'Maps found cannot be your Favoured Maps',
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_shadow_shaping_2': {
    id: 1059,
      tradeId: 'explicit.stat_1363247141',
    description: 'Maps found in your Maps have +1% chance to have a special Implicit Modifier for each different Map you have Favoured',
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Singular Focus
  'prefix_singular_focus_1': {
    id: 1060,
      tradeId: 'explicit.stat_3527275979',
    description: 'Maps found have (200–220)% more chance to be Favoured Maps',
    range: [200, 220],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_singular_focus_2': {
    id: 1061,
      tradeId: 'explicit.stat_3764294022',
    description: 'Non–Favoured Maps found in your Maps drop as Basic Currency Items instead',
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Smash and Grab
  'prefix_smash_and_grab_1': {
    id: 1062,
      tradeId: 'explicit.stat_95850091',
    description: 'Each Legion in your Maps contains an additional War Hoard',
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_smash_and_grab_2': {
    id: 1063,
      tradeId: 'explicit.stat_1088328219',
    description: 'Legion Chests in your Maps contain an additional Random Reward',
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_smash_and_grab_3': {
    id: 1064,
      tradeId: 'explicit.stat_699122342',
    description: 'Legion Encounters in your Maps have (80–60)% reduced Duration',
    range: [60, 80],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Speaker of the Dead
  'prefix_speaker_of_the_dead_1': {
    id: 1065,
      tradeId: 'explicit.stat_3249943883',
    description: 'Tormented Spirits in your Maps can Possess Players for 20 seconds',
    contentType: ContentType.TORMENTED_SPIRITS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_speaker_of_the_dead_2': {
    id: 1066,
      tradeId: 'explicit.stat_3249943883',
    description: 'Tormented Spirits in your Maps cannot Possess Monsters',
    contentType: ContentType.TORMENTED_SPIRITS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Straight and Narrow
  'prefix_straight_and_narrow_1': {
    id: 1067,
      tradeId: 'explicit.stat_3178985579',
    description: 'Your Maps have no chance to contain Smuggler\'s Caches',
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_straight_and_narrow_2': {
    id: 1068,
      tradeId: 'explicit.stat_1379148633',
    description: 'Rogue\'s Markers, Contracts and Blueprints cannot be found in Your Maps',
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_straight_and_narrow_3': {
    id: 1069,
      tradeId: 'explicit.stat_344979199',
    description: 'Your Maps have +5% chance to contain other Extra Content that can be turned off through Atlas Passives',
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Thorough Exploration
  'prefix_thorough_exploration_1': {
    id: 1070,
      tradeId: 'explicit.stat_199329214',
    description: 'If there are fewer than 50 monsters remaining in your Maps, Final Map Bosses are Empowered by Wildwood Wisps',
    contentType: ContentType.MISC,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Timeless Conflict
  'prefix_timeless_conflict_1': {
    id: 1071,
      tradeId: 'explicit.stat_222333372',
    description: 'Legion Encounters in your Maps have no Timer',
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_timeless_conflict_2': {
    id: 1072,
      tradeId: 'explicit.stat_222333372',
    description: 'Breaking out Monsters and Chests that are in stasis progressively causes a Schism',
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_timeless_conflict_3': {
    id: 1073,
      tradeId: 'explicit.stat_222333372',
    description: 'Legion Encounters in your Maps begin once the Schism has occurred',
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Trade Embargo
  'prefix_trade_embargo_1': {
    id: 1074,
      tradeId: 'explicit.stat_2978599106',
    description: 'Your Maps have no chance to contain Expedition Encounters',
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_trade_embargo_2': {
    id: 1075,
      tradeId: 'explicit.stat_3965835074',
    description: 'Scarabs found in your Maps cannot be Expedition Scarabs',
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_trade_embargo_3': {
    id: 1076,
      tradeId: 'explicit.stat_344979199',
    description: 'Your Maps have +5% chance to contain other Extra Content that can be turned off through Atlas Passives',
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Twist of Fate
  'prefix_twist_of_fate_1': {
    id: 1077,
      tradeId: 'explicit.stat_3936990754',
    description: 'Your Corrupted Rare Maps and any Map Crafting options applying to them are modified unpredictably when opened',
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_twist_of_fate_2': {
    id: 1078,
      tradeId: 'explicit.stat_812317919',
    description: 'Maps modified in this way have 1–3 additional random Map Modifiers',
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Twisted Wish
  'prefix_twisted_wish_fixed_1': {
    id: 1079,
      tradeId: 'explicit.stat_1901628087',
    description: 'Ultimatum Modifiers in your Maps start a Tier higher if possible',
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_twisted_wish_fixed_2': {
    id: 1080,
      tradeId: 'explicit.stat_1602736646',
    description: 'Ultimatum Encounters in your Maps get 3% reduced Radius each Round',
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_twisted_wish_variable_1': {
    id: 1081,
      tradeId: 'explicit.stat_3093967539',
    description: 'Ultimatum Rewards in your Maps have (-95–80)% increased chance to be Abyssal Items',
    range: [-95, -80],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_twisted_wish_variable_2': {
    id: 1082,
      tradeId: 'explicit.stat_1763481236',
    description: 'Ultimatum Rewards in your Maps have (-95–80)% increased chance to be Blight Oils',
    range: [-95, -80],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_twisted_wish_variable_3': {
    id: 1083,
      tradeId: 'explicit.stat_502838809',
    description: 'Ultimatum Rewards in your Maps have (-95–80)% increased chance to be Breach Items',
    range: [-95, -80],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_twisted_wish_variable_4': {
    id: 1084,
      tradeId: 'explicit.stat_4234425443',
    description: 'Ultimatum Rewards in your Maps have (-95–80)% increased chance to be Catalysts',
    range: [-95, -80],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_twisted_wish_variable_5': {
    id: 1085,
      tradeId: 'explicit.stat_1528872781',
    description: 'Ultimatum Rewards in your Maps have (-95–80)% increased chance to be Corrupted Rare Items',
    range: [-95, -80],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_twisted_wish_variable_6': {
    id: 1086,
      tradeId: 'explicit.stat_1656757869',
    description: 'Ultimatum Rewards in your Maps have (-95–80)% increased chance to be Currency Items',
    range: [-95, -80],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_twisted_wish_variable_7': {
    id: 1087,
      tradeId: 'explicit.stat_3324186704',
    description: 'Ultimatum Rewards in your Maps have (-95–80)% increased chance to be Delirium Items',
    range: [-95, -80],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_twisted_wish_variable_8': {
    id: 1088,
      tradeId: 'explicit.stat_297961897',
    description: 'Ultimatum Rewards in your Maps have (-95–80)% increased chance to be Divination Cards',
    range: [-95, -80],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_twisted_wish_variable_9': {
    id: 1089,
      tradeId: 'explicit.stat_3860246335',
    description: 'Ultimatum Rewards in your Maps have (-95–80)% increased chance to be Essences',
    range: [-95, -80],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_twisted_wish_variable_10': {
    id: 1090,
      tradeId: 'explicit.stat_469837536',
    description: 'Ultimatum Rewards in your Maps have (-95–80)% increased chance to be Fossils',
    range: [-95, -80],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_twisted_wish_variable_11': {
    id: 1091,
      tradeId: 'explicit.stat_3116664709',
    description: 'Ultimatum Rewards in your Maps have (-95–80)% increased chance to be Map Fragments',
    range: [-95, -80],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_twisted_wish_variable_12': {
    id: 1092,
      tradeId: 'explicit.stat_2091246228',
    description: 'Ultimatum Rewards in your Maps have (-95–80)% increased chance to be Gems',
    range: [-95, -80],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_twisted_wish_variable_13': {
    id: 1093,
      tradeId: 'explicit.stat_1322064377',
    description: 'Ultimatum Rewards in your Maps have (-95–80)% increased chance to be Heist Items',
    range: [-95, -80],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_twisted_wish_variable_14': {
    id: 1094,
      tradeId: 'explicit.stat_294140055',
    description: 'Ultimatum Rewards in your Maps have (-95–80)% increased chance to be Inscribed Ultimatums',
    range: [-95, -80],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_twisted_wish_variable_15': {
    id: 1095,
      tradeId: 'explicit.stat_3962675867',
    description: 'Ultimatum Rewards in your Maps have (-95–80)% increased chance to be Legion Items',
    range: [-95, -80],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_twisted_wish_variable_16': {
    id: 1096,
      tradeId: 'explicit.stat_3261121444',
    description: 'Ultimatum Rewards in your Maps have (-95–80)% increased chance to be Maps',
    range: [-95, -80],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_twisted_wish_variable_17': {
    id: 1097,
      tradeId: 'explicit.stat_1280423224',
    description: 'Ultimatum Rewards in your Maps have (-95–80)% increased chance to be Unique Items',
    range: [-95, -80],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Unending Nightmare
  'prefix_unending_nightmare_1': {
    id: 1098,
      tradeId: 'explicit.stat_4222365107',
    description: 'Delirium Fog in your Maps never dissipates',
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_unending_nightmare_2': {
    id: 1099,
      tradeId: 'explicit.stat_4222365107',
    description: 'Delirium in your Maps has doubled difficulty scaling with distance from the mirror',
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_unending_nightmare_3': {
    id: 1100,
      tradeId: 'explicit.stat_4222365107',
    description: 'Simulacrum Splinters cannot be found in your Maps',
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_unending_nightmare_4': {
    id: 1101,
      tradeId: 'explicit.stat_4222365107',
    description: 'Delirium Orbs cannot be found in your Maps',
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Well Supplied
  'prefix_well_supplied_1': {
    id: 1102,
      tradeId: 'explicit.stat_1682417271',
    description: '(30–50)% increased Intelligence gained from Immortal Syndicate targets encountered in your Maps',
    range: [30, 50],
    contentType: ContentType.BETRAYAL,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_well_supplied_2': {
    id: 1103,
      tradeId: 'explicit.stat_623132242',
    description: 'Syndicate Members Obtain an additional Equipment Item when appearing in your Maps',
    contentType: ContentType.BETRAYAL,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_well_supplied_3': {
    id: 1104,
      tradeId: 'explicit.stat_1856204587',
    description: 'Immortal Syndicate Leaders in your Maps drop an additional Veiled Item',
    contentType: ContentType.BETRAYAL,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Wellspring of Creation
  'prefix_wellspring_of_creation_2': {
    id: 1105,
      tradeId: 'explicit.stat_2937898686',
    description: 'Monsters in your Maps deal (30–25)% less Damage',
    range: [25, 30],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_wellspring_of_creation_1': {
    id: 1106,
      tradeId: 'explicit.stat_2804300445',
    description: 'Monsters in your Maps have (40–50)% more Life',
    range: [40, 50],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  
  // Wrath of the Cosmos
  'prefix_wrath_of_the_cosmos_1': {
    id: 1107,
      tradeId: 'explicit.stat_1804970439',
    description: 'Eldritch Altars Influenced by The Searing Exarch which have an additional Upside have (80–100)% increased Effect of Downsides',
    range: [80, 100],
    contentType: ContentType.SEARING_EXARCH,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_wrath_of_the_cosmos_2': {
    id: 1108,
      tradeId: 'explicit.stat_2348590020',
    description: 'Eldritch Altars Influenced by The Searing Exarch have (50–60)% chance to have an additional Upside',
    range: [50, 60],
    contentType: ContentType.SEARING_EXARCH,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'refiners_bargain_1': {
    id: 1109,
    tradeId: 'explicit.stat_1813488582',
    description: 'Equipment Items with Rarity dropped by Possessed Monsters in your Maps have 5% chance to be converted to Thaumaturgic Dust',
    range: [5, 5],
    contentType: ContentType.SETTLERS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'refiners_bargain_2': {
    id: 1110,
    tradeId: 'explicit.stat_2604629394',
    description: 'Sulphite found in your Maps is granted as a random Ore instead at 15% of the value',
    range: [15, 15],
    contentType: ContentType.SETTLERS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'refiners_bargain_3': {
    id: 1111,
    tradeId: 'explicit.stat_2175879462',
    description: 'Lifeforce found in your Maps is granted as a random Crop instead at 150% of the value',
    range: [150, 150],
    contentType: ContentType.SETTLERS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
};


const buildModDatabase = (): ModDatabase => {
    const db: ModDatabase = {
      mods: {},
      byContentType: {} as Record<ContentType, number[]>,
      byIdolSize: {} as Record<IdolSize, {
        prefixes: number[],
        suffixes: number[]
      }>
    };
  
    // Initialize empty arrays for each contentType
    Object.values(ContentType).forEach(contentType => {
      db.byContentType[contentType] = [];
    });
  
    // Initialize empty arrays for each idol type
    Object.values(IdolSize).forEach(idolSize => {
      db.byIdolSize[idolSize] = {
        prefixes: [],
        suffixes: []
      };
    });
  
    // Process prefixes
    Object.values(mods).forEach(mod => {
      // Add to main collection
      db.mods[mod.id] = mod;
      
      // Add to contentType index
      db.byContentType[mod.contentType].push(mod.id);
      
      // Add to idol size indexes
      mod.idolSizes.forEach(idolSize => {
        if (mod.type === 'prefix') {
          db.byIdolSize[idolSize].prefixes.push(mod.id);
        } else {
          db.byIdolSize[idolSize].suffixes.push(mod.id);
        }
      });
    });
    
    return db;
  };
  
  // Export the full database
  export const modDatabase = buildModDatabase();
  
  // Utility function to get mods for a specific idol type
  export const getModsForIdolSize = (idolSize: IdolSize, type?: 'prefixes' | 'suffixes'): Mod[] => {
    // Check if type is provided and return the corresponding mods
    const modIds = type ? modDatabase.byIdolSize[idolSize][type] : 
                          [...modDatabase.byIdolSize[idolSize].prefixes, ...modDatabase.byIdolSize[idolSize].suffixes];
    return modIds
      .map(id => modDatabase.mods[id]);
  };
  
  // Utility function to get mods by contentType
  export const getModsByContentType = (contentType: ContentType, type?: 'prefix' | 'suffix'): (Mod)[] => {
    const modIds = type ? modDatabase.byContentType[contentType].filter(id => modDatabase.mods[id].type === type) : 
                          modDatabase.byContentType[contentType] || [];
    return modIds
      .map(id => modDatabase.mods[id]);
  };
  
  // Format the description with actual values instead of ranges
  export const formatModDescription = (mod: Mod, value: number): string => {
    return mod.description.replace(/(\+?\()(\d+(?:\.\d+)?)–(\d+(?:\.\d+)?)(\)%)/g, (prefix) => {
      // Keep the + if it exists in the prefix
      const plusSign = prefix.includes('+') ? '+' : '';
      return `${plusSign}${value}%`;
    });
  };